import Vue from 'vue';

function styleInject(css, ref) {
  if ( ref === void 0 ) { ref = {}; }
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".jsgrid{position:relative;overflow:hidden;font-size:1em}.jsgrid,.jsgrid *,.jsgrid :after,.jsgrid :before{-webkit-box-sizing:border-box;box-sizing:border-box}.jsgrid input,.jsgrid select,.jsgrid textarea{font-size:1em}.jsgrid-grid-header{overflow-x:hidden;overflow-y:scroll}.jsgrid-grid-body{overflow-x:auto;overflow-y:scroll;position:relative;-webkit-overflow-scrolling:touch}.jsgrid-table{width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0}.jsgrid-cell{padding:0}.jsgrid-text-overflow{max-width:0;overflow:hidden;text-overflow:clip;white-space:nowrap}.jsgrid-header-cell,.jsgrid-сell{-webkit-box-sizing:border-box;box-sizing:border-box;height:25px}.jsgrid-align-left{text-align:left}.jsgrid-align-center,.jsgrid-align-center input,.jsgrid-align-center select,.jsgrid-align-center textarea{text-align:center}.jsgrid-align-right,.jsgrid-align-right input,.jsgrid-align-right select,.jsgrid-align-right textarea{text-align:right}.jsgrid-header-cell{padding:.2em 0}.jsgrid-edit-row input,.jsgrid-edit-row select,.jsgrid-edit-row textarea,.jsgrid-filter-row input,.jsgrid-filter-row select,.jsgrid-filter-row textarea,.jsgrid-insert-row input,.jsgrid-insert-row select,.jsgrid-insert-row textarea{width:100%;padding:.3em .5em}.jsgrid-edit-row input[type=checkbox],.jsgrid-filter-row input[type=checkbox],.jsgrid-insert-row input[type=checkbox]{width:auto}.jsgrid-selecting-row .jsgrid-cell,.jsgrid-selection-row .jsgrid-cell{cursor:pointer}.jsgrid-nodata-row .jsgrid-cell{padding:0;text-align:center}.jsgrid-header-sort{cursor:pointer}.jsgrid-pager{padding:.5em 0;display:none}.jsgrid-pager-nav-button{padding:.2em .6em}.jsgrid-pager-nav-inactive-button{display:none;pointer-events:none}.jsgrid-pager-page{padding:.2em .6em}.jsgrid-pager a{cursor:pointer}.jsgrid-sortable{list-style-type:none;margin:0;padding:0;z-index:1;position:absolute;left:2px}.jsgrid-sortable li{margin:0;padding:0;float:left;font-size:1em;background:#fff}.ui-sortable-helper:hover{cursor:move}.ui-sortable-helper{display:table}.jsgrid-table-sortable{border-collapse:collapse;border-spacing:0;cursor:move}.fixed-list-container,.virtual-scroll-list-container{cursor:pointer;overflow:auto;position:relative;padding:0;font-size:12px}.fixed-list-container li,.virtual-scroll-list-container li{height:26px}.fixed-list-container li:hover,.virtual-scroll-list-container li:hover{background:#e4f2fe}.fixed-list-container .jsgrid-view-list-more,.virtual-scroll-list-container{height:19px}.virtual-scroll-list-container::-webkit-scrollbar-thumb{background-color:#b9d3f0}.virtual-scroll-list-container::-webkit-scrollbar-thumb:hover{background-color:#358cee}.virtual-scroll-list-container::-webkit-scrollbar{width:8px;height:8px;background-color:#fff}.jsgrid-grid-body::-webkit-scrollbar-thumb{background-color:#b9d3f0}.jsgrid-grid-body::-webkit-scrollbar-thumb:hover{background-color:#358cee}.jsgrid-grid-body::-webkit-scrollbar{width:10px;height:10px;background-color:#fff}.fixed-list-container li{list-style:none}.toggle-triangle-wrap{float:left;position:relative;height:18px;width:18px;white-space:nowrap;overflow:hidden}.jsgrid-fixed-list-container{position:absolute;width:100%;height:100%;border:1px solid #0c88f8;background:#fff}.jsgrid-tooltip-title{color:#0098de}.jsgrid-tooltip-splitter{border-top:1px solid #e6e9f1;border-bottom:0;margin:5px 0}";
styleInject(css);

var css$2 = ".jsgrid-edit-row>.jsgrid-cell,.jsgrid-filter-row>.jsgrid-cell,.jsgrid-grid-body,.jsgrid-grid-header,.jsgrid-header-row>.jsgrid-header-cell,.jsgrid-insert-row>.jsgrid-cell{border:1px solid #bbc6db}.jsgrid-header-row>.jsgrid-header-cell{border-top:0}.jsgrid-filter-row>.jsgrid-cell,.jsgrid-header-row>.jsgrid-header-cell,.jsgrid-insert-row>.jsgrid-cell{border-bottom:0}.jsgrid-merge-header{border-bottom:1px solid #c4d9f1!important}.jsgrid-filter-row>.jsgrid-cell:first-child,.jsgrid-header-row>.jsgrid-header-cell:first-child,.jsgrid-insert-row>.jsgrid-cell:first-child{border-left:none}.jsgrid-header-row .jsgrid-align-left,.jsgrid-header-row .jsgrid-align-right{text-align:center}.jsgrid-grid-header{background:#f9f9f9}.jsgrid-header-scrollbar{scrollbar-arrow-color:#f1f1f1;scrollbar-base-color:#f1f1f1;scrollbar-3dlight-color:#f1f1f1;scrollbar-highlight-color:#f1f1f1;scrollbar-track-color:#f1f1f1;scrollbar-shadow-color:#f1f1f1;scrollbar-dark-shadow-color:#f1f1f1}.jsgrid-header-scrollbar::-webkit-scrollbar{visibility:hidden;width:10px}.jsgrid-grid-body::-webkit-scrollbar-track,.jsgrid-header-scrollbar::-webkit-scrollbar-track{background-color:#f1f1f1}.jsgrid-header-sortable:hover{cursor:pointer;background:#fcfcfc}.jsgrid-header-row .jsgrid-header-sort{background:#c4e2ff}.jsgrid-header-sort:before{content:\" \";display:block;float:left;width:0;height:0;border-style:solid}.jsgrid-header-sort-asc:before{border-width:0 5px 5px;border-color:transparent transparent #009a67}.jsgrid-header-sort-desc:before{border-width:5px 5px 0;border-color:#009a67 transparent transparent}.jsgrid-grid-body{border-top:none}.jsgrid-cell{border:1px solid #d6d8dd}.jsgrid-grid-body .jsgrid-alt-row:first-child .jsgrid-cell,.jsgrid-grid-body .jsgrid-row:first-child .jsgrid-cell,.jsgrid-grid-body .jsgrid-table tr:first-child .jsgrid-group-cell{border-top:none}.jsgrid-grid-body .jsgrid-cell:first-child{border-left:none}.jsgrid-row:nth-child(2n)>.jsgrid-cell{background:#fff}.jsgrid-row:nth-child(odd)>.jsgrid-cell{background:#fcfcfc}.jsgrid-header-row>.jsgrid-header-cell{background:#f9f9f9}.jsgrid-filter-row>.jsgrid-cell{background:#fcfcfc}.jsgrid-insert-row>.jsgrid-cell{background:#e3ffe5}.jsgrid-edit-row>.jsgrid-cell{background:#fdffe3}.jsgrid-selecting-row>.jsgrid-cell{background:#c4e2ff;border-color:#c4e2ff}.jsgrid-nodata-row>.jsgrid-cell{background:#fff}.jsgrid-group-cell{background:#e5e8f1}.jsgrid-invalid input,.jsgrid-invalid select,.jsgrid-invalid textarea{background:#ffe3e5;border:1px solid #ff808a}.jsgrid-pager-current-page{font-weight:700}.jsgrid-pager-nav-inactive-button a{color:#d3d3d3}.jsgrid-button+.jsgrid-button{margin-left:5px}.jsgrid-button:hover{opacity:.5;-webkit-transition:opacity .2s linear;transition:opacity .2s linear}.jsgrid .jsgrid-button{width:16px;height:16px;border:none;cursor:pointer;background-image:url(data:image/png;base64,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);background-repeat:no-repeat;background-color:transparent}@media only screen and (-webkit-min-device-pixel-ratio:2), only screen and (min-device-pixel-ratio:2){.jsgrid .jsgrid-button{background-image:url(data:image/png;base64,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);background-size:24px 352px}}.jsgrid .jsgrid-mode-button{width:24px;height:24px}.jsgrid-mode-on-button{opacity:.5}.jsgrid-cancel-edit-button{background-position:0 0;width:16px;height:16px}.jsgrid-clear-filter-button{background-position:0 -40px;width:16px;height:16px}.jsgrid-delete-button{background-position:0 -80px;width:16px;height:16px}.jsgrid-edit-button{background-position:0 -120px;width:16px;height:16px}.jsgrid-insert-mode-button{background-position:0 -160px;width:24px;height:24px}.jsgrid-insert-button{background-position:0 -208px;width:16px;height:16px}.jsgrid-search-mode-button{background-position:0 -248px;width:24px;height:24px}.jsgrid-search-button{background-position:0 -296px;width:16px;height:16px}.jsgrid-update-button{background-position:0 -336px;width:16px;height:16px}.jsgrid-load-shader{background:#ddd;opacity:.5;filter:alpha(opacity=50)}.jsgrid-load-panel{width:15em;height:5em;background:#fff;border:1px solid #bbc6db;padding-top:3em;text-align:center}.jsgrid-load-panel:before{content:\" \";position:absolute;top:.5em;left:50%;margin-left:-1em;width:2em;height:2em;border:2px solid #009a67;border-right-color:transparent;border-radius:50%;-webkit-animation:indicator 1s linear infinite;animation:indicator 1s linear infinite}@-webkit-keyframes indicator{0%{-webkit-transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg)}to{-webkit-transform:rotate(1turn)}}@keyframes indicator{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.jsgrid-load-panel{padding-top:1.5em\\9}.jsgrid-load-panel:before{display:none\\9}.jsgrid-fields-resizer{table-layout:fixed}.jsgrid-fields-resizer>tbody>tr>td,.jsgrid-fields-resizer>tbody>tr>th{overflow:hidden}.jsgrid-handler-group{height:0;position:relative}.jsgrid-handler-grip{margin-left:-1px;position:absolute;z-index:5}.jsgrid-handler-grip .jsgrid-fields-resizer{position:absolute;filter:alpha(opacity=1);opacity:0;width:5px;height:100%;cursor:col-resize;top:0;left:-2px}.jsgrid-handler-lastGroup{position:absolute;width:1px}.jsgrid-handler-dragging{border-left:1px dotted #000}.jsgrid-table-flex{width:auto!important}.jsgrid-handler-grip.jsgrid-disabled-grip .jsgrid-fields-resizer{cursor:default;display:none}.jsgrid-list-more{color:#3364ff;font-weight:700;cursor:pointer}.jsgrid-text-btn{color:#33beff;font-weight:inherit}.ui-sortable-helper{opacity:.7;filter:alpha(opacity=70)}.ui-sortable-placeholder{-webkit-box-shadow:4px 5px 4px #c6c6c6 inset;box-shadow:inset 4px 5px 4px #c6c6c6;border:0 dashed #3364ff;visibility:visible!important;background:#efefef!important}";
styleInject(css$2);

var ko = {
  grid: {
    i18n_enabled: '활성',
    i18n_disabled: '비활성',
    i18n_all: '모두 보기'
  }
};

var en = {
  grid: {
    i18n_enabled: 'Enabled',
    i18n_disabled: 'Disabled',
    i18n_all: 'All View'
  }
};

var ja = {
  grid: {
    i18n_enabled: 'Enabled-',
    i18n_disabled: 'Disabled-',
    i18n_all: 'All-'
  }
};

/*
 * jsGrid v1.5.3 (http://js-grid.com)
 * (c) 2016 Artem Tabalin
 * Licensed under MIT (https://github.com/tabalinas/jsgrid/blob/master/LICENSE)
 */

// locales
// edge browser에서 동작되도록 event.path 확장
if (!('path' in Event.prototype)) {
  Object.defineProperty(Event.prototype, 'path', {
    get: function () {
      var path = [];
      var currentElem = this.target;
      while (currentElem) {
        path.push(currentElem);
        currentElem = currentElem.parentElement;
      }

      if (path.indexOf(window) === -1 && path.indexOf(document) === -1) {
        path.push(document);
      }

      if (path.indexOf(window) === -1) {
        path.push(window);
      }

      return path
    }
  });
}

(function (window, $, undef) {
  var JSGRID = 'JSGrid',
    JSGRID_DATA_KEY = JSGRID,
    JSGRID_ROW_DATA_KEY = 'JSGridItem',
    JSGRID_EDIT_ROW_DATA_KEY = 'JSGridEditRow',
    JSGRID_FIELDS_DATA_KEY = 'JSField',
    SORT_ORDER_ASC = 'asc',
    SORT_ORDER_DESC = 'desc',
    CELL_TEXT_OVERFLOW_CALSS = 'jsgrid-text-overflow',
    ID_INDEX = 0;

  var BODY_ONSELECTSTART_SAVE = $(document.body).attr('onselectstart'),
    BODY_UNSELECTABLE_SAVE = $(document.body).attr('unselectable');

  var getOrApply = function (value, context) {
    if ($.isFunction(value)) {
      return value.apply(context, $.makeArray(arguments).slice(2))
    }
    return value
  };

  var normalizePromise = function (promise) {
    var d = $.Deferred();

    if (promise && promise.then) {
      promise.then(function () {
        d.resolve.apply(d, arguments);
      }, function () {
        d.reject.apply(d, arguments);
      });
    } else {
      d.resolve(promise);
    }

    return d.promise()
  };

  var defaultController = {
    loadData: $.noop,
    updateItem: $.noop,
    rowExpand: $.noop
  };

  function Grid (element, config) {
    var $element = $(element);

    $element.data(JSGRID_DATA_KEY, this);

    this._container = $element;

    this.data = [];
    this.fields = [];
    this.visiblefields = [];
    this.sortState = false;
    this.getRowSelectionItem = [];
    this.defaultTreeView = {
      use: false,
      targetColumn: null,
      expandAll: false,
      iconClass: 'ui-icon',
      openPosClass: 'ui-icon-triangle-1-s',
      closePosClass: 'ui-icon-triangle-1-e'
    };
    this._fieldSortable = null;
    this._resizableFields = null;
    this._virtualScroll = null;
    this._sortField = null;
    this._sortOrder = SORT_ORDER_ASC;
    this._firstDisplayingPage = 1;
    this.closedData = [];

    this._init(config);
    this.render();

    if (this.visibleHeader) {
      var orgBodyHeight = parseInt($(this._body).css('height'));

      $(this._body).css('height', orgBodyHeight + 23 + 'px');
      $(this._body).css('border-top', '1px solid #c4d8f1');

      $(this._header).css('visibility', 'collapse');
    }
  }

  Grid.prototype = {
    width: 'auto',
    height: 'auto',
    minHeight: 0,
    windowSize: false,
    resizeHeight: null,
    updateOnResize: true,
    rowClass: $.noop,
    rowRenderer: null,
    rowClick: function (args) {
      if (this.editing) {
        this.editItem($(args.event.target).closest('tr'));
      }
    },
    cellClick: $.noop,
    rowClicked: $.noop,
    rowDoubleClick: $.noop,
    headerSortClick: $.noop, // TAMS
    heading: true,
    headerRowRenderer: null,
    complexRowRenderer: null,
    headerRowClass: 'jsgrid-header-row',
    headerCellClass: 'jsgrid-header-cell',
    selecting: true,
    selectingRowClass: 'jsgrid-selecting-row',
    rowSelection: true,
    selectionRowClass: 'jsgrid-selection-row',
    selectionCellClass: 'jsgrid-selection-cell',
    multiSelection: true,
    oddRowClass: 'jsgrid-row',
    evenRowClass: 'jsgrid-row',
    cellClass: 'jsgrid-cell',
    groupCellClass: 'jsgrid-group-cell',
    sorting: false,
    sortableClass: 'jsgrid-header-sortable',
    sortAscClass: 'jsgrid-header-sort jsgrid-header-sort-asc',
    sortDescClass: 'jsgrid-header-sort jsgrid-header-sort-desc',
    sortClickedClass: 'jsgrid-header-sortable-clicked',
    paging: false,
    pagerContainer: null,
    pageIndex: 1,
    pageSize: 20,
    pageButtonCount: 15,
    pagerFormat: 'Pages: {first} {prev} {pages} {next} {last} &nbsp;&nbsp; {pageIndex} of {pageCount}',
    pagePrevText: 'Prev',
    pageNextText: 'Next',
    pageFirstText: 'First',
    pageLastText: 'Last',
    pageNavigatorNextText: '...',
    pageNavigatorPrevText: '...',
    pagerContainerClass: 'jsgrid-pager-container',
    pagerClass: 'jsgrid-pager',
    pagerNavButtonClass: 'jsgrid-pager-nav-button',
    pagerNavButtonInactiveClass: 'jsgrid-pager-nav-inactive-button',
    pageClass: 'jsgrid-pager-page',
    currentPageClass: 'jsgrid-pager-current-page',
    customLoading: false,
    pageLoading: false,
    autoload: false,
    controller: defaultController,
    loadIndication: true,
    loadIndicationDelay: 500,
    virtualScrolling: false,
    pageVirtualScrolling: false,
    invalidMessage: 'Invalid data entered!',
    authDisable: false,
    autoRender: true,
    invalidNotify: function (args) {
      var messages = $.map(args.errors, function (error) {
        return error.message || null
      });

      window.alert([this.invalidMessage].concat(messages).join('\n'));
    },
    resizableFields: {
      use: true
    },
    fieldSortable: false,
    rowSortable: false,
    objectView: false,
    onInit: $.noop,
    onRefreshing: $.noop,
    onRefreshed: $.noop,
    onPageChanged: $.noop,
    onItemDeleting: $.noop,
    onItemDeleted: $.noop,
    onItemInserting: $.noop,
    onItemInserted: $.noop,
    onItemEditing: $.noop,
    onItemUpdating: $.noop,
    onItemUpdated: $.noop,
    onItemInvalid: $.noop,
    onDataLoading: $.noop, // TAMS
    onDataLoaded: $.noop, // TAMS
    onOptionChanging: $.noop,
    onOptionChanged: $.noop,
    onError: $.noop,
    rowSortableStop: $.noop,
    firewallGroupEvent: $.noop,
    groupExpandCallBack: $.noop,
    firewallGroupButton: true,
    invalidClass: 'jsgrid-invalid',
    containerClass: 'jsgrid',
    tableClass: 'jsgrid-table',
    gridHeaderClass: 'jsgrid-grid-header',
    gridBodyClass: 'jsgrid-grid-body',
    grouping: false,
    firewall: false,
    nat: false,
    rowSortableHandler: null,
    treeLazeLoading: false,
    storageKey: void 0,
    treeRowId: 0,
    cellIconBtn: null,
    blueMaxGroupKey: null,
    tableId: '',
    loadingPopUp: void 0,
    resizeMode: void 0,
    vsRefreshHeight: false,

    // TAMS
    _rowIndexCnt: 0, // Row 카운트

    selectRow: function (idx, fieldName) {
      var
        targetRow = this._content.find('tr[data-rowindex=' + idx + ']'),
        targetCell = targetRow.find('td[field-name="' + fieldName + '"]');

      if (targetRow) {
        targetRow.trigger('click');
      }

      if (targetCell) {
        targetCell.addClass(this.selectionCellClass);
      }

      if (this.data[idx]) {
        this._setRowSelectionItem([this.data[idx]]);
      }
    },

    multiSelectRow: function (idxList) {
      var self = this;

      $.each(idxList, function (i, v) {
        var targetRow = self._content.find('tr[data-rowindex=' + v + ']');

        if (targetRow) {
          targetRow.addClass(self.selectionRowClass);
        }
      });
    },

    unSelectRow: function () {
      $(this._content).find('tr').removeClass(this.selectionRowClass);
      $(this._content).find('td').removeClass(this.selectionCellClass);
    },

    _init: function (config) {
      $.extend(this, config);

      this._initLoadStrategy();
      this._initController();
      this._initFields();
      // this._attachWindowLoadResize()
      // this._attachWindowResizeCallback()
      this._callEventHandler(this.onInit);
      this._initTreeViewOpts();

      // blueMax 전용
      if (this.firewall) {
        this.blueMaxGroupKey = 'fw_grp_id';
      }

      if (this.nat) {
        this.blueMaxGroupKey = 'nat_grp_id';
      }
    },

    _initTreeViewOpts: function () {
      $.extend(true, this.defaultTreeView, this.treeView);

      this.treeView = this.defaultTreeView;
      // this.treeView.targetColumn = this.treeView.targetColumn || this.fields[0].name
      // TAMS, vue compoennt destroy 될 때, 에러 발생 (대시보드 위젯)
      this.treeView.targetColumn = this.treeView.targetColumn || void 0;

      if (this.treeView.treeLazeLoading) {
        this.treeView.expandAll = false;
      }

      var rootData = _.filter(this.data, {level: 0});
      var self = this;

      _.forEach(rootData, function (root) {
        if (self.treeView.expandAll) {
          root.tree_open = true;
        } else {
          root.tree_open = false;
        }
      });
    },

    loadStrategy: function () {
      var loadStrategys = null;

      if (this.virtualScrolling) {
        loadStrategys = new jsGrid.loadStrategies.VirtualScrollStrategy(this);
      } else if (this.pageVirtualScrolling) {
        loadStrategys = new jsGrid.loadStrategies.PageVirtualScrolling(this);
      } else {
        loadStrategys = this.pageLoading
          ? new jsGrid.loadStrategies.PageLoadingStrategy(this)
          : new jsGrid.loadStrategies.DirectLoadingStrategy(this);
      }

      return loadStrategys
    },

    _initLoadStrategy: function () {
      this._loadStrategy = getOrApply(this.loadStrategy, this);
    },

    _initController: function () {
      this._controller = $.extend({}, defaultController, getOrApply(this.controller, this));
    },

    renderTemplate: function (source, context, config) {
      var args = [];

      for (var key in config) {
        if (config.hasOwnProperty(key)) {
          args.push(config[key]);
        }
      }

      args.unshift(source, context);

      if (context) {
        if (context.sortNumber) {
          if (config) {
            if (config.hasOwnProperty('index')) {
              source = config.index;
            } else {
              source = getOrApply.apply(null, args);
            }
          }
        } else {
          source = getOrApply.apply(null, args);
        }
      } else {
        source = getOrApply.apply(null, args);
      }

      return (source === undefined || source === null) ? '' : source
    },

    _initFields: function () {
      var self = this;
      self.fields = $.map(self.fields, function (field) {
        if ($.isPlainObject(field)) {
          var FieldConstructor = (field.type && jsGrid.fields[field.type]) || jsGrid.Field;
          field = new FieldConstructor(field);
        }
        field._grid = self;

        // storage column
        if (self.storageKey && _.indexOf(_.keys(localStorage), self.storageKey) === 0) {
          var storageFieldKey = JSON.parse(localStorage.getItem(self.storageKey));

          _.each(storageFieldKey, function (key) {
            if (field.name === key.name) {
              field = _.assign(field, {
                visible: false
              });
            }
          });
        }

        return field
      });
      self.visiblefields = $.grep(self.fields, function (item, i) {
        return item.visible
      });
    },

    _attachWindowLoadResize: function () {
      $(window).on('load', $.proxy(this._refreshSize, this));
    },

    _attachWindowResizeCallback: function () {
      if (this.updateOnResize) {
        $(window).on('resize', $.proxy(this._refreshSize, this));
      }
    },

    _detachWindowResizeCallback: function () {
      $(window).off('resize', this._refreshSize);
      $(window).off('load', this._refreshSize);
    },

    option: function (key, value) {
      var optionChangingEventArgs,
        optionChangedEventArgs;

      if (arguments.length === 1) {
        return this[key]
      }

      optionChangingEventArgs = {
        option: key,
        oldValue: this[key],
        newValue: value
      };
      this._callEventHandler(this.onOptionChanging, optionChangingEventArgs);

      this._handleOptionChange(optionChangingEventArgs.option, optionChangingEventArgs.newValue);

      optionChangedEventArgs = {
        option: optionChangingEventArgs.option,
        value: optionChangingEventArgs.newValue
      };
      this._callEventHandler(this.onOptionChanged, optionChangedEventArgs);
    },

    fieldOption: function (field, key, value) {
      field = this._normalizeField(field);

      if (arguments.length === 2) {
        return field[key]
      }

      field[key] = value;
      this._renderGrid();
    },

    _handleOptionChange: function (name, value) {
      this[name] = value;

      switch (name) {
        case 'width':
        case 'height':
          this._refreshSize(value);
          break
        case 'vsRefreshHeight':
          this.vsRefreshHeight = value.refreshType;
          this._refreshSize(value.minSize);
          break
        case 'rowClass':
        case 'rowRenderer':
        case 'rowClick':
        case 'rowClicked':
        case 'rowDoubleClick':
        case 'selecting':
        case 'rowSelection':
        case 'multiSelection':
        case 'selectingRowClass':
        case 'oddRowClass':
        case 'evenRowClass':
          this._refreshContent();
          break
        case 'pageButtonCount':
        case 'pagerFormat':
        case 'pagePrevText':
        case 'pageNextText':
        case 'pageFirstText':
        case 'pageLastText':
        case 'pageNavigatorNextText':
        case 'pageNavigatorPrevText':
        case 'pagerClass':
        case 'pagerNavButtonClass':
        case 'pageClass':
        case 'currentPageClass':
        case 'pagerRenderer':
          this._refreshPager();
          break
        case 'fields':
          this._initFields();
          this.render();
          break
        case 'data':
        case 'paging':
          this.refresh(true, 'dataRefresh');
          // this._createRenderResizableFields() // sorting, 데이터 변경 시 중복 호출로 인한 제거
          break
        case 'loadStrategy':
        case 'pageLoading':
          this._initLoadStrategy();
          this.search();
          break
        case 'pageIndex':
          this.openPage(value);
          break
        case 'pageSize':
          this.refresh();
          this.search();
          break
        case 'updateOnResize':
          this._detachWindowResizeCallback();
          this._attachWindowResizeCallback();
          break
        case 'invalidNotify':
        case 'invalidMessage':
          break
        case 'redrawFieldSortable':
          this._redrawFieldSortable();
          break
        case 'destroyFieldSortable':
          this._destroyFieldSortable();
          break
        case 'createFieldSortable':
          this._initFieldSortable();
          break
        case 'treeExpandAll':
          this.treeExpandAll(value);
          break
        case 'groupExpandAll':
          this.groupExpandAll(value);
          break
        case 'refreshVirtualScroll':
          this.refreshVirtualScroll();
          break
        case 'changeFieldValue':
          this.setFieldValue(value);
          break
        case 'resizeOverflow':
          if (!this._resizableFields) { return }
          this._resizableFields._onResize();
          break
        default:
          this.render();
          break
      }
    },

    destroy: function () {
      BODY_ONSELECTSTART_SAVE = null;
      BODY_UNSELECTABLE_SAVE = null;
      //하위 인스턴스들을 초기화하기 위해 이벤트 dispatch.
      $(this).trigger('jsgrid.core.destroy');
      this._detachWindowResizeCallback();

      if (this._resizableFields) {
        this._resizableFields.destroy();
        delete this._resizableFields;
      }

      this._loadStrategy.destroy();

      if (this._virtualScroll || this.pageVirtualScrolling) {
        this._virtualScroll.destroy();
      }

      this._clear();
      this._container.removeData(JSGRID_DATA_KEY);

      this._container = null;
      this._loadStrategy = null;
      this._headerRow = null;
      this._headerColGroupRow = null;
      this._headerGrid = null;
      this._header = null;
      this._pagerContainer = null;
      this._content = null;
      this._body = null;
      this._bodyColGroupRow = null;
      this._bodyGrid = null;
      this.data = [];
      this.fields = [];
      this.visiblefields = [];
      this.sortState = false;
      this.getRowSelectionItem = [];
      this._resizableFields = null;
      this._virtualScroll = null;
      this._sortField = null;
      this.closedData = [];
      this._fieldSortable = null;
      var instance = $(this).data(JSGRID_DATA_KEY);
      instance = {};
      instance = null;
    },

    render: function () {
      this._renderGrid();

      // data 바인딩 형태가 controller의 loadData인지 data 인지 판단
      var controller = this.controller;

      if (controller['loadData'] === $.noop && this.autoRender) {
        this._createRenderResizableFields();
      }

      return this.autoload ? this.loadData() : $.Deferred().resolve().promise()
    },

    _createRenderResizableFields: function () {
      if (this.resizableFields.use) {
        getOrApply(this._renderResizableFields, this);
      }
    },

    _renderResizableFields: function () {
      var disabledResizeFields = $.map(this.fields, function (field) {
        if (!field.resizable) {
          return field.name
        }
      });

      this._resizableFields = new jsGrid.ResizableFields(this, disabledResizeFields);
    },

    _renderGrid: function () {
      this._clear();

      this._container
        .attr('id', 'jsgrid-' + (ID_INDEX++))
        .addClass(this.containerClass)
        .css('position', 'relative')
        .append(this._createHeader())
        .append(this._createBody());

      this._pagerContainer = this._createPagerContainer();

      if (this.virtualScrolling || this.pageVirtualScrolling) {
        this._virtualScroll = this._createVirtualScroll();
      }

      if (this.rowSortable && !this.authDisable) {
        var self = this;
        var sortableOpts = {
          containment: null,
          opacity: 1,
          revert: 200,
          distance: 0,
          cursor: 'move',
          axis: 'y',
          items: '> tr:not(tr:first[parent-group], tr[tams=true])',
          cancel: 'tr[tams=true]',
          helper: function (e, ui) {
            ui.children().each(function () {
              $(this).width($(this).width());
              $(this).height($(this).height());
            });

            return ui
          },
          start: function (e, ui) {
            ui.placeholder.height(ui.helper.outerHeight());
          },
          stop: function (e, ui) {
            var rowData = $(ui.item).data(JSGRID_ROW_DATA_KEY);
            var cell = ui.item.find('td');
            var pos = ui.position.top - ui.originalPosition.top > 0 ? 'down' : 'up';
            var itemIndex = ((self.pageIndex - 1) * self.pageSize) + ui.item.index();

            self._eachField(function (field) {
              $(cell).css('width', field.width);
            });

            self._resizableFields.refresh();
            self.rowSortableStop(rowData, Number($(ui.item).attr('row-local-seq')), itemIndex, e, ui, $(this), pos);
          }
        };

        // rowSortable Handler 지정
        if (this.rowSortableHandler !== null) {
          $.extend(sortableOpts, {
            handle: 'td[row-sortable-handler="true"]'
          });
        }

        this._content.sortable(sortableOpts);
      }

      if (this.objectView) {
        var objectViewOpts = {
          connectToSortable: '.ui-sortable',
          helper: 'clone',
          revert: 'invalid'
        };

        this._content.find('tr').draggable(objectViewOpts);
      }

      if (this.fieldSortable && !this._fieldSortable) {
        this._initFieldSortable();
      }
      this.refresh();
    },

    _clear: function () {
      this._pagerContainer && this._pagerContainer.empty();

      this._container.empty()
        .css({position: '', width: '', height: ''});

      this.getRowSelectionItem = [];
    },

    _createHeader: function () {
      var $headerBody = $('<tbody>');
      var $headerRow = this._headerRow = this._createHeaderRow(),
        $headerColGroupRow = this._headerColGroupRow = this._createColGroupRow();

      $headerBody.append($headerRow);

      var $headerGrid = this._headerGrid = $('<table>').addClass(this.tableClass)
        .append($headerColGroupRow)
        .append($headerBody);

      var $header = this._header = $('<div>').addClass(this.gridHeaderClass)
        .addClass(this._scrollBarWidth() ? 'jsgrid-header-scrollbar' : '')
        .append($headerGrid);

      return $header
    },

    _createColGroupRow: function () {
      var $result = $('<colgroup>');

      this._eachField(function (field) {
        $('<col>').css('width', field.width).appendTo($result);
      });

      return $result
    },

    _createBody: function () {
      var $content = this._content = $('<tbody>'),
        $bodyColGroupRow = this._bodyColGroupRow = this._createColGroupRow();

      var $bodyGrid = this._bodyGrid = $('<table>').addClass(this.tableClass)
        .append($bodyColGroupRow)
        .append($content);

      var $body = this._body = $('<div>').addClass(this.gridBodyClass)
        .append($bodyGrid)
        .on('scroll', $.proxy(function (e) {
          this._header.scrollLeft(e.target.scrollLeft);
        }, this))
        .on('DOMMouseScroll mousewheel', function (e) {
          e.stopPropagation();
        });

      return $body
    },

    _createVirtualScroll: function () {
      return getOrApply(this.virtualScroll, this)
    },

    virtualScroll: function () {
      return new jsGrid.VirtualScroll(this)
    },

    _createPagerContainer: function () {
      var pagerContainer = this.pagerContainer || $('<div>').appendTo(this._container);
      return $(pagerContainer).addClass(this.pagerContainerClass)
    },

    _eachField: function (callBack) {
      var self = this;
      $.each(this.fields, function (index, field) {
        if (field.visible) {
          callBack.call(self, field, index);
        }
      });
    },

    _createHeaderRow: function () {
      var self = this;

      //mutiheader options
      if ($.isFunction(this.complexRowRenderer)) {
        return $(this.renderTemplate(this.complexRowRenderer, this))
      }

      if ($.isFunction(this.headerRowRenderer)) {
        return $(this.renderTemplate(this.headerRowRenderer, this))
      }

      var $result = $('<tr>').addClass(this.headerRowClass);

      this._eachField(function (field, index) {
        var $th = this._prepareCell('<th>', field, 'headercss', this.headerCellClass)
          .addClass(CELL_TEXT_OVERFLOW_CALSS)
          .data(JSGRID_FIELDS_DATA_KEY, field)
          .appendTo($result);

        if (field.headerType) {
          var el;

          if (field.headerType === 'checkbox') {
            el = $('<input>')
              .attr('type', 'checkbox')
              .attr('name', field.name)
              .attr('headertype', field.headerType)
              .on('click.headercheck')
              .on('click.headercheck', function (e) {
                var checked = $(this).prop('checked');
                var rowCheckEl = self._content.find('input[type="checkbox"][name="' + field.name + '"]');

                rowCheckEl.prop({
                  checked: checked
                });

                e.stopPropagation();
              });
          }

          $th.append(field.title).append(el);
        } else {
          if (field.hasOwnProperty('header')) {
            if (field.header.type === 'toggle') {
              $th.append($('<div>').attr('vue-quasar-template', 'headerToggle-' + field.name));
            }
          }

          var args = {item: this.data, name: field.name};
          $th.append(this.renderTemplate(field.headerTemplate, field, args));
        }

        if (this.sorting && field.sorting && !this.grouping) {
          $th.addClass(this.sortableClass)
            .off('click.headersort')
            .on('click.headersort', $.proxy(function (evt) {
              if ($th.hasClass('jsgrid-header-sortable-clicked')) {
                evt.stopPropagation();
              } else {
                $th.addClass('jsgrid-header-sortable-clicked');
                setTimeout(function () {
                  $th.removeClass('jsgrid-header-sortable-clicked');
                }, 1000);
                this.sort($th.index());
                // TAMS
                this.headerSortClick({
                  field: this._sortField,
                  order: this._sortOrder
                });
              }
            }, this));
        }
      });

      return $result
    },

    _prepareCell: function (cell, field, cssprop, cellClass) {
      return $(cell).css('width', field.width)
        .addClass(cellClass || this.cellClass)
        .addClass((cssprop && field[cssprop]) || field.css)
        .addClass(field.align !== '' ? ('jsgrid-align-' + field.align) : 'jsgrid-align-center')
    },

    _callEventHandler: function (handler, eventParams) {
      handler.call(this, $.extend(eventParams, {
        grid: this
      }));

      return eventParams
    },

    reset: function () {
      this._resetSorting();
      this._resetPager();
      return this._loadStrategy.reset()
    },

    _resetPager: function () {
      this._firstDisplayingPage = 1;
      this._setPage(1);
    },

    _resetSorting: function () {
      this._sortField = null;
      this._sortOrder = SORT_ORDER_ASC;
      this._clearSortingCss();
      this.sortState = false;
    },

    refresh: function (isExpandAll, refreshType) {
      if ( isExpandAll === void 0 ) isExpandAll = true;

      //data watch 시 정렬된 상태로 변경
      this._sortData();

      if (this.sortState) {
        this._setSortingCss();
      }

      if (this.pageVirtualScrolling && refreshType) {
        if (this.pageIndex < this._pagesCount()) {
          this._setPage(this._pagesCount());
        }
      }

      this._callEventHandler(this.onRefreshing);

      this._refreshHeading();

      if (this.virtualScrolling || this.pageVirtualScrolling) {
        this._virtualScroll._initVirtualScroll(refreshType);
      } else {
        this._refreshContent(isExpandAll);
      }

      // this._refreshPager()
      this._refreshSize();

      this._callEventHandler(this.onRefreshed);

      if (this._resizableFields && this.resizableFields.use) {
        this._resizableFields.refresh();
      }

      if (this.fieldSortable && !this._fieldSortable) {
        this._redrawFieldSortable();
      }
    },

    scrollTo: function (scrollY) {
      if (!Number.isInteger(scrollY)) { return }
      this._body.scrollTop(scrollY);
    },

    scrollToBottom: function () {
      if (!this.virtualScrolling) {
        if (this.pageIndex < this._pagesCount()) {
          this._setPage(this._pagesCount());
          this._loadStrategy.openPage(this._pagesCount());
        }

        if (this.pageVirtualScrolling) {
          this._body.scrollTop(this._virtualScroll.scrollSector.height());
        } else {
          this._body.scrollTop(this._bodyGrid.height());
        }
      }
    },

    // 페이지 이동 시 scroll 최상위
    pageScrollToTop: function () {
      this._body.scrollTop(0);
    },

    // TAMS, 새로 고침 시, scroll 초기화
    refreshScrollToLeft: function () {
      this._body.scrollLeft(0);
    },

    _initFieldSortable: function () {
      var headerGrid = this._headerGrid;
      var fieldSortable = this._fieldSortable = {
        originTable: {
          table: headerGrid,
          startIndex: 0,
          endIndex: 0
        },
        sortableTable: {
          table: null,
          movingRow: null
        }
      };

      fieldSortable.originTable.table.find('th')
        .off('mousedown.fieldSortable')
        .on('mousedown.fieldSortable', $.proxy(function (evt) {
          if (evt.which !== 1) {
            return
          }

          clearTimeout(fieldSortable.downTimer);
          fieldSortable.downTimer = setTimeout($.proxy(function () {
            this._disableTextSelection();
            this._createFieldSortable(evt);
          }, this), 150);
        }, this))
        .off('mouseup.fieldSortable')
        .on('mouseup.fieldSortable', function () {
          clearTimeout(fieldSortable.downTimer);
        });
    },

    _createFieldSortable: function (e) {
      !e.cancelBubble && (e.cancelBubble = true);

      var fieldSortable = this._fieldSortable,
        sortableTable = fieldSortable.sortableTable;
      var headerGridRow = fieldSortable.originTable.table.find('tr');
      // var tableAttrs = $.makeArray(fieldSortable.originTable.table[0].attributes)
      // var tableAttrsStr = ''
      var rowAttrsArr = [],
        rowHeightArr = [],
        cellWidthArr = [];

      /* $.each(tableAttrs, function (idx, value) {
       if (value.nodeValue && value.nodeName !== 'id' && value.nodeName !== 'width') {
       tableAttrsStr += value.nodeName + '="' + value.nodeValue + '" '
       }
       }) */

      headerGridRow.each(function (rowIdx, row) {
        var rowAttr = $.makeArray(row.attributes);
        var rowAttrsStr = '';

        $.each(rowAttr, function (idx, attr) {
          if (attr.nodeValue && attr.nodeName !== 'id') {
            rowAttrsStr += ' ' + attr.nodeName + '="' + attr.nodeValue + '"';
          }
        });

        rowAttrsArr.push(rowAttrsStr);
        rowHeightArr.push($(row).height());
      });

      headerGridRow.find('> th').each(function (idx, value) {
        var cellWidth = $(value).is(':visible') ? parseInt($(value).css('width')) : 0;

        cellWidthArr.push(cellWidth);
      });

      var sortableHtml = $('<ul>').addClass('jsgrid-sortable')
        .css('width', this._headerGrid.width() + 'px');

      headerGridRow.find('> th').each(function (idx, headerCell) {
        var headerCellWidth = $(headerCell).is(':visible') ? parseInt($(headerCell).css('width')) : 0;
        var sortableLi = $('<li>').attr('id', 'jsgrid-sortable-li-' + idx).css('width', headerCellWidth + 'px');
        var sortableTable = $('<table>').attr('id', 'jsgrid-sortable-table-' + idx).addClass('jsgrid-table-sortable');
        var sortableThead = $('<thead>');
        var headerCol = headerGridRow.find('> th:nth-child(' + (idx + 1) + ')');

        headerCol = headerCol.add(headerGridRow.find('> td:nth-child(' + (idx + 1) + ')'));
        headerCol.each(function (colIdx, col) {
          var rowContent = $(col).clone().attr('id', 'jsgrid-sortable-content-' + idx);

          $('<tr ' + rowAttrsArr[colIdx] + '>').css('height', rowHeightArr[colIdx] + 'px')
            .append(rowContent)
            .appendTo(sortableThead);

          sortableThead.appendTo(sortableTable);
          sortableTable.appendTo(sortableLi);
          sortableLi.appendTo(sortableHtml);
        });
      });

      sortableTable.table = fieldSortable.originTable.table.before(sortableHtml).prev();
      sortableTable.table.find('> li > table').each(function (idx, table) {
        if ($(e.target).index() === idx) {
          // ui-sortable-placeholder - calculator border size
          cellWidthArr[idx] -= 2;
          $(table).parent().css('width', cellWidthArr[idx]);
          cellWidthArr[idx] += 2;
        }

        $(table).css('width', cellWidthArr[idx] + 'px');
      });

      this._applyFieldSortable();

      var startIdx = fieldSortable.originTable.startIndex = $(e.target).closest('th').prevAll().length + 1;
      sortableTable.movingRow = sortableTable.table.find('> li:nth-child(' + startIdx + ')');
      sortableTable.movingRow.trigger($.extend($.Event(e.type), {
        which: 1,
        clientX: e.clientX,
        clientY: e.clientY,
        pageX: e.pageX,
        pageY: e.pageY,
        screenX: e.screenX,
        screenY: e.screenY
      }));
    },

    _redrawFieldSortable: function () {
      this._destroyFieldSortable();
      this._initFieldSortable();
    },

    _destroyFieldSortable: function () {
      this._fieldSortable.originTable.table.find('th')
        .off('mousedown.fieldSortable')
        .off('mouseup.fieldSortable');
      this._fieldSortable = null;
    },

    _applyFieldSortable: function () {
      this._fieldSortable.sortableTable.table.sortable({
        items: 'li',
        opacity: 1,
        stop: this._syncFieldSortable(),
        revert: 200,
        containment: null,
        distance: 0,
        cursor: 'move',
        axis: 'x'
      });
    },

    _syncFieldSortable: function () {
      return $.proxy(function () {
        var fieldSortable = this._fieldSortable;

        fieldSortable.originTable.endIndex = fieldSortable.sortableTable.movingRow.prevAll().length + 1;
        fieldSortable.sortableTable.table.remove();

        this._bubbleFieldSortable();
        this._restoreTextSelection();

        this.fields = $.map(this._headerRow.find('th'), function (cell) {
          return $(cell).data(JSGRID_FIELDS_DATA_KEY)
        });

        if (this._resizableFields && this.resizableFields.use) {
          this._resizableFields.refresh();
        }
      }, this)
    },

    getCellData: function (evt) {
      // firefox 지원(composedPath)
      var evtPath = evt.path || (evt.composedPath && evt.composedPath());
      var className = $(_.find(evtPath, {nodeName: 'LI'})).attr('class');
      var row = _.find(evtPath, {nodeName: 'TR'});
      var cell = _.find(evtPath, {nodeName: 'TD'});
      var cellName = $(cell).attr('field-name');

      if (cellName) {
        var rowItem = $(row).data(JSGRID_ROW_DATA_KEY);
        var cellItem = rowItem[cellName];

        this.selectRow(rowItem.itemIndex);

        // fixed list
        if (_.find(evtPath, {nodeName: 'LI'})) {
          // fixed list more button click
          if (!className) {
            return
          }

          var parseClassName = className.split(' ');
          var fixedCellItem = $(_.find(evtPath, {nodeName: 'LI'})).data(parseClassName ? parseClassName[0] : className);

          return {
            cell: cellName,
            cellItem: fixedCellItem,
            rowItem: rowItem
          }
        } else {
          return {
            cell: cellName,
            cellItem: cellItem,
            rowItem: rowItem
          }
        }
      }
    },

    _disableTextSelection: function () {
      var $style = $('<style id="__dragtable_disable_text_selection__" type="text/css">body { -ms-user-select:none;-moz-user-select:-moz-none;-khtml-user-select:none;-webkit-user-select:none;user-select:none; }</style>');

      $(document.head).append($style);
      $(document.body).attr('onselectstart', 'return false;').attr('unselectable', 'on');

      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else {
        document.selection.empty();
      }
    },

    _restoreTextSelection: function () {
      $('#__dragtable_disable_text_selection__').remove();
      var documentBbody = $(document.body);

      if (BODY_ONSELECTSTART_SAVE) {
        documentBbody.attr('onselectstart', BODY_ONSELECTSTART_SAVE);
      } else {
        documentBbody.removeAttr('onselectstart');
      }

      if (BODY_UNSELECTABLE_SAVE) {
        documentBbody.attr('unselectable', BODY_UNSELECTABLE_SAVE);
      } else {
        documentBbody.removeAttr('unselectable');
      }
    },

    _bubbleFieldSortable: function () {
      var this$1 = this;

      var originTable = this._fieldSortable.originTable;
      var fromPos = originTable.startIndex,
        toPos = originTable.endIndex;
      var i;

      if (fromPos < toPos) {
        for (i = fromPos; i < toPos; i++) {
          this$1._setSwapFields(i, 'front');
        }
      } else {
        for (i = fromPos; i > toPos; i--) {
          this$1._setSwapFields(i, 'back');
        }
      }
    },

    _setSwapFields: function (index, type) {
      var this$1 = this;

      var contentIdx, j;
      var originTable = this._fieldSortable.originTable;
      var sortableField, originField,
        sortableHeaderCol, originHeaderCol, sortableBodyCol, originBodyCol,
        colGroup = {};
      var headerGridRow = originTable.table.find('tr');
      var headerGridCol = this._headerColGroupRow.children();
      var bodyGridRow = this._content.find('tr');
      var bodyGridCol = this._bodyColGroupRow.children();

      if (type === 'front') {
        contentIdx = index + 1;
      }

      if (type === 'back') {
        contentIdx = index - 1;
      }

      sortableField = headerGridRow.find('> td:nth-child(' + index + ')')
        .add(headerGridRow.find('> th:nth-child(' + index + ')'))
        .add(bodyGridRow.find('> td:nth-child(' + index + ')'));

      sortableHeaderCol = headerGridCol[index - 1];
      sortableBodyCol = bodyGridCol[index - 1];

      originField = headerGridRow.find('> td:nth-child(' + contentIdx + ')')
        .add(headerGridRow.find('> th:nth-child(' + contentIdx + ')'))
        .add(bodyGridRow.find('> td:nth-child(' + contentIdx + ')'));

      originHeaderCol = headerGridCol[contentIdx - 1];
      originBodyCol = bodyGridCol[contentIdx - 1];

      for (j = 0; j < sortableField.length; j++) {
        this$1._swapFields($.makeArray(sortableField[j]), $.makeArray(originField[j]), 'fields');
      }

      colGroup = {
        sortableCol: [sortableHeaderCol, sortableBodyCol],
        originCol: [originHeaderCol, originBodyCol]
      };

      this._swapFields(colGroup.sortableCol, colGroup.originCol, 'cols');
    },

    _swapFields: function (sortableField, originField, swapType) {
      var length = swapType === 'fields' ? 1 : 2;

      for (var i = 0; i < length; i++) {
        var row = sortableField[i].parentNode;
        var sortableFieldSibling = sortableField[i].nextSibling === originField[i] ? sortableField[i] : sortableField[i].nextSibling;

        originField[i].parentNode.insertBefore(sortableField[i], originField[i]);
        row.insertBefore(originField[i], sortableFieldSibling);
      }
    },

    _refreshHeading: function () {
      this._headerRow.toggle(this.heading);
    },

    _refreshContent: function (isExpandAll) {
      if ( isExpandAll === void 0 ) isExpandAll = true;

      this._content.empty();
      this.getRowSelectionItem = [];

      if (!this.data.length) {
        return this
      }

      this._refreshRows(isExpandAll);
    },

    _createTreeRows: function _createTreeRows ($content, rowIndexCnt, data, itemIndex) {
      // 재귀함수 - tree 구조 데이터 삽입/row
      var createTreeRows = $.proxy(function (item, itemIndex, parentIndex) {
        // TAMS 특화
        var row = this._createRow(item, this._rowIndexCnt)
          .attr('data-rowindex', this._rowIndexCnt) // row id
          .attr('data-depthlevel', item.level) // tree depth level
          .attr('data-groupid', itemIndex) // group id
          .attr('data-parentid', parentIndex) // parent id
          .attr('data-childcount', item.children != null ? item.children.length : 0); // parent id

        // 부모 Row이면 tree-open 속성 추가
        if (parentIndex === void 0) {
          row.attr('tree-open', item.tree_open === void 0 ? this.treeView.expandAll : item.tree_open);
        }

        $.extend(item, {
          parentId: parentIndex,
          groupId: itemIndex
        });

        $content.append(row);

        // TAMS 특화
        this._rowIndexCnt++;

        // tree laze loading
        if (!this.treeView.treeLazeLoading) {
          var childItem = item.children;

          if (childItem != null) {
            for (var i = 0; i < childItem.length; i++) {
              createTreeRows(childItem[i], itemIndex, item.itemIndex);
            }
          }
        }
      }, this);

      createTreeRows(data[itemIndex], itemIndex);
    },

    refreshVirtualScroll: function () {
      if (this.pageVirtualScrolling) {
        this._virtualScroll._initVirtualScroll(true);
      } else {
        this._virtualScroll._initVirtualScroll(true);
        /* #44025 이슈
          dataTable의 height값이 변할때에 해당 함수가 실행되고
          this.data.length 부분을 주입 하였을때에 0px로 변환되어
          스크롤이 오동작하여 주석처리
        */
        // if (this.vsRefreshHeight) {
        //   this._virtualScroll._initVirtualScroll(true)
        // } else {
        //   this._virtualScroll.refreshVirtualScroll(this.data.length)
        // }
      }
    },

    _refreshRows: function (isExpandAll) {
      var this$1 = this;
      if ( isExpandAll === void 0 ) isExpandAll = true;

      var $content = this._content;
      var indexFrom = this._loadStrategy.firstDisplayIndex();
      var rowIndexCnt = this._rowIndexCnt; // TAMS
      var indexTo = this._loadStrategy.lastDisplayIndex();
      var isOpenRow = true;
      this.getRowSelectionItem = [];

      for (var itemIndex = indexFrom; itemIndex < indexTo; itemIndex++) {
        if (this$1.treeView.use) {
          this$1._createTreeRows($content, rowIndexCnt, this$1.data, itemIndex);
        } else {
          var item = this$1.data[itemIndex];
          var row;

          if (this$1.grouping) {
            item = _.filter(this$1.data, function (o) { return (o.is_open || o.is_open === void 0) || o.is_group || !_.has(o, 'is_open'); })[itemIndex];

            // 기존 데이터에 "is_open" 속성 추가
            if (!item.hasOwnProperty('is_open')) {
              $.extend(item, {
                is_open: true
              });
            }

            if (item.is_group) {
              isOpenRow = item.is_open;
              row = this$1._createGroupRow(item, itemIndex);
            } else {
              if (isOpenRow) {
                row = this$1._createRow(item, itemIndex).attr('row-seq', item.seq).attr('row-local-seq', itemIndex);
              }
            }
          } else {
            row = this$1._createRow(item, itemIndex);
          }

          $content.append(row.attr('data-rowindex', itemIndex));
        }
      }

      if (this.treeView.use) {
        if (isExpandAll) {
          if (this.sortState) {
            this.treeExpandAll('close');
          } else {
            if (this.treeView.expandAll) {
              this.treeExpandAll('open');
            } else {
              this.treeExpandAll('close');
            }
          }
        } else {
          // 대상노드 요소 가져오기
          var childNodes = $($content)[0].childNodes;

          // 대상노드 반복
          for (var i = 0, max = childNodes.length; i < max; i++) {
            var targetRow = $(childNodes[i]);
            var targetTreeOpen = targetRow.attr('tree-open');

            // 상위 노드일 경우
            if (targetTreeOpen) {
              // 상위 노드에 해당되는 자식노드 검색
              var groupId = targetRow.attr('data-groupid');

              // 그룹 ID에 해당하는 Row 아이템들 가져오기
              var groupParam = "tr[data-groupid=" + groupId + "][data-depthlevel!=0]";

              // 대상 아이템들 체크
              var rowItems = $(groupParam);

              // Tree 컨트롤러 가져오기
              var expandController = targetRow.find('.toggle-triangle-wrap > div');

              // TreeView 제어
              this$1._treeVisibledCtrl(expandController, targetTreeOpen === 'true' ? 'open' : 'close', rowItems);
            }
          }
        }
      }
    },

    treeExpandAll: function (expandType) {
      if (this.treeView.use) {
        var bodyGrid = this._bodyGrid,
          treeController = bodyGrid.find('.toggle-triangle-wrap > div'),
          itemRow = bodyGrid.find('tr[data-depthlevel!=0]'),
          parent = $(treeController).parent().parent().parent();

        switch (expandType) {
          case 'open':
            this._treeVisibledCtrl(treeController, 'open', itemRow);
            parent.attr('tree-open', true);
            break
          case 'close':
            this._treeVisibledCtrl(treeController, 'close', itemRow);
            parent.attr('tree-open', false);
            break
          default :
        }
      }
    },

    // 코드 수정 - 2018.10.11 김민수 (rowExpand trigger 방식으로 변경)
    rowExpand: function (itemIndex, isExpand) {
      if ( isExpand === void 0 ) isExpand = true;

      // TreeView를 사용하는 경우 동작
      if (this.treeView.use) {
        // Tree expand 대상 row 및 버튼 요소 찾기
        var bodyGrid = this._bodyGrid;
        var selectedRow = bodyGrid.find('#jsgrid-tr-' + itemIndex);
        var rowExpandBtn = selectedRow.find('.toggle-triangle-wrap');

        // 대상 Row의 현재 펼침 / 접힘여부
        var isTreeOpen = selectedRow.attr('tree-open');

        // 트리 펼치기
        if (isExpand) {
          // 트리가 접혀있는 경우에만 Trigger 발생
          if (isTreeOpen !== 'true') {
            rowExpandBtn.trigger('click');
          }
        } else {
          // 트리가 펼쳐있는 경우에만 Trigger 발생
          if (isTreeOpen !== 'false') {
            rowExpandBtn.trigger('click');
          }
        }
      }
    },

    _createGroupRow: function (item, itemIndex) {
      var mergeLen = _.filter(this.fields, function (o) { return o.visible !== false; }).length;
      var groupRow = $('<tr>').attr('id', 'jsgrid-tr-' + itemIndex).attr('parent-group', item.name).attr('group-open', item.is_open === void 0 ? true : item.is_open);
      var groupText = item.name;
      var self = this;

      // 방화벽 정책 데이터 테이블 특화
      if (this.firewall || this.nat) {
        // // TAMS 속성 설정 (NGF 수정부분, TAMS 불필요)
        // if (this.firewall) {
        //   if (item.fw_set_id === 0) {
        //     groupRow.attr('tams', true)
        //   }
        // }

        // TAMS, (server-side paging 변경에 따른 활성/비활성 갯수 별도 입력)
        var enableCnt, disableCnt;
        if (typeof item.enabled_cnt !== 'undefined') {
          enableCnt = item.enabled_cnt;
        } else {
          enableCnt = _.filter(this.data, function (o) {
            return o.use === 1 && !o.is_group && item[self.blueMaxGroupKey] === o[self.blueMaxGroupKey]
          }).length;
        }
        if (typeof item.disabled_cnt !== 'undefined') {
          disableCnt = item.disabled_cnt;
        } else {
          disableCnt = _.filter(this.data, function (o) {
            return o.use === 0 && !o.is_group && item[self.blueMaxGroupKey] === o[self.blueMaxGroupKey]
          }).length;
        }

        groupText = item.name + ' (' + this.i18n_enabled + ': ' + enableCnt + ', ' + this.i18n_disabled + ': ' + disableCnt + ')';
      }

      // var quasarGroupBtnTemplate = $('<div>').attr('vue-quasar-template', 'groupBtn').css('display', 'inline-block')
      var quasarGroupBtnTemplate =
        $('<button tabindex="0" class="q-btn inline relative-position q-btn-item non-selectable q-btn-round q-focusable q-hoverable bs bs-q-btn-sm bs-q-btn-round-icon" style="font-size: 10px;">' +
          '<div class="q-focus-helper">' +
          '</div>' +
          '<div class="q-btn-inner row col items-center justify-center">' +
          '<span class="bs-q-btn-round-icon bs-q-btn-round-icon-more-dot"></span>' +
          '</div>' +
          '</button>'
        ).on('click', function () {
          self.firewallGroupEvent(self, item);
        });

      var groupTextBox =
        $('<span>')
          .addClass('fw-group-text-box')
          .attr('fw-group-id', item[this.blueMaxGroupKey])
          .attr('fw-group-name', item.name)
          .text(groupText)
          .css('margin-right', '5px');

      // // TAMS (NGF 수정부분, TAMS 불필요)
      // if (this.firewall) {
      //   if (item.fw_set_id === 0) {
      //     groupTextBox.css('color', '#df3400')
      //   }
      // }
      //
      // var groupBox = $('<div>').append(groupTextBox)
      //
      // if (this.firewallGroupButton) {
      //   // TAMS 제거
      //   if (this.firewall) {
      //     if (item.fw_set_id !== 0) {
      //       groupBox.append(quasarGroupBtnTemplate)
      //     }
      //   }
      // }

      // TAMS
      if (this.firewall) {
        if (item.name === 'pams') {
          groupTextBox.css('color', '#df3400');
        }
      }

      // TAMS - 상속 그룹여부 판단
      var isInheritGroup = false;
      if (item.name !== 'top' && item.name !== 'bottom') {
        isInheritGroup = true;
      }

      // TAMS
      var groupBox = $('<div>').append(groupTextBox).append(this.firewallGroupButton && !isInheritGroup ? quasarGroupBtnTemplate : null);

      var groupCell =
        $('<td>').attr('colspan', mergeLen).addClass(this.cellClass).addClass(this.groupCellClass);

      var expandBtnWrapper = $('<div>').addClass('toggle-triangle-wrap').css('margin-left', '0px'),
        expandBtn = $('<div>').addClass('ui-icon').css({left: '0px', cursor: 'pointer'}),
        isOpenIconClass = 'ui-icon-triangle-1-s',
        isOpenIconDataClass = 'tree-open';

      if (_.has(item, 'is_open')) {
        if (!item.is_open) {
          isOpenIconClass = 'ui-icon-triangle-1-e';
          isOpenIconDataClass = 'tree-close';
        }
      }

      expandBtn.addClass(isOpenIconClass).addClass(isOpenIconDataClass);

      expandBtnWrapper
        .off('click.groupexpand')
        .on('click.groupexpand', function (e) {
          var icon = $(e.target);

          self.getRowSelectionItem = [];

          if (icon.hasClass('tree-close')) {
            self.data = _.map(self.data, function (o) {
              if (o[self.blueMaxGroupKey] === item[self.blueMaxGroupKey]) {
                o.is_open = true;
              }

              return o
            });
          } else {
            self.data = _.map(self.data, function (o) {
              if (o[self.blueMaxGroupKey] === item[self.blueMaxGroupKey]) {
                o.is_open = false;
              }

              return o
            });
          }

          self.refresh();
          // this._loadStrategy.finishLoad(_.filter(this.data, o => o.is_open || o.is_group))
          self.groupExpandCallBack(_.filter(self.data, function (o) { return (o.is_open || o.is_open === void 0) || o.is_group; }).length, item.fw_grp_id, item.is_open);
        });

      expandBtnWrapper.append(expandBtn);
      groupBox.append(expandBtnWrapper);
      groupCell.append(groupBox);
      groupRow.append(groupCell);

      return groupRow
    },

    // 페이지 사이즈 조절
    refreshPageSize: function refreshPageSize (pageSize) {
      this.pageSize = pageSize;
      this.refresh();
    },

    _setGroupData: function (item) {
      var tempData = [];

      if (this.groupDataList.length > 0) {
        tempData = this.groupDataList;
      } else {
        tempData = this.data;
      }

      this.groupDataList = $.map(tempData, $.proxy(function (value) {
        if (value[this.blueMaxGroupKey] !== item[this.blueMaxGroupKey] || value.is_group) {
          return value
        } else {
          this.closedData.unshift(value);
        }
      }, this));
    },

    _createRow: function (item, itemIndex, type) {
      var $result;

      if ($.isFunction(this.rowRenderer)) {
        $result = this.renderTemplate(this.rowRenderer, this, {item: item, itemIndex: itemIndex});
      } else {
        $result = $('<tr>').attr('id', 'jsgrid-tr-' + itemIndex);

        this._renderCells($result, item, itemIndex, type);
      }

      // // TAMS 속성 설정 (NGF 수정부분, TAMS 불필요)
      // if (this.firewall) {
      //   if (item.fw_set_id === 0) {
      //     $result.attr('tams', true)
      //   }
      // }

      if (this.grouping) {
        if (item.hasOwnProperty('group')) {
          $result.attr('group', item.name);
        }
      }

      // TAMS, lazy-loading 관련 - 해당구문 불필요
      // if (this.treeView.use && type !== 'update') {
      //   if (item.level && item.level !== 0) {
      //     $result.hide()
      //   }
      // }

      $result.addClass(this._getRowClasses(item, itemIndex))
        .data(JSGRID_ROW_DATA_KEY, $.extend(item, {itemIndex: itemIndex}))
        .off('dblclick.rowdblclick')
        .on('dblclick.rowdblclick', $.proxy(function (e) {
          // TAMS (NGF 수정부분, TAMS 불필요)
          // if (this.firewall) {
          //   if (item.fw_set_id === 0) {
          //     return
          //   }
          // }

          if (this.firewall || this.nat) {
            if ($(e.target).attr('class').indexOf('jsgrid-cell-textbox') > -1) {
              if ($(e.target).parent().attr('field-name') === 'seq' || $(e.target).parent().attr('field-name') === 'use') {
                return
              }
            } else {
              if ($(e.target).attr('field-name') === 'seq' || $(e.target).attr('field-name') === 'use') {
                return
              }
            }
          }

          if (!this.disable) {
            this.rowDoubleClick({
              item: item,
              itemIndex: itemIndex,
              event: e
            });
          }
        }, this));

      if (this.selecting) {
        this._attachRowHover($result);
      }

      if (this.rowSelection && !this.editing) {
        this._attachRowSelection($result);
      }

      return $result
    },

    groupExpandAll: function (expandType) {
      if (this.grouping) {
        if (expandType === 'open') {
          $.map(this.data, function (value, idx) {
            value.is_open = true;
          });

          this.closedData = [];
        } else {
          $.map(this.data, function (value, idx) {
            value.is_open = false;
          });
        }

        this.refresh();
      }
    },

    _getRowClasses: function (item, itemIndex) {
      var classes = [];
      classes.push(((itemIndex + 1) % 2) ? this.oddRowClass : this.evenRowClass);
      classes.push(getOrApply(this.rowClass, this, item, itemIndex));
      return classes.join(' ')
    },

    _attachRowHover: function ($row) {
      var self = this;
      var selectingRowClass = this.selectingRowClass;
      var selectionRowClass = this.selectionRowClass;

      $row.hover(function () {
          var rowItem = $row.data(JSGRID_ROW_DATA_KEY);

          if (!$row.hasClass(selectionRowClass)) {
            $(this).addClass(selectingRowClass);
          }

          if (self.cellIconBtn) {
            if (self.cellIconBtn.hasOwnProperty('except')) {
              if (rowItem[self.cellIconBtn.except.key] === self.cellIconBtn.except.value) {
                return
              }
            }
            var cellIconBtnClass = self.cellIconBtn.class;
            var cellIconBtnCallBack = self.cellIconBtn.event;
            var cellIconBtn = $('<i>').addClass(cellIconBtnClass);

            cellIconBtn.off('click.celliconbtn').on('click.celliconbtn', function (e) {
              var fieldName = $(this).parent().attr('field-name');
              var cellItem = rowItem[fieldName];

              cellIconBtnCallBack.call(self, {rowItem: rowItem, cellItem: cellItem});
            });

            $(this).find('td').append(cellIconBtn);
          }
        },
        function () {
          $(this).removeClass(selectingRowClass);
          $(this).find('td > i').remove();
        });
    },

    _setRowSelectionItem: function (selectedItem) {
      this.getRowSelectionItem = selectedItem;
    },

    _attachRowSelectionStyle: function (compareIdx) {
      var el = $.grep(this._content.children(), function (f) {
        return $(f).data('rowindex') === compareIdx && $(f).attr('parent-group') == null
      });

      $(el).addClass(this.selectionRowClass);
    },

    _attachRowSelection: function ($row) {
      $row.off('click.attachclick')
        .on('click.attachclick', $.proxy(function (e) {
          var this$1 = this;

          // TODO: 리펙토링 필요
          if (!this.disable) {
            var selectionRowClass = this.selectionRowClass;
            var content = this._content;
            var selectItem = $row.data(JSGRID_ROW_DATA_KEY);
            var selectionItemObj = this.getRowSelectionItem.length > 0 ? this.getRowSelectionItem : $.makeArray(selectItem);
            var multiRowList = this.getRowSelectionItem;
            var result = [];
            var data = this.data;

            // Shift key 다중 선택
            if (e.shiftKey > 0 && this.multiSelection) {
              var startRowIdx = 0;
              var endRowIdx = selectItem.itemIndex;
              var rowItem = void 0;
              var checkParentGroup = void 0;

              if ($.isPlainObject(selectionItemObj)) {
                startRowIdx = $.makeArray(selectionItemObj)[0].itemIndex;
              } else {
                startRowIdx = _.last(selectionItemObj).itemIndex;
              }

              if (startRowIdx > endRowIdx) {
                for (startRowIdx; startRowIdx >= endRowIdx; startRowIdx--) {
                  if (this$1.firewall || this$1.nat) {
                    checkParentGroup = !$(content).find('tr[id*=' + startRowIdx + ']').attr('parent-group');
                    rowItem = $(content).find('tr[data-rowindex="' + startRowIdx + '"]').data('JSGridItem');
                    // rowItem = $(content).find('tr').eq(i).data('JSGridItem')
                  } else {
                    checkParentGroup = !$(content).find('tr').eq(startRowIdx).attr('parent-group');

                    if (data[startRowIdx]) {
                      rowItem = data[startRowIdx];
                    }

                    if (this$1.treeView.use) {
                      rowItem = $(content).find('tr[data-rowindex="' + startRowIdx + '"]').data('JSGridItem');
                      // rowItem = $(content).find('tr').eq(i).data('JSGridItem')
                    }
                  }

                  this$1._attachRowSelectionStyle(startRowIdx);

                  if (this$1.firewall || this$1.nat) {
                    if (checkParentGroup && !_.some(multiRowList, rowItem) && rowItem.is_open) {
                      multiRowList.push(rowItem);
                    }
                  } else {
                    if (checkParentGroup && !_.some(multiRowList, rowItem)) {
                      multiRowList.push(rowItem);
                    }
                  }
                }
              } else {
                for (startRowIdx; startRowIdx <= endRowIdx; startRowIdx++) {
                  if (this$1.firewall || this$1.nat) {
                    checkParentGroup = !$(content).find('tr[id*=' + startRowIdx + ']').attr('parent-group');
                    rowItem = $(content).find('tr[data-rowindex="' + startRowIdx + '"]').data('JSGridItem');
                    // rowItem = $(content).find('tr').eq(v).data('JSGridItem')
                  } else {
                    checkParentGroup = !$(content).find('tr').eq(startRowIdx).attr('parent-group');

                    if (data[startRowIdx]) {
                      rowItem = data[startRowIdx];
                    }

                    if (this$1.treeView.use) {
                      rowItem = $(content).find('tr[data-rowindex="' + startRowIdx + '"]').data('JSGridItem');
                      // rowItem = $(content).find('tr').eq(v).data('JSGridItem')
                    }
                  }

                  this$1._attachRowSelectionStyle(startRowIdx);

                  if (checkParentGroup && !_.some(multiRowList, rowItem)) {
                    multiRowList.push(rowItem);
                  }
                }
              }

              result = multiRowList;
            } else {
              // Ctrl key 다중 선택
              if (e.ctrlKey > 0 && this.multiSelection) {
                if ($(e.currentTarget).hasClass(selectionRowClass)) {
                  // unselect
                  var currDataArr = this.getRowSelectionItem;

                  $row.removeClass(selectionRowClass);

                  result = $.grep(currDataArr, function (f) {
                    return f !== selectItem
                  });
                } else {
                  // select
                  multiRowList = this.getRowSelectionItem;
                  multiRowList.push(selectItem);

                  $.each(multiRowList, $.proxy(function (idx, value) {
                    var itemIndex = void 0;

                    if (this.treeView.use) {
                      itemIndex = Number($(e.currentTarget).attr('data-rowindex'));
                    } else {
                      itemIndex = value.itemIndex;
                    }

                    this._attachRowSelectionStyle(itemIndex);
                  }, this));

                  result = multiRowList;
                }
              } else {
                // normal select
                $(content).find('tr').removeClass(selectionRowClass);
                $row.addClass(selectionRowClass);
                result = $.makeArray(selectItem);
              }
            }

            this._setRowSelectionItem($.unique(result));

            this.rowClick({
              item: selectItem,
              items: result,
              multiple: result.length > 1,
              itemIndex: selectItem.itemIndex,
              event: e
            });

            this.rowClicked({
              item: selectItem,
              items: result,
              multiple: result.length > 1,
              itemIndex: selectItem.itemIndex,
              event: e
            });
          }
        }, this));
    },

    _renderCells: function ($row, item, itemIndex, type) {
      this._eachField(function (field) {
        $row.append(this._createCell(item, field, itemIndex, type));
      });
      return this
    },

    _createCell: function (item, field, itemIndex, type) {
      var self = this;
      var $result = null;
      var fieldValue = this._getItemFieldValue(item, field);
      var args = {value: fieldValue, item: item, name: field.name};

      if ($.isFunction(field.cellRenderer)) {
        $result = this.renderTemplate(field.cellRenderer, field, args);
      } else {
        $result = $('<td>').addClass(CELL_TEXT_OVERFLOW_CALSS).attr('field-name', field.name);

        if (field.type === 'quasar' && type !== 'virtualScrollDummy') {
          var quasarResource = field.itemTemplate(fieldValue, item, field.name);
          var parseArray = [];

          if (quasarResource) {
            if ($.isArray(quasarResource)) {
              parseArray = quasarResource;
            } else {
              parseArray.push(quasarResource);
            }
          }

          parseArray.forEach(function (a, i) {
            if (_.isString(quasarResource)) {
              // $result.attr('title', fieldValue)
            } else {
              if (!item._itemKey) { // itemIndex를 사용할 때에 정렬 버그로 인하여 식별 Key 생성
                item._itemKey = String(Date.now()) + String(Math.floor(Math.random() * (200 - 0 + 1)));
              }

              $result.append($('<div>').attr('vue-quasar-template', self.tableId + '_' + field.name + '_' + i + '_' + item._itemKey));
            }
          });

          if (_.has(field, 'quasarItemTemplate')) {
            $result.append(this.renderTemplate(field.quasarItemTemplate(fieldValue, item, field.name, quasarResource), field, args));
          } else {
            // $result.append(this.renderTemplate(field.itemTemplate || fieldValue, field, Object.assign(args, {index: itemIndex})))
            $result.append($('<span>').addClass('jsgrid-cell-textbox').append(this.renderTemplate(field.itemTemplate || fieldValue, field, Object.assign(args, {index: itemIndex}))));
          }
        } else {
          var cellTextBox = $('<span>').addClass('jsgrid-cell-textbox');

          if (field.type === 'list' || field.type === 'fixed') {
            // 패딩... 임시 삭제.. 리사즈이 크기가 안 맞음
            // $result.addClass('jsgrid-cell-list')
            cellTextBox.removeClass('jsgrid-cell-textbox').addClass('jsgrid-cell-listbox');
          } else {
            if (self.firewall || self.nat) {
              if (item.use === 0) {
                cellTextBox.addClass('disabled');
              }
            }
          }

          if (this.treeView.use && this.treeView.targetColumn === field.name) {
            $result.prepend(this._createTreeController(item, field));
          }

          // 아이콘 템플릿을 사용하는 경우
          if (field.hasOwnProperty('iconTemplate') && field.type !== 'fixed') {
            var iconTemplate = field.iconTemplate(fieldValue, item);

            if (iconTemplate) {
              if (_.isArray(iconTemplate.icon)) { // 아이콘 여러 개 생성
                _.forEach(iconTemplate.icon, function (icon) {
                  var iconClassContainer = $('<div>');
                  $result.append(iconClassContainer.addClass(icon));
                });
              } else { // 단일 아이콘
                var iconClassContainer = $('<div>');
                $result.append(iconClassContainer.addClass(iconTemplate.icon));
              }

              if (iconTemplate.hasOwnProperty('text')) {
                var textWrapper = cellTextBox.text(this.renderTemplate(iconTemplate.text));

                if (iconTemplate.textDecoration) {
                  textWrapper.css('text-decoration', 'line-through');
                }

                if (iconTemplate.color) {
                  textWrapper.css('color', iconTemplate.color);
                }

                $result.append(textWrapper);

                // 자식 태그에 title 속성 추가
                // this._setTitleToTemplate($result.children())
              }
            }
          } else if (field.hasOwnProperty('itemTemplate')) {
            var resRender = this.renderTemplate(field.itemTemplate || fieldValue, field, Object.assign(args, {index: itemIndex}));
            var textBox$1 = cellTextBox.append(resRender);

            $result.append(textBox$1);
          } else if (field.hasOwnProperty('textTemplate') && field.type !== 'fixed') { // textTemplate 일 경우
            var textTemplate = field.textTemplate(fieldValue, item, field.name || '');
            var resRender$1 = this.renderTemplate(textTemplate);
            var textBox$2 = $('<span>').addClass('jsgrid-cell-textbox').append(resRender$1);

            if (self.firewall || self.nat) {
              if (item.use === 0) {
                textBox$2.addClass('disabled');
              }
            }

            $result.append(textBox$2);
          } else {
            var resRender$2 = this.renderTemplate(field.itemTemplate || fieldValue, field, Object.assign(args, {index: itemIndex}));
            var textBox = '';

            if (typeof resRender$2 === 'string') {
              textBox = cellTextBox.text(resRender$2);
            } else {  // strip tag 를 허용
              textBox = cellTextBox.append(resRender$2);
            }

            $result.append(textBox);
          }
        }
      }

      // 자식 속성에 title이 없는 경우에만 추가
      // if (!$result.children().attr('title')) {
      //   // 빈 객체가 아니고, 리스트도 아니며, 퀘이사 컴포넌트의 값이 아닌 경우
      //   if (!_.isPlainObject(fieldValue) && !_.isArray(fieldValue) && field.type !== 'quasar') {
      //     // 값이 있는 경우에만 title 설정
      //     if (fieldValue) {
      //       this._setTitleToTemplate($result.children(), fieldValue)
      //     }
      //   }
      // }

      // rowSortable Handler 지정
      if (this.rowSortableHandler !== null) {
        if (field.name === this.rowSortableHandler) {
          $result.attr('row-sortable-handler', true);
        }
      }

      if (field.onCellSelect) {
        $result
          .off('click.cellevt')
          .on('click.cellevt', function (e) {
            // // TAMS (NGF 수정부분, TAMS 불필요)
            // if (self.firewall) {
            //   if (item.fw_set_id === 0) {
            //     return
            //   }
            // }

            self._bodyGrid.find('.jsgrid-selection-cell').removeClass(self.selectionCellClass);
            $result.addClass(self.selectionCellClass);

            self.cellClick({
              rowItem: item,
              fieldName: field.name,
              cellItem: fieldValue,
              event: e
            });
          });
      }

      // tooltip (TAMS 수정됨, tooltip: false 명시 시 사용하지 않음)
      if (field.type !== 'fixed' && field.tooltip !== false) {
        $result.hover(function (e) {
          var textBox = $(e.currentTarget).find('.jsgrid-cell-textbox');

          if (_.has(field, 'iconTemplate')) {
            if ($(textBox).text() === '') {
              textBox = $($(e.currentTarget).children()[0]);
            }
          }

          field._renderToolTip(field, item, textBox, self, 'basic', e);
        }, function () {
          field._destroyToolTip();
        });
      }

      return this._prepareCell($result, field)
    },

    _createTreeController: function (item, field) {
      var self = this;
      var pos = (field.align !== 'center' && field.align !== '') ? 'margin-left' : 'left';
      var depthMargin = 18 * parseInt(_.get(item, ['level'], 0)) + 5 + 'px'; // TAMS
      var treeWrap = $('<div>').addClass('toggle-triangle-wrap').css(pos, depthMargin),
        treeIconEl = $('<div>').css('left', '5px').css('display', 'inline-block');

      // TAMS - ...정확히 판단 불가
      // if (item.children) {
      var isLazyLoad = _.get(self.treeView, ['treeLazeLoading'], false);
      if ((_.get(item.children, ['length'], 0) > 0 && !isLazyLoad) ||
        (item.children && isLazyLoad)) {
        treeIconEl
          .addClass(this.treeView.closePosClass)
          .addClass(this.treeView.iconClass)
          .addClass('tree-close')
          .css('cursor', 'pointer');

        treeWrap.off('click.treeView')
          .on('click.treeView', function (evt) {
            var icon = $(this.children[0]);
            var targetRow = $(this).parent().parent();
            var depthLevel = targetRow.data('depthlevel'),
              groupIndex = targetRow.data('groupid'), // TAMS
              targetRowId = targetRow.data('rowindex');

            // if (icon.hasClass('tree-close')) {
            if (!JSON.parse(targetRow.attr('tree-open'))) {
              var rootIndex = Number($(targetRow).data('groupid'));

              self.data[rootIndex].tree_open = true;

              if (self.treeView.treeLazeLoading) {
                // var rowIndexCnt = 1 // TAMS
                var childrenData = self.treeView.lazeCallBack(item);
                targetRow.attr('data-childcount', childrenData.length);  // TAMS, 자식 노드 갯수 업데이트

                childrenData.then(function (result) {
                  // TAMS
                  var inverseRowIdx = self._rowIndexCnt + result.length;
                  // 타겟행 아래에 열을 추가하기 위해 역순으로 추가 (최초 정렬 유지 위함)
                  for (var i = result.length - 1; i >= 0; i--) {
                    var childItem = result[i];
                    var row = self._createRow(childItem, inverseRowIdx)
                      .attr('data-rowindex', inverseRowIdx) // row id
                      .attr('data-depthlevel', _.get(childItem, ['level'], 1)) // tree depth level
                      .attr('data-groupid', groupIndex) // group id
                      .attr('data-parentid', targetRowId) // parent id
                      .attr('data-childcount', item.children != null ? item.children.length : 0) // parent id
                      .attr('tree-open', false);

                    $.extend(item, {
                      parentId: targetRowId,
                      groupId: groupIndex
                    });

                    var marginLeft = 18 * parseInt(_.get(childItem, ['level'], 1)) + 5;

                    row.find('.toggle-triangle-wrap').css('margin-left', marginLeft + 'px');
                    targetRow.after(row);

                    self._rowIndexCnt++;
                    inverseRowIdx--;
                  }

                  // self._treeFilterGroup(self, parentIndex, depthLevel, targetRowId, icon, targetRow) // TAMS 제외
                });
              }

              // TAMS
              self._treeFilterGroup(self, groupIndex, depthLevel, targetRowId, icon, targetRow);
            } else {
              self.data[Number($(targetRow).data('groupid'))].tree_open = false;

              if (self.treeView.treeLazeLoading) {
                var groupId = $(targetRow).data('groupid');
                var childNode = self._bodyGrid.find('tr[data-parentid=' + groupId + ']'),
                  childWrap = $(childNode).find('.toggle-triangle-wrap > div'),
                  targetWrap = $(targetRow).find('.toggle-triangle-wrap > div');

                // TAMS
                // $.merge(childWrap, targetWrap).removeClass(self.treeView.openPosClass)
                //   .removeClass('tree-open')
                //   .addClass(self.treeView.closePosClass)
                //   .addClass('tree-close')
                //
                // $(targetRow).attr('tree-open', false)
                //
                // self._bodyGrid.find('tr[data-parentid="' + groupId + '"]').remove()

                // 재귀 함수
                var removeChildNode = function (findGroup, parentIds, idx) {
                  if (parentIds.length > 0) {
                    var leftGroup, leftParentIds = [];
                    for (var i = 0; i < parentIds.length; i++) {
                      leftGroup = $.grep(findGroup, function (f) {
                        if ($(f).data('depthlevel') > depthLevel && $(f).data('parentid') === parentIds[i]) {
                          leftParentIds.push($(f).data('rowindex'));
                          $(f).remove();
                          return false
                        } else {
                          return true
                        }
                      });
                    }
                    idx++;
                    removeChildNode(leftGroup, leftParentIds, idx);
                  }
                };

                var sameGroup = self._bodyGrid.find('tr[data-groupid=' + groupIndex + ']');
                var childGroup = $.grep(sameGroup, function (f) {
                  return $(f).data('depthlevel') > depthLevel && $(f).data('parentid') >= targetRowId
                });
                var interatorIdx = 0;
                removeChildNode(childGroup, [targetRowId], interatorIdx);
                targetRow.attr('data-childcount', 0)  // 자식 노드 갯수 초기화
                  .attr('tree-open', false);

                targetWrap.removeClass(self.treeView.openPosClass)
                  .removeClass('tree-open')
                  .addClass(self.treeView.closePosClass)
                  .addClass('tree-close');

                // TAMS 제외
                // $(targetRow).attr('tree-open', false)
                //
                // self._bodyGrid.find('tr[data-parentid="' + groupId + '"]').remove()
              } else {
                // 재귀함수 - 단계 별 하위 노드 close
                var hideChildNode = function (targetRow) {
                  $(targetRow).each(function (idx, value) {
                    if ($(value).data('childcount') > 0) {
                      var rowId = $(value).data('rowindex');
                      var childNode = self._bodyGrid.find('tr[data-parentid=' + rowId + ']'),
                        childWrap = $(childNode).find('.toggle-triangle-wrap > div'),
                        targetWrap = $(targetRow).find('.toggle-triangle-wrap > div');

                      self._treeVisibledCtrl($.merge(childWrap, targetWrap), 'close', $(childNode));
                      $(value).attr('tree-open', false);

                      hideChildNode(childNode);
                    }
                  });
                };

                hideChildNode(targetRow);
              }
            }

            evt.stopPropagation();
          });
      }

      treeWrap.append(treeIconEl);

      return treeWrap
    },

    _treeFilterGroup: function (grid, groupId, level, targetGroupId, icon, targetRow) {
      // root parent가 동일한 그룹 조회
      // 조회된 그룹 중 event가 발생된 element의 depth level과 상위 parent의 id를 비교하여 조건에 일치하는 element 추출
      var parentGroup = grid._bodyGrid.find('tr[data-groupid=' + groupId + ']'),
        filterGroup = $.grep(parentGroup, function (f) {
          return $(f).data('depthlevel') > level && $(f).data('parentid') === targetGroupId
        });

      this._treeVisibledCtrl(icon, 'open', $(filterGroup));
      $(targetRow).attr('tree-open', true);
    },

    _treeVisibledCtrl: function (selector, type, target) {
      switch (type) {
        case 'open':
          selector.removeClass(this.treeView.closePosClass)
            .removeClass('tree-close')
            .addClass(this.treeView.openPosClass)
            .addClass('tree-open');
          target.show();

          break
        case 'close':
          selector.removeClass(this.treeView.openPosClass)
            .removeClass('tree-open')
            .addClass(this.treeView.closePosClass)
            .addClass('tree-close');
          target.hide();

          break
        default:
      }
    },

    _getItemFieldValue: function (item, field) {
      var props = field.name.split('.');
      var result = item[props.shift()];

      while (result && props.length) {
        result = result[props.shift()];
      }

      if (_.has(field, 'noneData')) {
        if (_.isArray(result)) {
          if (result.length === 0) {
            result.push(field.noneData);
          }
        } else {
          if (!result) {
            result = field.noneData;
          }
        }
      }

      return result
    },

    _setItemFieldValue: function (item, field, value) {
      var props = field.name.split('.');
      var current = item;
      var prop = props[0];

      while (current && props.length) {
        item = current;
        prop = props.shift();
        current = item[prop];
      }

      if (!current) {
        while (props.length) {
          item = item[prop] = {};
          prop = props.shift();
        }
      }

      item[prop] = value;
    },

    sort: function (field, order) {
      if (!this.disable) {
        if ($.isPlainObject(field)) {
          order = field.order;
          field = field.field;
        }

        this._clearSortingCss();
        this._setSortingParams(field, order);
        this._setSortingCss();
        this.sortState = true;

        return this._loadStrategy.sort()
      }
    },

    _clearSortingCss: function () {
      this._headerRow.find('th')
        .removeClass(this.sortAscClass)
        .removeClass(this.sortDescClass);
    },

    _setSortingParams: function (field, order) {
      field = this._normalizeField(field);
      order = order || ((this._sortField === field) ? this._reversedSortOrder(this._sortOrder) : SORT_ORDER_ASC);

      this._sortField = field;
      this._sortOrder = order;
    },

    _normalizeField: function (field) {
      if ($.isNumeric(field)) {
        return this.visiblefields[field]
      }

      if (typeof field === 'string') {
        return $.grep(this.fields, function (f) {
          return f.name === field
        })[0]
      }

      return field
    },

    _reversedSortOrder: function (order) {
      return (order === SORT_ORDER_ASC ? SORT_ORDER_DESC : SORT_ORDER_ASC)
    },

    _setSortingCss: function () {
      var fieldIndex = this._visibleFieldIndex(this._sortField);

      this._headerRow.find('th').eq(fieldIndex)
        .addClass(this._sortOrder === SORT_ORDER_ASC ? this.sortAscClass : this.sortDescClass);
    },

    _visibleFieldIndex: function (field) {
      return $.inArray(field, $.grep(this.fields, function (f) {
        return f.visible
      }))
    },

    _sortData: function () {
      // TAMS (customSorter)
      if (_.get(this._sortField, ['customSorter'])) {
        return
      }

      var sortFactor = this._sortFactor(),
        sortField = this._sortField;

      if (sortField) {
        // object.freeze로 인해 read only 데이터를 복사
        var cloneData = _.cloneDeep(this.data);

        cloneData.sort(function (item1, item2) {
          var sortItem1 = item1[sortField.name];
          var sortItem2 = item2[sortField.name];

          if (sortField.name.indexOf('.') !== -1) {
            if (typeof item1[sortField.name.split('.')[0]] === 'object') {
              if (item1[sortField.name.split('.')[0]] !== void 0 && item1[sortField.name.split('.')[0]] !== null) {
                sortItem1 = item1[sortField.name.split('.')[0]][sortField.name.split('.')[1]];
              }
            }

            if (typeof item2[sortField.name.split('.')[0]] === 'object') {
              if (item2[sortField.name.split('.')[0]] !== void 0 && item2[sortField.name.split('.')[0]] !== null) {
                sortItem2 = item2[sortField.name.split('.')[0]][sortField.name.split('.')[1]];
              }
            }
          }

          return sortFactor * sortField.sortingFunc(sortItem1, sortItem2, item1, item2)
        });

        this.data = cloneData;
      }
    },

    _sortFactor: function () {
      return this._sortOrder === SORT_ORDER_ASC ? 1 : -1
    },

    _itemsCount: function () {
      return this._loadStrategy.itemsCount()
    },

    _pagesCount: function () {
      var itemsCount = this._itemsCount(),
        pageSize = this.pageSize;
      return Math.floor(itemsCount / pageSize) + (itemsCount % pageSize ? 1 : 0)
    },

    _refreshPager: function () {
      this._pagerContainer.empty();

      var showPager = this.paging && !this.virtualScrolling && this._pagesCount() > 1;
      this._pagerContainer.toggle(showPager);
    },

    _refreshSize: function (value) {
      this._refreshHeight(value);
      this._refreshWidth();

      if (value) {
        if (this.virtualScrolling || this.pageVirtualScrolling) {
          this.refreshVirtualScroll();
        }
      }

      if (this._resizableFields) {
        this._resizableFields.refresh();
      }
    },

    _refreshWidth: function () {
      var width = (this.width === 'auto') ? this._getAutoWidth() : this.width;

      this._container.width(width);
    },

    // TAMS
    _refreshResizable: function () {
      try {
        if (this.resizableFields.use) {
          if (typeof this._resizableFields._onResize === 'function') {
            this._resizableFields._onResize();
          }
        }
      } catch (e) {
        // error
      }
    },

    _getAutoWidth: function () {
      var $headerGrid = this._headerGrid,
        $header = this._header;

      $headerGrid.width('auto');

      var contentWidth = $headerGrid.outerWidth();
      var borderWidth = $header.outerWidth() - $header.innerWidth();

      $headerGrid.width('');

      return contentWidth + borderWidth
    },

    _scrollBarWidth: (function () {
      var result;

      return function () {
        if (result === undefined) {
          var $ghostContainer = $('<div style=\'width:50px;height:50px;overflow:hidden;position:absolute;top:-10000px;left:-10000px;\'></div>');
          var $ghostContent = $('<div style=\'height:100px;\'></div>');
          $ghostContainer.append($ghostContent).appendTo('body');
          var width = $ghostContent.innerWidth();
          $ghostContainer.css('overflow-y', 'auto');
          var widthExcludingScrollBar = $ghostContent.innerWidth();
          $ghostContainer.remove();
          result = width - widthExcludingScrollBar;
        }
        return result
      }
    })(),

    _refreshHeight: function (value) {
      var pagerContainer = this._pagerContainer,
        height = this.windowSize ? (value === null || value === void 0 ? this.resizeHeight : value) : this.height,
        nonBodyHeight;

      if (parseInt(height) < parseInt(this.minHeight)) {
        height = this.minHeight + 'px';
      }

      if (this.windowSize) {
        this.resizeHeight = height;
      }

      this._container.height(height);

      if (height !== 'auto') {
        height = this._container.height();

        nonBodyHeight = this._header.outerHeight(true);
        if (pagerContainer.parents(this._container).length) {
          nonBodyHeight += pagerContainer.outerHeight(true);
        }

        this._body.outerHeight(height - nonBodyHeight - 2);
      }
    },

    // row 항목의 text를 비활성화 처리
    disableRow: function (flag, rowItem) {
      var rowIndex = rowItem.itemIndex;

      if (flag) {
        $('#jsgrid-tr-' + rowIndex).find('.jsgrid-cell-textbox').addClass('disabled');
      } else {
        $('#jsgrid-tr-' + rowIndex).find('.jsgrid-cell-textbox').removeClass('disabled');
      }
    },

    openPage: function (pageIndex) {
      if (pageIndex < 1 || pageIndex > this._pagesCount()) {
        return
      }

      this._setPage(pageIndex);
      this._loadStrategy.openPage(pageIndex);
    },

    _setPage: function (pageIndex) {
      var firstDisplayingPage = this._firstDisplayingPage,
        pageButtonCount = this.pageButtonCount;

      this.pageIndex = pageIndex;

      if (pageIndex < firstDisplayingPage) {
        this._firstDisplayingPage = pageIndex;
      }

      if (pageIndex > firstDisplayingPage + pageButtonCount - 1) {
        this._firstDisplayingPage = pageIndex - pageButtonCount + 1;
      }

      this._callEventHandler(this.onPageChanged, {
        pageIndex: pageIndex
      });
    },

    _controllerCall: function (method, param, isCanceled, doneCallback) {
      if (isCanceled) {
        return $.Deferred().reject().promise()
      }

      var controller = this._controller;
      if (!controller || !controller[method]) {
        throw Error('controller has no method ' + method)
      }

      return normalizePromise(controller[method](param))
        .done($.proxy(doneCallback, this))
        .fail($.proxy(this._errorHandler, this))
    },

    _errorHandler: function () {
      this._callEventHandler(this.onError, {
        args: $.makeArray(arguments)
      });
    },

    search: function (filter) {
      this._resetSorting();
      this._resetPager();
      return this.loadData(filter)
    },

    loadData: function (filter) {
      filter = filter || (this.filtering ? this.getFilter() : {});

      $.extend(filter, this._loadStrategy.loadParams(), this._sortingParams());

      var args = this._callEventHandler(this.onDataLoading, {
        filter: filter
      });

      return this._controllerCall('loadData', filter, args.cancel, function (loadedData) {
        if (!loadedData) {
          return
        }

        this._loadStrategy.finishLoad(loadedData);

        this._callEventHandler(this.onDataLoaded, {
          data: loadedData
        });
      })
    },

    getFilter: function () {
      var result = {};
      this._eachField(function (field) {
        if (field.filtering) {
          this._setItemFieldValue(result, field, field.filterValue());
        }
      });
      return result
    },

    _sortingParams: function () {
      if (this.sorting && this._sortField) {
        return {
          sortField: this._sortField.name,
          sortOrder: this._sortOrder
        }
      }
      return {}
    },

    getSorting: function () {
      var sortingParams = this._sortingParams();
      return {
        field: sortingParams.sortField,
        order: sortingParams.sortOrder
      }
    },

    editItem: function (item) {
      var $row = this.rowByItem(item);
      if ($row.length) {
        this._editRow($row);
      }
    },

    rowByItem: function (item) {
      if (item.jquery || item.nodeType) {
        return $(item)
      }

      return this._content.find('tr').filter(function () {
        return $.data(this, JSGRID_ROW_DATA_KEY) === item
      })
    },

    _editRow: function ($row) {
      if (!this.editing) {
        return
      }

      var item = $row.data(JSGRID_ROW_DATA_KEY);

      var args = this._callEventHandler(this.onItemEditing, {
        row: $row,
        item: item,
        itemIndex: this._itemIndex(item)
      });

      if (args.cancel) {
        return
      }

      var $editRow = this._createEditRow(item);

      $row.hide();
      $editRow.insertBefore($row);
      $row.data(JSGRID_EDIT_ROW_DATA_KEY, $editRow);

      if (this.resizableFields.use) {
        this._resizableFields.refresh();
      }
    },

    updateItem: function (item, editedItem) {
      if (arguments.length === 1) {
        editedItem = item;
      }

      var $row = this.rowByItem(item);

      if (!editedItem) {
        return
      }

      return this._updateRow($row, editedItem)
    },

    _updateRow: function ($updatingRow, editedItem) {
      var updatingItem = $updatingRow.data(JSGRID_ROW_DATA_KEY),
        updatingItemIndex = this._itemIndex(updatingItem),
        updatedItem = $.extend(true, {}, updatingItem, editedItem);

      var args = this._callEventHandler(this.onItemUpdating, {
        row: $updatingRow,
        item: updatedItem,
        itemIndex: updatingItemIndex,
        previousItem: updatingItem
      });

      return this._controllerCall('updateItem', updatedItem, args.cancel, function (loadedUpdatedItem) {
        var previousItem = $.extend(true, {}, updatingItem);
        updatedItem = loadedUpdatedItem || $.extend(true, updatingItem, editedItem);

        var $updatedRow = this._finishUpdate($updatingRow, updatedItem, updatingItemIndex);

        this._callEventHandler(this.onItemUpdated, {
          row: $updatedRow,
          item: updatedItem,
          itemIndex: updatingItemIndex,
          previousItem: previousItem
        });
      })
    },

    _rowIndex: function (row) {
      return this._content.children().index($(row))
    },

    _itemIndex: function (item) {
      if (this.treeView.use) {
        return item.itemIndex
      } else {
        return $.inArray(item, this.data)
      }
    },

    setFieldValue: function (value) {
      // 임시로 title만 변경되도록 수정
      var field = _.find(this.fields, {name: value.fieldName});
      var filterField = _.filter(this.fields, function (f) {
        if (!_.has(f, 'visible')) {
          return true
        } else {
          if (f.visible) {
            return true
          }
        }
      });

      var fieldThIndex = _.findIndex(filterField, function (filterField) {
        if (!_.has(filterField, 'visible')) {
          if (filterField.name === value.fieldName) {
            return true
          }
        } else {
          if (filterField.visible) {
            if (filterField.name === value.fieldName) {
              return true
            }
          }
        }
      });

      var fieldIndex = _.findIndex(this.fields, function (field) {
        if (field.name === value.fieldName) {
          return true
        }
      });

      if (fieldIndex >= 0) {
        this.fields.splice(fieldIndex, 1, _.assign(field, value.fieldValue));
      }

      if (fieldThIndex >= 0) {
        this._headerGrid.find('th').eq(fieldThIndex).text(value.fieldValue.title);
      }
    },

    _finishUpdate: function ($updatingRow, updatedItem, updatedItemIndex) {
      this.data[updatedItemIndex] = updatedItem;
      var $updatedRow = null;

      if (this.treeView.use) {
        var self = this;
        var root = _.find(this.data, {groupId: updatedItem.groupId});

        var lf = function (child) {
          $.map(child, function (v, i) {
            // root update 포함
            if (v.itemIndex === updatedItemIndex || updatedItem.level === 0) {
              v = updatedItem;
              $updatedRow =
                self._createRow(updatedItem, updatedItemIndex, 'update')
                  .attr('data-rowindex', $updatingRow.data('rowindex')) // row id
                  .attr('data-depthlevel', $updatingRow.data('depthlevel')) // tree depth level
                  .attr('data-groupid', $updatingRow.data('groupid')) // group id
                  .attr('data-parentid', $updatingRow.data('parentid')) // parent id
                  .attr('data-childcount', $updatingRow.data('childcount')); // parent id
              return v
            } else {
              lf(v.children);
            }
          });
        };

        if (root.hasOwnProperty('children')) {
          // root(level = 0)의 자식 데이터가 존재하는 경우
          for (var i = 0; i < root.children.length; i++) {
            lf(root.children);
          }
        } else {
          // root(level = 0)의 자식 데이터가 존재하지 않는 경우
          lf(root);
        }

        var treeOpen = JSON.parse($updatingRow.attr('tree-open'));

        $updatingRow.replaceWith($updatedRow);

        if (treeOpen) {
          $updatedRow.attr('tree-open', false);
        } else {
          $updatedRow.attr('tree-open', true);
        }

        $updatedRow.find('.toggle-triangle-wrap > div').trigger('click.treeView');
      } else {
        $updatedRow = this._createRow(updatedItem, updatedItemIndex);
        $updatingRow.replaceWith($updatedRow);
      }
      return $updatedRow
    },

    deleteItem: function (item) {
      var $row = this.rowByItem(item);

      if (!$row.length) {
        return
      }

      if (this.confirmDeleting && !window.confirm(getOrApply(this.deleteConfirm, this, $row.data(JSGRID_ROW_DATA_KEY)))) {
        return
      }

      return this._deleteRow($row)
    },

    _deleteRow: function ($row) {
      var deletingItem = $row.data(JSGRID_ROW_DATA_KEY),
        deletingItemIndex = this._itemIndex(deletingItem);

      var args = this._callEventHandler(this.onItemDeleting, {
        row: $row,
        item: deletingItem,
        itemIndex: deletingItemIndex
      });

      return this._controllerCall('deleteItem', deletingItem, args.cancel, function () {
        this._loadStrategy.finishDelete(deletingItem, deletingItemIndex);

        this._callEventHandler(this.onItemDeleted, {
          row: $row,
          item: deletingItem,
          itemIndex: deletingItemIndex
        });
      })
    },

    /*
      이름: _setTitleToTemplate
      설명: 템플릿을 사용할 경우 태그의 title에 값이 표시되도록 title 속성을 추가한다.
     */
    _setTitleToTemplate: function _setTitleToTemplate (targetEl, titleValue) {
      if ( titleValue === void 0 ) titleValue = null;

      // 태그를 제거하는 정규식
      var removeTag = /<[^>]*>/gi;

      // JQuery 객체로 변경
      var parentEl = $(targetEl);

      // Child 객체 가져오기
      var childEl = parentEl.children();

      // ChildEl이 없는 경우
      if (childEl.length === 0) {
        // 부모 El에 Title 추가
        parentEl.attr('title', titleValue || parentEl.text().replace(removeTag, ''));
      } else if (childEl.is('ul')) {
        // 하나의 Cell에 여러 값이 들어가는 경우
        childEl.find('li').each(function (index, item) {
          var liTag = $(item);
          liTag.attr('title', liTag.text().replace(removeTag, ''));
        });
      } else {
        // 포맷에 맞지 않거나, Child 태그가 있는 경우
        childEl.attr('title', titleValue || childEl.text().replace(removeTag, ''));
      }
    }
  };
  $.fn.jsGrid = function (config) {
    var args = $.makeArray(arguments),
      methodArgs = args.slice(1),
      result = this;

    this.each(function () {
      var $element = $(this),
        instance = $element.data(JSGRID_DATA_KEY),
        methodResult;

      if (instance) {
        if (typeof config === 'string') {
          methodResult = instance[config].apply(instance, methodArgs);
          if (methodResult !== undefined && methodResult !== instance) {
            result = methodResult;
            return false
          }
        } else {
          instance._detachWindowResizeCallback();
          instance._init(config);
          instance.render();
        }
      } else {
        var gridInstance = new Grid($element, config);
      }
    });

    return result
  };

  var fields = {};

  var setDefaults = function (config) {
    var componentPrototype;

    if ($.isPlainObject(config)) {
      componentPrototype = Grid.prototype;
    } else {
      componentPrototype = fields[config].prototype;
      config = arguments[1] || {};
    }

    $.extend(componentPrototype, config);
  };

  var locales = {};

  var locale = function (lang) {
    var localeConfig = void 0;

    if ($.isPlainObject(lang)) {
      localeConfig = lang;
    } else {
      if (lang === 'ko') {
        localeConfig = ko;
      }

      if (lang === 'en') {
        localeConfig = en;
      }

      if (lang === 'ja') {
        localeConfig = ja;
      }
    }

    if (!localeConfig) {
      throw Error('unknown locale ' + lang)
    }

    setLocale(jsGrid, localeConfig);
  };

  var setLocale = function (obj, localeConfig) {
    $.each(localeConfig, function (field, value) {
      if ($.isPlainObject(value)) {
        setLocale(obj[field] || obj[field[0].toUpperCase() + field.slice(1)], value);
        return
      }

      if (obj.hasOwnProperty(field)) {
        obj[field] = value;
      } else {
        obj.prototype[field] = value;
      }
    });
  };

  window.jsGrid = {
    Grid: Grid,
    fields: fields,
    setDefaults: setDefaults,
    locales: locales,
    locale: locale,
    version: '@VERSION'
  };
}(window, jQuery));

/**
 * ToolTip Utils
 *
 * @since 2018-11-24
 * @author kdydesign.kim
 */

function parsePosition (pos) {
  var parts = pos.split(' ');
  return {vertical: parts[0], horizontal: parts[1]}
}

function position (e) {
  var posx, posy;

  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  }

  if (e.clientX || e.clientY) {
    posx = e.clientX;
    posy = e.clientY;
  } else if (e.pageX || e.pageY) {
    posx = e.pageX - document.body.scrollLeft - document.documentElement.scrollLeft;
    posy = e.pageY - document.body.scrollTop - document.documentElement.scrollTop;
  } else {
    var offset = targetElement(e).getBoundingClientRect();
    posx = ((offset.right - offset.left) / 2) + offset.left;
    posy = ((offset.bottom - offset.top) / 2) + offset.top;
  }

  return {
    top: posy,
    left: posx
  }
}

function targetElement (e) {
  var target;

  if (e.target) {
    target = e.target;
  } else if (e.srcElement) {
    target = e.srcElement;
  }

  // defeat Safari bug
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  return target
}

function getTargetPosition (el) {
  return {
    top: 0,
    center: el.offsetHeight / 2,
    bottom: el.offsetHeight,
    left: 0,
    middle: el.offsetWidth / 2,
    right: el.offsetWidth
  }
}

function setToolTipPosition (ref) {
  var el = ref.el;
  var animate = ref.animate;
  var anchorEl = ref.anchorEl;
  var anchorOrigin = ref.anchorOrigin;
  var selfOrigin = ref.selfOrigin;
  var maxWidth = ref.maxWidth;
  var maxHeight = ref.maxHeight;
  var event = ref.event;
  var anchorClick = ref.anchorClick;
  var touchPosition = ref.touchPosition;
  var offset = ref.offset;
  var touchOffset = ref.touchOffset;
  var cover = ref.cover;

  var anchor;
  el.style.maxHeight = maxHeight || '65vh';
  el.style.maxWidth = '100vw';

  if (event && (!anchorClick || touchPosition)) {
    var ref$1 = position(event);
    var top = ref$1.top;
    var left = ref$1.left;
    anchor = {top: top, left: left, width: 1, height: 1, right: left + 1, center: top, middle: left, bottom: top + 1};
  } else {
    if (touchOffset) {
      var ref$2 = anchorEl.getBoundingClientRect();
      var anchorTop = ref$2.top;
      var anchorLeft = ref$2.left;
      var top$1 = anchorTop + touchOffset.top,
        left$1 = anchorLeft + touchOffset.left;
      anchor = {top: top$1, left: left$1, width: 1, height: 1, right: left$1 + 1, center: top$1, middle: left$1, bottom: top$1 + 1};
    } else {
      anchor = getAnchorPosition(anchorEl, offset);
    }
  }

  var target = getTargetPosition(el);
  var targetPosition = {
    top: anchor[anchorOrigin.vertical] - target[selfOrigin.vertical],
    left: anchor[anchorOrigin.horizontal] - target[selfOrigin.horizontal]
  };

  targetPosition = repositionIfNeeded(anchor, target, selfOrigin, anchorOrigin, targetPosition, cover);

  el.style.top = Math.max(0, targetPosition.top) + 'px';
  el.style.left = Math.max(0, targetPosition.left) + 'px';
  if (targetPosition.maxHeight) {
    el.style.maxHeight = (targetPosition.maxHeight) + "px";
  }
  if (targetPosition.maxWidth) {
    el.style.maxWidth = (targetPosition.maxWidth) + "px";
  }

  if (animate) {
    var directions = targetPosition.top < anchor.top ? ['up', 'down'] : ['down', 'up'];
    el.classList.add(("animate-popup-" + (directions[0])));
    el.classList.remove(("animate-popup-" + (directions[1])));
  }
}

var size;

function getScrollbarWidth () {
  if (size !== undefined) {
    return size
  }

  var
    inner = document.createElement('p'),
    outer = document.createElement('div');

  css$4(inner, {
    width: '100%',
    height: '200px'
  });
  css$4(outer, {
    position: 'absolute',
    top: '0px',
    left: '0px',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;

  if (w1 === w2) {
    w2 = outer.clientWidth;
  }

  outer.remove();
  size = w1 - w2;

  return size
}

function repositionIfNeeded (anchor, target, selfOrigin, anchorOrigin, targetPosition, cover) {
  var margin = getScrollbarWidth();
  var innerHeight = window.innerHeight;
  var innerWidth = window.innerWidth;
  // don't go bellow scrollbars
  innerHeight -= margin;
  innerWidth -= margin;

  // TAMS
  var PAGE_TOP = 0 + 70; // TODO: 추후 vue-table 연동 시 제외 (상단 Top 메뉴 높이 보정, 70px)

  if (targetPosition.top < PAGE_TOP || targetPosition.top + target.bottom > innerHeight) {
    if (selfOrigin.vertical === 'center') {
      targetPosition.top = anchor[selfOrigin.vertical] > innerHeight / 2 ? innerHeight - target.bottom : PAGE_TOP;
      targetPosition.maxHeight = Math.min(target.bottom, innerHeight);
    } else if (anchor[selfOrigin.vertical] > innerHeight / 2) {
      var anchorY = Math.min(innerHeight, anchorOrigin.vertical === 'center' ? anchor.center : (anchorOrigin.vertical === selfOrigin.vertical ? anchor.bottom : anchor.top));
      targetPosition.maxHeight = Math.min(target.bottom, anchorY);
      targetPosition.top = Math.max(PAGE_TOP, anchorY - targetPosition.maxHeight);
    } else {
      targetPosition.top = anchorOrigin.vertical === 'center' ? anchor.center : (anchorOrigin.vertical === selfOrigin.vertical ? anchor.top : anchor.bottom);
      targetPosition.maxHeight = Math.min(target.bottom, innerHeight - targetPosition.top);
    }
  }

  if (targetPosition.left < 0 || targetPosition.left + target.right > innerWidth) {
    targetPosition.maxWidth = Math.min(target.right, innerWidth);
    if (selfOrigin.horizontal === 'middle') {
      targetPosition.left = anchor[selfOrigin.horizontal] > innerWidth / 2 ? innerWidth - target.right : 0;
    } else if (cover) {
      targetPosition.left = targetPosition.left < 0 ? 0 : innerWidth - target.right;
    } else if (anchor[selfOrigin.horizontal] > innerWidth / 2) {
      var anchorY$1 = Math.min(innerWidth, anchorOrigin.horizontal === 'middle' ? anchor.center : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchor.right : anchor.left));
      targetPosition.maxWidth = Math.min(target.right, anchorY$1);
      targetPosition.left = Math.max(0, anchorY$1 - targetPosition.maxWidth);
    } else {
      targetPosition.left = anchorOrigin.horizontal === 'middle' ? anchor.center : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchor.left : anchor.right);
      targetPosition.maxWidth = Math.min(target.right, innerWidth - targetPosition.left);
    }
  }

  return targetPosition
}

function getAnchorPosition (el, offset) {
  var ref = el.getBoundingClientRect();
  var top = ref.top;
  var left = ref.left;
  var right = ref.right;
  var bottom = ref.bottom;
  var a = {
      top: top,
      left: left,
      width: el.offsetWidth,
      height: el.offsetHeight
    };

  if (offset) {
    a.top -= offset[1];
    a.left -= offset[0];
    if (bottom) {
      bottom += offset[1];
    }
    if (right) {
      right += offset[0];
    }
    a.width += offset[0];
    a.height += offset[1];
  }

  a.right = right || a.left + a.width;
  a.bottom = bottom || a.top + a.height;
  a.middle = a.left + ((a.right - a.left) / 2);
  a.center = a.top + ((a.bottom - a.top) / 2);

  return a
}

function css$4 (element, css) {
  var style = element.style;

  Object.keys(css).forEach(function (prop) {
    style[prop] = css[prop];
  });
}

(function (jsGrid, $, undef) {
  function Field (config) {
    $.extend(this, config);
    this.sortingFunc = this._getSortingFunc();
    this.setTimeoutConst = null;
  }

  Field.prototype = {
    name: '',
    title: null,
    css: '',
    align: '',
    width: 100,
    resizable: true,
    visible: true,
    filtering: true,
    inserting: true,
    editing: true,
    sorting: true,
    sorter: 'string',
    headerType: null,
    iconTemplate: null,
    textTemplate: null,
    sortNumber: false,
    tooltip: $.noop(),
    customTooltipStyle: null,
    isTooltipDestroy: false,

    headerTemplate: function () {
      var headerTitle = (this.title === undefined || this.title === null) ? this.name : this.title;

      if (this.hasOwnProperty('header')) {
        if (this.header.type === 'toggle') {
          headerTitle = '';
        }
      }

      return headerTitle
    },

    itemTemplate: function (value, item) {
      return value
    },

    _getSortingFunc: function () {
      var sorter = this.sorter;

      if ($.isFunction(sorter)) {
        return sorter
      }

      if (typeof sorter === 'string') {
        return jsGrid.sortStrategies[sorter]
      }

      throw Error('wrong sorter for the field' + this.name + '!')
    },

    _createToolTip: function (res) {
      var this$1 = this;

      var toolTipWrapper = $('<div>');
      var len = 0, data = void 0;

      // TAMS
      toolTipWrapper.css('text-overflow', 'ellipsis');
      toolTipWrapper.css('overflow', 'hidden');
      toolTipWrapper.css('lineHeight', 'initial'); // TODO: 추후 vue-table 업데이트 시 제외 (임시 스타일)
      // toolTipWrapper.css('white-space', 'nowrap')

      if (_.isArray(res)) {
        len = res.length;
      } else if (_.isPlainObject(res)) {
        len = Object.keys(res).length;
      }

      if (_.isArray(res) || _.isPlainObject(res)) {
        if (res.hasOwnProperty('title')) {
          toolTipWrapper.append(this._setTooltipStyle(res.title).addClass('jsgrid-tooltip-title'));
          toolTipWrapper.append($('<hr>').addClass('jsgrid-tooltip-splitter'));
        }

        for (var j = 0; j < len; j++) {
          if (_.isArray(res)) {
            len = res.length;
            data = res[j];
          } else {
            if (_.isPlainObject(res)) {
              var result = res;

              if (res.hasOwnProperty('body')) {
                result = res.body;
              }

              len = Object.keys(result).length;
              data = result[Object.keys(result)[j]];
            }
          }

          toolTipWrapper.append(this$1._setTooltipStyle(data));

          if (j !== len - 1) {
            toolTipWrapper.append($('<br/>'));
          }
        }
      } else {
        // 2019.02.13 김민수 : Tooltip 커스텀 스타일 함수가 전달된 경우 스타일이 적용되도록 개선 (단일 Tooltip만 가능)
        toolTipWrapper.append(this._setTooltipStyle(res));
      }

      return toolTipWrapper
    },

    _setTooltipStyle: function (tooltipText) {
      /* customTooltipStyle 함수의 리턴값은 객체로 리턴되어야 한다.
          {
            color: 'red',
            fontSize: '14px',
            ...
          }
      */
      var customStyle = {};
      var newTooltipEl = $('<span>').text(tooltipText);

      try {
        if (this.customTooltipStyle) {
          customStyle = this.customTooltipStyle(tooltipText);
          var styleKeys = Object.keys(customStyle);

          for (var i = 0, max = styleKeys.length; i < max; i++) {
            var key = styleKeys[i];
            newTooltipEl.css(key, customStyle[key]);
          }
        }
      } catch (e) {
        console.warn('[DataTable apply tooltip style warn] : ', e);
      }

      return newTooltipEl
    },

    _setToolTipPosition: function (toolTipContainer) {
      if (toolTipContainer[0].parentNode) {
        setToolTipPosition({
          el: toolTipContainer[0],
          animate: true,
          offset: [10, 10],
          anchorEl: toolTipContainer[0].parentNode,
          anchorOrigin: parsePosition('top middle'),
          selfOrigin: parsePosition('bottom middle')
        });
      }
    },

    _renderToolTip: function (opt, rowItem, el, _grid, from, evt) {
      // tooltip (TAMS 수정됨, tooltip: false 명시 시 사용하지 않음)
      if (opt.tooltip !== false) {
        var self = this;
        var toolTipContainer = $('<div>').addClass('q-tooltip animate-popup bs bs-q-tooltip bs-q-tooltip-default animate-popup-up');

        this.isTooltipDestroy = false;

        if (opt.tooltip !== $.noop && opt.tooltip !== void 0) {
          // wheel 사용시 누적 호출 수정
          self._grid._bodyGrid.find('.q-tooltip').remove();

          clearTimeout(self.setTimeoutConst);
          self.setTimeoutConst = null;

          this.setTimeoutConst = setTimeout(function () {
            var result = opt.tooltip(rowItem);

            if (typeof result === 'object' && typeof result.then === 'function') {
              result.then(function (res) {
                if (!self.isTooltipDestroy) {
                  self._grid._bodyGrid.find('.q-tooltip').remove();

                  toolTipContainer.append(self._createToolTip(res));

                  el.append(toolTipContainer);

                  self._setToolTipPosition(toolTipContainer);
                }
              });
            } else {
              if (result) {
                self._grid._bodyGrid.find('.q-tooltip').remove();

                toolTipContainer.append(self._createToolTip(result));
                el.append(toolTipContainer);

                self._setToolTipPosition(toolTipContainer);
              }
            }
          }, 500);
        } else {
          var fieldValue = void 0;

          if (from === 'fixed-list' || from === 'list') {
            fieldValue = rowItem;
          } else {
            fieldValue = $(evt.currentTarget)[0].innerText;
          }

          if (fieldValue) {
            this.setTimeoutConst = setTimeout(function () {
              toolTipContainer.append(self._createToolTip(fieldValue));
              el.append(toolTipContainer);

              self._setToolTipPosition(toolTipContainer);
            }, 500);
          }
        }
      }
    },

    _destroyToolTip: function () {
      this._grid._bodyGrid.find('.q-tooltip').remove();

      clearTimeout(this.setTimeoutConst);
      this.setTimeoutConst = null;
      this.isTooltipDestroy = true;
    }
  };

  jsGrid.Field = Field;
}(jsGrid, jQuery));

/**
 * jsgrid fields resize module
 * @since : 2017-01-12
 * @author : kdydesign
 */
(function (jsGrid, $, undef) {
  var DOCUMENT = $(document); // window object
  var HEAD = $('head'); // head object
  var RESIZE_HANDLER = null; // resize handler object
  var TABLES = {}; // table object
  var ID_SUFFIX = 0; // id count
  var ID = 'id';
  var PX = 'px';
  var SIGNATURE = 'jsgrid-fields-resizer';
  var IE = navigator.userAgent.indexOf('Trident/4.0') > 0; // IE 8
  try {
    // 로컬 파일 시스템으로 실행되었을 때 Firefox 충돌 예외처리
    
  } catch (e) {
    console.error(e);
  }

  /**
   * 필드 리사이즈 생성자
   * @param grid
   * @param config
   * @constructor
   */
  function ResizableFields (grid, config) {
    this._grid = grid;
    var minWidthArr = $.map(grid.fields, function (field) {
      return field.width || 100
    });
    var gridMinWidth = minWidthArr.reduce(function (a, b) { return a + b; }, 0);

    var defaults = {
      resizeMode: grid.resizeMode || 'minFix',                         // 리사이즈 모드 minFix : 그리드 최소 값 고정에 대한 비율, overflow : 최소, 최대값이 없음
      draggingClass: 'jsgrid-handler-dragging',       // 드래그 핸들러 스타일 클래스
      liveDrag: true,                                 // 드래그 타입
      headerOnly: true,                               // 필드 리사이즈 핸들러가 첫번 째 열의 높이와 동일하게 지정
      hoverCursor: 'col-resize',                      // 리사이즈 핸들러 마우스 오버 커서 css style = cursor : {VALUE}
      dragCursor: 'col-resize',                       // 리사이즈 핸들러 dragging 커서 css style = cursor : {VALUE}
      postbackSafe: false,                            // post-back 기능 사용 여부, 사용지 브라우저 session storage에 저장. sessionStorage 지원이 가능한 브라우저를 필요
      flush: false,                                   // session storage에 저장된 value 삭제
      disabledFields: [],                             // 필드 리사이즈 제외 필드
      onDrag: $.noop,                                 // liveDrag가 활성화된 경우, 칼럼 크기 조정 프로세스 중에 실행할 콜백 함수
      onResizeComplete: $.noop,                       // 리사이즈 종료 callback function
      handleTemplate: $.noop,                          // 필드 리사이즈 핸들러 template function
      gridMinWidth: gridMinWidth
      // minWidth: $.map(grid.fields, (field) => { return field.width || 50 })
    };

    var options = $.extend(defaults, grid.resizableFields);

    this._initDisabledResizeFields(config);

    $.extend(true, this, {
      options: options
    });

    this._init(options);
  }

  /**
   * ResizableFields Prototype
   * @type {{
   *  _init: ResizableFields._init, _initDisabledResizeFields: ResizableFields._initDisabledResizeFields,
   *  _destroy: ResizableFields._destroy, _createHandler: ResizableFields._createHandler, _memento: ResizableFields._memento,
   *  _syncHandler: ResizableFields._syncHandler, _syncFields: ResizableFields._syncFields, _applyBounds: ResizableFields._applyBounds,
   *  _onHandlerDrag: ResizableFields._onHandlerDrag, _onHandlerDragOver: ResizableFields._onHandlerDragOver,
   * _onHandlerMouseDown: ResizableFields._onHandlerMouseDown, _onResize: ResizableFields._onResize, refresh: ResizableFields.refresh
   * }}
   */
  ResizableFields.prototype = {

    /**
     * 필드 리사이즈 생성
     * @param options
     * @private
     */
    _init: function (options) {
      // _destroy 호출
      this._destroy();
      this._onResize = _.throttle(this._onResize, 500);
      this._onHandlerDrag = _.throttle(this._onHandlerDrag, 33);

      // 데이터 테이블 객체 가져오기
      // var fullGridWidth = this._grid._container.width() - 12
      var headerGrid = $(this._grid._headerGrid);
      var bodyGrid = $(this._grid._bodyGrid);
      var dummyScroll = $('<div class="jsgrid-dummy-scroll"/>').css({height: '1px', position: 'absolute'});

      // 2019.01.29 김민수 : 지역 변수로 변경
      var headerID = headerGrid.id = headerGrid.attr(ID) || SIGNATURE + ID_SUFFIX++;

      // $(window).on('resize.' + headerID, $.proxy(this, '_onResize'))

      // 데이터 테이블 객체 속성 추가 시작
      headerGrid.opt = options;
      headerGrid.mode = options.resizeMode;
      headerGrid.disabledFields = headerGrid.opt.disabledFields;
      headerGrid.postbackSafe = headerGrid.opt.postbackSafe;

      // if (!headerGrid.is('table') || TABLES[id]) {
      //   return
      // }

      headerGrid.addClass(SIGNATURE).attr(ID, headerID).before('<div class="jsgrid-handler-group"/>');
      bodyGrid.addClass(SIGNATURE).before(dummyScroll);

      headerGrid.handleGrip = [];
      headerGrid.resizeCell = [];
      bodyGrid.resizeCell = [];

      // headerGrid.gridWidth = bodyGrid.gridWidth = headerGrid.width()

      if (headerGrid.mode === 'overflow') {
        headerGrid.gridWidth = bodyGrid.gridWidth = headerGrid.outerWidth();
      } else {
        // headerGrid.gridWidth = bodyGrid.gridWidth = fullGridWidth
        headerGrid.gridWidth = bodyGrid.gridWidth = '100%';
      }
      headerGrid.handleGroup = headerGrid.prev();
      headerGrid.cellSpacing = parseInt(IE ? this._grid._headerGrid.cellSpacing || this._grid._headerGrid.currentStyle.borderSpacing : headerGrid.css('border-spacing')) || 2;
      headerGrid.border = parseInt(IE ? this._grid._headerGrid.border || this._grid._headerGrid.currentStyle.borderLeftWidth : headerGrid.css('border-left-width')) || 1;

      headerGrid.css({width: headerGrid.gridWidth, 'min-width': headerGrid.gridWidth});
      bodyGrid.css({width: headerGrid.gridWidth, 'min-width': headerGrid.gridWidth});
      dummyScroll.css({width: headerGrid.gridWidth, 'min-width': headerGrid.gridWidth});

      // 새롭게 추가된 데이터 테이블 등록
      TABLES[headerID] = {
        grid: this._grid._container,
        header: headerGrid,
        body: bodyGrid,
        scroll: dummyScroll
      };

      // 데이터 테이블 멤버에 객체 초기화
      this._headerResizeGrid = headerGrid;
      this._bodyResizeGrid = bodyGrid;
      this._bodyResizeDummyScroll = dummyScroll;

      this._createHandler(headerGrid);
    },

    /**
     * 필드 별 리사이즈 비활성화 필드 재구성
     * @param config
     * @private
     */
    _initDisabledResizeFields: function (config) {
      var resizableOpt = this._grid.resizableFields;

      if (resizableOpt.disabledFields && config.length > 0) {
        var mergeConfig = $.merge(resizableOpt.disabledFields, config);
        var mergeDisabledFields = [];

        $.each(mergeConfig, function (index, value) {
          if ($.inArray(value, mergeDisabledFields) === -1) {
            mergeDisabledFields.push(value);
          }
        });

        resizableOpt.disabledFields = mergeDisabledFields;
      }
    },

    destroy: function destroy () {
      // 리사이즈 이벤트 제거
      // $(window).off('resize.' + SIGNATURE, $.proxy(this, '_onResize'))

      // TABLES 객체의 Key값 가져오기
      var resizerKeyList = Object.keys(TABLES);

      // TABLES 객체에서 데이터가 null이면 제거
      for (var i = 0; i < resizerKeyList.length; i++) {
        // Resizer 키 값 가져오기
        var resizerKey = resizerKeyList[i];

        // Document에 마운트 되지 않았다면 해당 목록 제거
        if (!document.getElementById(resizerKey)) {
          delete TABLES[resizerKey].header;
          delete TABLES[resizerKey].body;
          delete TABLES[resizerKey].scroll;
          delete TABLES[resizerKey].grid;
          delete TABLES[resizerKey];
          // $(window).off('resize.' + resizerKey, $.proxy(this, '_onResize'))
        }
      }

      // 2019.01.29 김민수 : 실제 Destroy를 호출한 데이터 테이블의 ID 제거
      // for (let j = 0, k = _.get(TABLES, [this._headerResizeGrid.id, 'header', 'handleGrip'], []).length; j < k; j++) {
      //   const grip = _.get(TABLES, [this._headerResizeGrid.id, 'header', 'handleGrip', j])
      //   grip.off()
      // }
      if (TABLES[this._headerResizeGrid.id]) {
        delete TABLES[this._headerResizeGrid.id].header;
        delete TABLES[this._headerResizeGrid.id].body;
        delete TABLES[this._headerResizeGrid.id].scroll;
        delete TABLES[this._headerResizeGrid.id].grid;
        delete TABLES[this._headerResizeGrid.id];
        // $(window).off(`resize.${this._headerResizeGrid.id}`, $.proxy(this, '_onResize'))
      }
    },

    /**
     * 필드 리사이즈 초기화
     * @private
     */
    _destroy: function () {
      var headerGrid = $(this._grid._headerGrid);
      var bodyGrid = $(this._grid._bodyGrid);
      var headerGridWidth = headerGrid.css('width');
      var headerGridMinWidth = headerGrid.css('min-width');

      DOCUMENT.off('mouseup.' + SIGNATURE)
        .off('mousemove.' + SIGNATURE);

      // $(window).off('resize.' + SIGNATURE, $.proxy(this, '_onResize'))

      headerGrid.removeAttr('style');
      // bodyGrid.removeClass(SIGNATURE + ' ' + FLEX_CLASS)

      // TAMS - drag 시 커서 스타일 변경 원복 (Chromium 이외 브라우저 스타일링)
      $('head style[data-table-resizer]').remove();

      this._grid._header.find('.jsgrid-handler-group').remove();
      this._grid._body.find('.jsgrid-dummy-scroll').remove();

      headerGrid.css('width', headerGridWidth)
        .css('min-width', headerGridMinWidth);

      bodyGrid.css('width', headerGridWidth)
        .css('min-width', headerGridMinWidth);

      /*
        2019.01.29 김민수
        해당 내용은 제거되었습니다. (마지막 변경된 Resizer 객체만 선택하여 TABLES에 적용하는 문제가 발생함)
      */
      // $.each($(document).find('div[id*="jsgrid"]'), function (i, v) {
      //   if (_.has(TABLES, `jsgrid-fields-resizer${$(v).attr('id').split('-')[1]}`)) {
      //     TABLES = _.pick(TABLES, `jsgrid-fields-resizer${$(v).attr('id').split('-')[1]}`)
      //   }
      // })

      if (this._bodyResizeDummyScroll) {
        this._bodyResizeDummyScroll.remove();
        this._bodyResizeDummyScroll = void 0;
      }
    },

    /**
     * 리사이징 핸들러 생성
     * @param headerGrid
     * @private
     */
    _createHandler: function (headerGrid) {
      var this$1 = this;

      var bodyGrid = this._bodyResizeGrid;
      var headerTH = headerGrid.find('tr:first > th, > tr:first > th, > tr:first > td, > tr:first > td');
      var bodyGridTh = bodyGrid.find('> tbody > tr:first > th, > tbody > tr:first > td');
      var headerGridRows = headerGrid.find('td, th');
      var dummyHeaderTH = [];

      if (this._grid.grouping) {
        var rowIndex = 0;

        bodyGrid.find('tr').each(function (idx, value) {
          if (!$(value).attr('parent-group')) {
            rowIndex = idx;
            return false
          }
        });

        bodyGridTh = bodyGrid.find('> tbody > tr:eq(' + rowIndex + ') > th, > tbody > tr:eq(' + rowIndex + ') > td');
      }

      var complexRow = headerGrid.find('tr:eq(1)>th, >tr:eq(1)>th, >tr:eq(1)>td, >tr:eq(1)>td');

      headerTH.each(function (idx, value) {
        if ($(value).attr('colspan')) {
          var colspan = $(value).attr('colspan');

          for (var i = 0; i < colspan; i++) {
            if (i === 0 && idx > 0) {
              // 첫번째 컬럼의 border 지정
              // 지정하지 않으면 border의 크기 1px 씩 밀림
              // 이곳에 코드를 fix하지 않으려면
              // .jsgrid-header-row > .jsgrid-header-cell:first-child ... css의 스타일에서 jsgrid-header-row:first-child...로 지정
              $(complexRow[i]).css('border-left', '1px solid #fff');
            }

            if (complexRow.length === i + 1) {
              // 핸들링 크기를 조절하기 위해 마지막 요소에 attribute 지정
              $(complexRow[i]).attr('last-complex-header', true);
            }

            $(complexRow[i]).attr('complex-header', true);

            dummyHeaderTH.push(complexRow[i]);
          }

          complexRow.splice(0, colspan);
        } else {
          dummyHeaderTH.push(value);
        }
      });

      headerTH = $(dummyHeaderTH);
      headerTH = headerTH.filter(':visible');

      headerGrid.colGroup = headerGrid.find('col');
      bodyGrid.colGroup = bodyGrid.find('col');

      headerGrid.colSize = headerTH.length;

      headerTH.each($.proxy(function (idx, valueTH) {
        var fieldsItem = this._grid.fields[idx];
        var headerCell = $(valueTH);
        var bodyCell = $(bodyGridTh[idx]);
        var disabledFields = fieldsItem == null ? false : headerGrid.disabledFields.indexOf(fieldsItem.name) !== -1;
        var grip = $(headerGrid.handleGroup.append('<div class="jsgrid-handler-grip"></div>')[0].lastChild);

        grip.append('<div class="' + SIGNATURE + '"></div>');

        if (!disabledFields) {
          var handleTemplate = headerGrid.opt.handleTemplate;

          if ($.isFunction(handleTemplate)) {
            var cellObj = {
              bodyCell: bodyCell,
              headerCell: headerCell
            };

            grip.append(handleTemplate.call(this, cellObj));
          }
        }

        if (idx === headerGrid.colSize - 1) {
          grip.addClass('jsgrid-handler-lastGroup');
        }

        grip.on('mousedown', $.proxy(this, '_onHandlerMouseDown'));

        if (!disabledFields) {
          grip.removeClass('jsgrid-disabled-grip').on('mousedown', $.proxy(this, '_onHandlerMouseDown'));
        } else {
          grip.addClass('jsgrid-disabled-grip');
        }

        grip.grid = headerGrid;
        grip.cellIdx = idx;
        grip.resizeCell = headerCell;

        headerCell.cellWidth = headerCell.outerWidth();
        headerCell.complexHeader = headerCell.attr('complex-header') === 'true' || false;
        headerCell.lastComplexHeader = headerCell.attr('last-complex-header') === 'true' || false;
        bodyCell.cellWidth = headerCell.width();

        headerGrid.handleGrip.push(grip);
        headerGrid.resizeCell.push(headerCell);
        bodyGrid.resizeCell.push(bodyCell);

        bodyCell.width(headerCell.cellWidth).removeAttr('width');
        headerCell.width(headerCell.cellWidth).removeAttr('width');

        grip.data(SIGNATURE, {
          cellIdx: idx,
          grid: headerGrid.attr(ID),
          last: idx === headerGrid.colSize - 1,
          minWidth: fieldsItem.width
        });
      }, this));

      var headerFullWidth = headerGrid.width();
      for (var j = 0; j < headerGrid.colSize; j++) {
        var hc = headerGrid.resizeCell[j];
        if (headerGrid.mode === 'overflow') {
          headerGrid.colGroup.eq(j).width(hc.cellWidth + PX);
          bodyGrid.colGroup.eq(j).width(hc.cellWidth + PX);
        } else {
          headerGrid.colGroup.eq(j).width(this$1._colSizeToPercentCalc(headerFullWidth, hc.cellWidth));
          bodyGrid.colGroup.eq(j).width(this$1._colSizeToPercentCalc(headerFullWidth, hc.cellWidth));
        }
      }
      // headerGrid.colGroup.removeAttr('width')
      // bodyGrid.colGroup.removeAttr('width')

      headerGridRows.not(headerTH).not('table th, table td').each(function () {
        $(this).removeAttr('width');
      });
      // headerGrid.removeAttr('width').addClass(FLEX_CLASS)
      // bodyGrid.removeAttr('width').addClass(FLEX_CLASS)

      if (headerGrid.opt.hoverCursor !== 'col-resize') {
        $('.jsgrid-handler-grip .jsgrid-fields-resizer').css('cursor', headerGrid.opt.hoverCursor);
      }

      this._syncHandler(headerGrid);
    },

    /**
     * 필드 리사이징 핸들러 동기화
     * @param headerGrid
     * @private
     */
    _colSizeToPercentCalc: function _colSizeToPercentCalc (gridSize, colSize) {
      return (Number(colSize / gridSize) * 100) + '%'
    },
    _syncHandler: function (headerGrid) {
      headerGrid.handleGroup.width(headerGrid.gridWidth);

      for (var i = 0; i < headerGrid.colSize; i++) {
        var headerCell = headerGrid.resizeCell[i];
        var lastComplexHeader = headerCell.lastComplexHeader;
        var handleSize = headerGrid.opt.headerOnly ? headerGrid.resizeCell[i].outerHeight(false) : headerGrid.outerHeight(false);
        var headleMargin = headerGrid.outerHeight() - headerGrid.resizeCell[i].outerHeight() + PX;

        // 가장 마지막과 Complex header의 마지막에는 0 지정
        if (i === headerGrid.colSize - 1 || lastComplexHeader) {
          headleMargin = 0 + PX;
        }

        // Complext header의 마지막의 handle 사이즈는 최대 높이
        if (lastComplexHeader) {
          handleSize = headerGrid.outerHeight() + PX;
        }

        headerGrid.handleGrip[i].css({
          left: headerCell.offset().left - headerGrid.offset().left + headerCell.outerWidth(false) + headerGrid.cellSpacing / 2 + PX,
          height: handleSize,
          marginTop: headleMargin
        });
      }
    },

    /**
     * 필드 사이즈 동기화
     * @param headerGrid
     * @param handlerIdx
     * @param isOver
     * @private
     */
    _syncFields: function (headerGrid, handlerIdx, isOver) {
      var fullGridSize = this._grid._container.width() - 12;
      var headerFullWidth = headerGrid.gridWidth;
      var bodyGrid = this._bodyResizeGrid;
      var dummyScroll = this._bodyResizeDummyScroll;
      var calcDistance = RESIZE_HANDLER.distance - RESIZE_HANDLER.posLeft;
      var prevHeaderCell = headerGrid.resizeCell[handlerIdx],
        prevBodyCell = bodyGrid.resizeCell[handlerIdx];
      var disPrevWidth = prevHeaderCell.cellWidth + calcDistance;
      // var resizeTdIndex = 0

      prevHeaderCell.width(disPrevWidth + PX);

      // virtual scroll로 인해 지워진 DOM 객체의 크기는 찾을 수 없기에 DOM을 재 탐색하여 크기 지정
      // group virtual scroll 일경우 0번째의 TD가 group이기 때문에 N번째로 지정
      // bodyGrid.find('tr').eq(resizeTdIndex).find('td').eq(handlerIdx).width(disPrevWidth + PX)

      // virtual scroll Group 포함할 경우를 위해 resize 될때마다 각 td에 size를 추가
      // if (this._grid.grouping) {
      bodyGrid.find('tr').each(function (idx, value) {
        if (!$(value).attr('parent-group')) {
          $(value).find('td').each(function (idx2, value2) {
            if (idx2 === handlerIdx) {
              $(value2).width(disPrevWidth + PX);
            }
          });
        }
      });
      // } else {
      // bodyGrid.find('tr').eq(resizeTdIndex).find('td').eq(handlerIdx).width(disPrevWidth + PX)
      // }
      if (headerGrid.mode === 'overflow') {
        headerGrid.colGroup.eq(handlerIdx).width(disPrevWidth + PX);
        bodyGrid.colGroup.eq(handlerIdx).width(disPrevWidth + PX);
        if (headerFullWidth + calcDistance < fullGridSize) {
          headerGrid.css({width: fullGridSize, 'min-width': fullGridSize});
          bodyGrid.css({width: fullGridSize, 'min-width': fullGridSize});
          dummyScroll.css({width: fullGridSize, 'min-width': fullGridSize});
        } else {
          headerGrid.css({width: '100%', 'min-width': '100%'});
          bodyGrid.css({width: '100%', 'min-width': '100%'});
          dummyScroll.css({width: '100%', 'min-width': '100%'});
        }
      } else {
        headerGrid.colGroup.eq(handlerIdx).width(this._colSizeToPercentCalc(fullGridSize, disPrevWidth));
        bodyGrid.colGroup.eq(handlerIdx).width(this._colSizeToPercentCalc(fullGridSize, disPrevWidth));
      }

      if (isOver) {
        prevHeaderCell.cellWidth = disPrevWidth;
        prevBodyCell.cellWidth = disPrevWidth;
      }
    },

    /**
     * 모든 열의 너비 업데이트
     * @param headerGrid
     */
    _applyBounds: function (headerGrid, bodyGrid) {
      var this$1 = this;
      if ( bodyGrid === void 0 ) bodyGrid = this._bodyResizeGrid;

      var headerFullWidth = headerGrid.width();
      // var bodyGrid = this._bodyResizeGrid
      // var dummyScroll = this._bodyResizeDummyScroll
      var headerCellWidth = $.map(headerGrid.resizeCell, function (cell) {
        return cell.outerWidth()
      });

      headerGrid.gridWidth = headerGrid.width();
      bodyGrid.gridWidth = headerGrid.width();

      // dummyScroll.width(headerGrid.gridWidth)
      for (var j = 0; j < headerGrid.colSize; j++) {
        var hc = headerGrid.resizeCell[j];
        if (headerGrid.mode === 'overflow') {
          headerGrid.colGroup.eq(j).width(hc.cellWidth + PX);
          bodyGrid.colGroup.eq(j).width(hc.cellWidth + PX);
        } else {
          headerGrid.colGroup.eq(j).width(this$1._colSizeToPercentCalc(headerFullWidth, hc.cellWidth));
          bodyGrid.colGroup.eq(j).width(this$1._colSizeToPercentCalc(headerFullWidth, hc.cellWidth));
        }
      }

      $.each(headerGrid.resizeCell, $.proxy(function (idx, cell) {
        cell.width(headerCellWidth[idx]).cellWidth = headerCellWidth[idx];

        bodyGrid.find('tr').each(function (i, r) {
          var row = $(r);

          $(row.find('td')[idx]).width(headerCellWidth[idx]).cellWidth = headerCellWidth[idx];
        });
      }, this));
    },

    /**
     * 필드 리사이즈 핸들러 drag event
     * @param e
     * @returns {boolean}
     * @private
     */
    _onHandlerDrag: function (e) {
      if (!RESIZE_HANDLER) {
        return
      }
      var fullGridSize = this._grid._container.width() - 12;
      var headerGrid = RESIZE_HANDLER.grid;

      var onDrag = headerGrid.opt.onDrag;
      var oe = e.originalEvent.touches;
      var ox = oe ? oe[0].pageX : e.pageX;
      var calcDistance = ox - RESIZE_HANDLER.ox + RESIZE_HANDLER.posLeft;
      var cellMinWidth = headerGrid.opt.minWidth,
        handlerIdx = RESIZE_HANDLER.cellIdx;
      var calcPosLeft = headerGrid.cellSpacing * 1.5 + cellMinWidth + headerGrid.border;
      var last = handlerIdx === headerGrid.colSize - 1;
      var min = 0,
        max = Infinity;
      if (headerGrid.mode === 'minFix' && (calcDistance - RESIZE_HANDLER.posLeft) > 0 && headerGrid.opt.gridMinWidth > fullGridSize) { return }

      if (handlerIdx) {
        // min = headerGrid.handleGrip[handlerIdx - 1].position().left + headerGrid.cellSpacing + cellMinWidth
        min = headerGrid.handleGrip[handlerIdx - 1].position().left + cellMinWidth;
      } else {
        min = calcPosLeft;
      }

      calcDistance = Math.max(min, Math.min(max, calcDistance));

      RESIZE_HANDLER.distance = calcDistance;
      RESIZE_HANDLER.css('left', calcDistance + PX);

      if (last) {
        var lastHeaderCell = headerGrid.resizeCell[RESIZE_HANDLER.cellIdx];

        RESIZE_HANDLER.cellWidth = lastHeaderCell.cellWidth + calcDistance - RESIZE_HANDLER.posLeft;
      }

      if (headerGrid.opt.liveDrag) {
        if (last) {
          lastHeaderCell.width(RESIZE_HANDLER.cellWidth);
        }

        this._syncFields(headerGrid, handlerIdx);
        this._syncHandler(headerGrid);

        if (onDrag && $.isFunction(onDrag)) {
          e.currentTarget = headerGrid[0];

          onDrag.call(this, e);
        }
      }

      return false
    },

    /**
     * 핸들러 drag event 이 후 mouse up event
     * @param e
     * @private
     */
    _onHandlerDragOver: function (e) {
      DOCUMENT.off('mouseup.' + SIGNATURE)
        .off('mousemove.' + SIGNATURE);

      // TAMS - drag 시 커서 스타일 변경 원복 (Chromium 이외 브라우저 스타일링)
      $('head style[data-table-resizer]').remove();

      if (!RESIZE_HANDLER) {
        return
      }

      RESIZE_HANDLER.removeClass(RESIZE_HANDLER.grid.opt.draggingClass);
      var headerGrid = RESIZE_HANDLER.grid;
      var fullGridSize = this._grid._container.width() - 12;

      if (headerGrid.mode === 'minFix' && (RESIZE_HANDLER.distance - RESIZE_HANDLER.posLeft) > 0 && headerGrid.opt.gridMinWidth > fullGridSize) { return }

      if (!(RESIZE_HANDLER.distance - RESIZE_HANDLER.posLeft === 0)) {
        // var headerGrid = RESIZE_HANDLER.grid
        var onResizeComplete = headerGrid.opt.onResizeComplete;
        var handlerIdx = RESIZE_HANDLER.cellIdx;

        this._syncFields(headerGrid, handlerIdx, true);

        this._applyBounds(headerGrid);
        this._syncHandler(headerGrid);

        if (onResizeComplete && $.isFunction(onResizeComplete)) {
          var resizeGridParam = {
            bodyGrid: this._bodyResizeGrid,
            headerGrid: this._headerResizeGrid
          };

          e.currentTarget = headerGrid[0];

          onResizeComplete.call(this, e, resizeGridParam, this.options);
        }
      }

      RESIZE_HANDLER = null;
    },

    /**
     * 필드 리사이즈 핸드러 mouse down event
     * @param e
     * @returns {boolean}
     * @private
     */
    _onHandlerMouseDown: function (e) {
      var this$1 = this;

      var handlerData = $(e.currentTarget).data(SIGNATURE);
      var headerGrid = TABLES[handlerData.grid].header,
        handler = headerGrid.handleGrip[handlerData.cellIdx];
      var headerFullWidth = headerGrid.width();
      var bodyGrid = this._bodyResizeGrid;
      var oe = e.originalEvent.touches;

      headerGrid.opt.minWidth = parseInt(handlerData.minWidth);

      handler.ox = oe ? oe[0].pageX : e.pageX;
      handler.posLeft = handler.position().left;
      handler.distance = handler.posLeft;

      DOCUMENT.on('mousemove.' + SIGNATURE, $.proxy(this, '_onHandlerDrag'))
        .on('mouseup.' + SIGNATURE, $.proxy(this, '_onHandlerDragOver'));

      // TAMS - drag 시 스타일 추가 (Chromium 이외 브라우저 스타일링)
      if (!$('head style[data-table-resizer]').length) {
        HEAD.append('<style data-table-resizer type=\'text/css\'>*{cursor:' + headerGrid.opt.dragCursor + ' !important}</style>');
      }

      handler.addClass(headerGrid.opt.draggingClass);

      RESIZE_HANDLER = handler;

      // colgroup의 width에 대해서 초기 설정
      for (var j = 0; j < headerGrid.colSize; j++) {
        var hc = headerGrid.resizeCell[j];
        if (headerGrid.mode === 'overflow') {
          headerGrid.colGroup.eq(j).width(hc.cellWidth);
          bodyGrid.colGroup.eq(j).width(hc.cellWidth);
        } else {
          headerGrid.colGroup.eq(j).width(this$1._colSizeToPercentCalc(headerFullWidth, hc.cellWidth));
          bodyGrid.colGroup.eq(j).width(this$1._colSizeToPercentCalc(headerFullWidth, hc.cellWidth));
        }
      }

      if (headerGrid.resizeCell[handlerData.cellIdx].lock) {
        for (var i = 0, headerCell; i < headerGrid.colSize; i++) {
          headerCell = headerGrid.resizeCell[i];
          headerCell.lock = false;
          headerCell.cellWidth = headerCell.outerWidth();
        }
      }

      return false
    },

    /**
     * 브라우저 크기 조절에 따른 필드 리사이드 모듈 동기화
     * option.mode 또는 default option의 resizeMode가 minFix 일 경우 적용
     * @private
     */
    _onResize: function () {
      var this$1 = this;

      for (var headerGrid in TABLES) {
        if (!TABLES.hasOwnProperty(headerGrid) || !this$1._grid._container) { continue }
        if (!TABLES[headerGrid].header || TABLES[headerGrid].header.width() === 0 || this$1._grid._container.width() === 0) { continue }
        var headerGridSelector = TABLES[headerGrid].header;
        var bodyGridSelector = TABLES[headerGrid].body;
        var scrollSelector = TABLES[headerGrid].scroll;
        var fullGridWidth = TABLES[headerGrid].grid.width() - 12;  // 화면에 보이는 table의 width
        var headerFullGridWidth = headerGridSelector.gridWidth;  // 실질적인 table의 width

        var gridWidth = 0;
        if (headerGridSelector.mode === 'overflow') {
          if (headerFullGridWidth <= fullGridWidth) {
            var idx = headerGridSelector.colSize - 1; // 마지막 컬럼 ID
            // fullGridWidth - headerFullGridWidth 만큼의 갭을 마지막 컬럼이 채워줌
            var headerCell = headerGridSelector.resizeCell[idx];
            var bodyCell = bodyGridSelector.resizeCell[idx];
            var gap = fullGridWidth - headerFullGridWidth;
            var disPrevWidth = headerCell.cellWidth + gap;
            headerGridSelector.colGroup.eq(idx).width(disPrevWidth + PX);
            bodyGridSelector.colGroup.eq(idx).width(disPrevWidth + PX);

            headerCell.cellWidth = disPrevWidth;
            bodyCell.cellWidth = disPrevWidth;

            gridWidth = fullGridWidth;
          } else {
            gridWidth = headerFullGridWidth;
          }
        } else { // minFix MODE
          gridWidth = '100%';
        }

        headerGridSelector.css({width: gridWidth, 'min-width': gridWidth});
        bodyGridSelector.css({width: gridWidth, 'min-width': gridWidth});
        scrollSelector.css({width: gridWidth, 'min-width': gridWidth});

        this$1._applyBounds(headerGridSelector, bodyGridSelector);
        this$1._syncHandler(headerGridSelector.addClass(SIGNATURE));
      }
    },

    /**
     * 필드 리사이즈 새로고침
     */
    refresh: function () {
      this._init(this.options);
    }
  };

  jsGrid.ResizableFields = ResizableFields;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  function LoadIndicator (config) {
    this._init(config);
  }

  LoadIndicator.prototype = {

    container: 'body',
    message: 'Loading...',
    shading: true,

    zIndex: 1000,
    shaderClass: 'jsgrid-load-shader',
    loadPanelClass: 'jsgrid-load-panel',

    _init: function (config) {
      $.extend(true, this, config);

      this._initContainer();
      this._initShader();
      this._initLoadPanel();
    },

    _initContainer: function () {
      this._container = $(this.container);
    },

    _initShader: function () {
      if (!this.shading) {
        return
      }

      this._shader = $('<div>').addClass(this.shaderClass)
        .hide()
        .css({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: this.zIndex
        })
        .appendTo(this._container);
    },

    _initLoadPanel: function () {
      this._loadPanel = $('<div>').addClass(this.loadPanelClass)
        .text(this.message)
        .hide()
        .css({
          position: 'absolute',
          top: '50%',
          left: '50%',
          zIndex: this.zIndex
        })
        .appendTo(this._container);
    },

    show: function () {
      var $loadPanel = this._loadPanel.show();

      var actualWidth = $loadPanel.outerWidth();
      var actualHeight = $loadPanel.outerHeight();

      $loadPanel.css({
        marginTop: -actualHeight / 2,
        marginLeft: -actualWidth / 2
      });

      this._shader.show();
    },

    hide: function () {
      this._loadPanel.hide();
      this._shader.hide();
    }

  };

  jsGrid.LoadIndicator = LoadIndicator;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  function VirtualScrollStrategy (grid) {
    this._grid = grid;
  }

  VirtualScrollStrategy.prototype = {
    startPosition: 0,
    endPosition: 0,

    firstDisplayIndex: function () {
      return this.startPosition
    },

    lastDisplayIndex: function () {
      return this.endPosition === 0 ? 1 : this.endPosition
    },

    itemsCount: function () {
      return this._grid.option('data').length
    },

    openPage: function (index) {
      this._grid.refresh();
    },

    loadParams: function () {
      return {}
    },

    destroy: function destroy () {
      this._grid = null;
      this.endPosition = 0;
    },

    sort: function () {
      this._grid._sortData();
      this._grid.refresh(true, 'dataRefresh');
      return $.Deferred().resolve().promise()
    },

    finishLoad: function (loadedData) {
      this._grid.option('data', loadedData);
    },

    finishInsert: function (insertedItem) {
      var grid = this._grid;
      grid.option('data').push(insertedItem);
      grid.refresh();
    },

    finishDelete: function (deletedItem, deletedItemIndex) {
      var grid = this._grid;
      grid.option('data').splice(deletedItemIndex, 1);
      grid.reset();
    }
  };

  // direct loading strategy
  function DirectLoadingStrategy (grid) {
    this._grid = grid;
  }

  DirectLoadingStrategy.prototype = {

    firstDisplayIndex: function () {
      var grid = this._grid;
      return grid.option('paging') ? (grid.option('pageIndex') - 1) * grid.option('pageSize') : 0
    },

    lastDisplayIndex: function () {
      var grid = this._grid;
      var itemsCount = grid.option('data').length;

      if (this._grid.firewall || this._grid.nat) {
        itemsCount = _.filter(grid.option('data'), function (o) { return (o.is_open || o.is_open === void 0) || o.is_group || !_.has(o, 'is_open'); }).length;
      }

      return grid.option('paging')
        ? Math.min(grid.option('pageIndex') * grid.option('pageSize'), itemsCount)
        : itemsCount
    },

    destroy: function destroy () {
      this._grid = null;
    },

    itemsCount: function () {
      return this._grid.option('data').length
    },

    openPage: function (index) {
      this._grid.refresh();
    },

    loadParams: function () {
      return {}
    },

    sort: function () {
      this._grid._sortData();
      // Data-Table header sorting이 되지 않는 문제를 해결하기 위해 this._grid.refresh() 주석 해제
      this._grid.refresh(true, 'dataRefresh');
      return $.Deferred().resolve().promise()
    },

    reset: function () {
      this._grid.refresh();
      return $.Deferred().resolve().promise()
    },

    finishLoad: function (loadedData) {
      this._grid.option('data', loadedData);
    },

    finishInsert: function (insertedItem) {
      var grid = this._grid;
      grid.option('data').push(insertedItem);
      grid.refresh();
    },

    finishDelete: function (deletedItem, deletedItemIndex) {
      var grid = this._grid;
      grid.option('data').splice(deletedItemIndex, 1);
      grid.reset();
    }
  };

  // page in virtual scroll strategy
  function PageVirtualScrolling (grid) {
    this._grid = grid;
  }

  PageVirtualScrolling.prototype = {
    startPosition: 0,
    endPosition: 0,

    firstDisplayIndex: function () {
      var grid = this._grid;

      return (grid.option('pageIndex') - 1) * grid.option('pageSize')
    },

    lastDisplayIndex: function () {
      return this.endPosition === 0 ? 1 : this.endPosition
    },

    destroy: function destroy () {
      this._grid = null;
      this.endPosition = 0;
    },

    itemsCount: function () {
      return this._grid.option('data').length
    },

    openPage: function (index) {
      this._grid.refresh();
    },

    loadParams: function () {
      return {}
    },

    sort: function () {
      this._grid._sortData();
      this._grid.refresh(true, 'dataRefresh');
      return $.Deferred().resolve().promise()
    },

    reset: function () {
      this._grid.refresh();
      return $.Deferred().resolve().promise()
    },

    finishLoad: function (loadedData) {
      this._grid.option('data', loadedData);
    },

    finishInsert: function (insertedItem) {
      var grid = this._grid;
      grid.option('data').push(insertedItem);
      grid.refresh();
    },

    finishDelete: function (deletedItem, deletedItemIndex) {
      var grid = this._grid;
      grid.option('data').splice(deletedItemIndex, 1);
      grid.reset();
    }
  };

  // page loading strategy
  function PageLoadingStrategy (grid) {
    this._grid = grid;
    this._itemsCount = 0;
  }

  PageLoadingStrategy.prototype = {

    firstDisplayIndex: function () {
      return 0
    },

    lastDisplayIndex: function () {
      return this._grid.option('data').length
    },

    itemsCount: function () {
      return this._itemsCount
    },

    openPage: function (index) {
      this._grid.loadData();
    },

    destroy: function destroy () {
      this._grid = null;
      this._itemsCount = null;
    },

    loadParams: function () {
      var grid = this._grid;
      return {
        pageIndex: grid.option('pageIndex'),
        pageSize: grid.option('pageSize')
      }
    },

    reset: function () {
      return this._grid.loadData()
    },

    sort: function () {
      return this._grid.loadData()
    },

    finishLoad: function (loadedData) {
      this._itemsCount = loadedData.itemsCount;
      this._grid.option('data', loadedData.data);
    },

    finishInsert: function (insertedItem) {
      this._grid.search();
    },

    finishDelete: function (deletedItem, deletedItemIndex) {
      this._grid.search();
    }
  };

  jsGrid.loadStrategies = {
    PageVirtualScrolling: PageVirtualScrolling,
    VirtualScrollStrategy: VirtualScrollStrategy,
    DirectLoadingStrategy: DirectLoadingStrategy,
    PageLoadingStrategy: PageLoadingStrategy
  };
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var isDefined = function (val) {
    return typeof (val) !== 'undefined' && val !== null
  };

  var sortStrategies = {
    string: function (str1, str2) {
      if (!isDefined(str1) && !isDefined(str2)) {
        return 0
      }

      if (!isDefined(str1)) {
        return -1
      }

      if (!isDefined(str2)) {
        return 1
      }

      return ('' + str1).localeCompare('' + str2)
    },

    number: function (n1, n2) {
      if (typeof n1 === 'string') {
        // 콤마로 구분한 숫자들이 있을 경우 첫번째 숫자로 비교
        if (n1.indexOf(',') !== -1) {
          n1 = n1.split(',')[0];
        }
        // 범위 형식일 경우 출발지만으로 비교
        if (n1.indexOf('-') !== -1) {
          n1 = n1.split('-')[0];
        }
      }
      if (typeof n2 === 'string') {
        // 콤마로 구분한 숫자들이 있을 경우 첫번째 숫자로 비교
        if (n2.indexOf(',') !== -1) {
          n2 = n2.split(',')[0];
        }
        // 범위 형식일 경우 출발지만으로 비교
        if (n2.indexOf('-') !== -1) {
          n2 = n2.split('-')[0];
        }
      }
      if (isNaN(n1)) {
        return -1
      }
      if (isNaN(n2)) {
        return 1
      }

      return n1 - n2
    },

    date: function (dt1, dt2) {
      return dt1 - dt2
    },

    numberAsString: function (n1, n2) {
      return parseFloat(n1) - parseFloat(n2)
    },

    ip: function (addr1, addr2) {
      if (!isDefined(addr1)) {
        return -1
      }
      if (!isDefined(addr2)) {
        return 1
      }
      if (typeof addr1 === 'object') {
        // ['1.1.1.1'] 같이 리스트 형식일 경우 예외처리
        if (addr1.length === 1) {
          addr1 = addr1[0];
        } else if (addr1.hasOwnProperty('ip_info1')) { // { ip_info1: '', ip_info2: '' } 같이 dictionary 형식일 경우 예외처리
          addr1 = addr1.ip_info1;
        }
      }
      if (typeof addr2 === 'object') {
        if (addr2.length === 1) {
          addr2 = addr2[0];
        } else if (addr2.hasOwnProperty('ip_info1')) {
          addr2 = addr2.ip_info1;
        }
      }
      // 콤마로 구분한 IP들이 있을 경우 첫번째 IP로 비교
      if (addr1.indexOf(',') !== -1) {
        addr1 = addr1.split(',')[0];
      }
      if (addr2.indexOf(',') !== -1) {
        addr2 = addr2.split(',')[0];
      }
      // 범위 형식일 경우 출발지만으로 비교
      if (addr1.indexOf('~') !== -1) {
        addr1 = addr1.split('~')[0];
      }
      if (addr2.indexOf('~') !== -1) {
        addr2 = addr2.split('~')[0];
      }
      // NetMask 부분은 sorting 시 사용하지 않기 때문에 제거
      if (addr1.indexOf('/') !== -1) {
        addr1 = addr1.split('/')[0];
      }
      if (addr2.indexOf('/') !== -1) {
        addr2 = addr2.split('/')[0];
      }
      if (addr1.indexOf(':') !== -1) {
        return ('' + addr1).localeCompare('' + addr2)
      }
      if (addr2.indexOf(':') !== -1) {
        return ('' + addr1).localeCompare('' + addr2)
      }

      var arr1 = addr1.split('.');
      var arr2 = addr2.split('.');

      for (var i = 0; i < arr1.length; i++) {
        if (parseInt(arr1[i]) < parseInt(arr2[i])) {
          return -1
        }
        if (parseInt(arr1[i]) > parseInt(arr2[i])) {
          return 1
        }
      }
      return 0
    }
  };

  jsGrid.sortStrategies = sortStrategies;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  function Validation (config) {
    this._init(config);
  }

  Validation.prototype = {

    _init: function (config) {
      $.extend(true, this, config);
    },

    validate: function (args) {
      var errors = [];

      $.each(this._normalizeRules(args.rules), function (_, rule) {
        if (rule.validator(args.value, args.item, rule.param)) {
          return
        }

        var errorMessage = $.isFunction(rule.message) ? rule.message(args.value, args.item) : rule.message;
        errors.push(errorMessage);
      });

      return errors
    },

    _normalizeRules: function (rules) {
      if (!$.isArray(rules)) {
        rules = [rules];
      }

      return $.map(rules, $.proxy(function (rule) {
        return this._normalizeRule(rule)
      }, this))
    },

    _normalizeRule: function (rule) {
      if (typeof rule === 'string') {
        rule = {validator: rule};
      }

      if ($.isFunction(rule)) {
        rule = {validator: rule};
      }

      if ($.isPlainObject(rule)) {
        rule = $.extend({}, rule);
      } else {
        throw Error('wrong validation config specified')
      }

      if ($.isFunction(rule.validator)) {
        return rule
      }

      return this._applyNamedValidator(rule, rule.validator)
    },

    _applyNamedValidator: function (rule, validatorName) {
      delete rule.validator;

      var validator = validators[validatorName];
      if (!validator) {
        throw Error('unknown validator ' + validatorName)
      }

      if ($.isFunction(validator)) {
        validator = {validator: validator};
      }

      return $.extend({}, validator, rule)
    }
  };

  jsGrid.Validation = Validation;

  var validators = {
    required: {
      message: 'Field is required',
      validator: function (value) {
        return value !== undefined && value !== null && value !== ''
      }
    },

    rangeLength: {
      message: 'Field value length is out of the defined range',
      validator: function (value, _, param) {
        return value.length >= param[0] && value.length <= param[1]
      }
    },

    minLength: {
      message: 'Field value is too short',
      validator: function (value, _, param) {
        return value.length >= param
      }
    },

    maxLength: {
      message: 'Field value is too long',
      validator: function (value, _, param) {
        return value.length <= param
      }
    },

    pattern: {
      message: 'Field value is not matching the defined pattern',
      validator: function (value, _, param) {
        if (typeof param === 'string') {
          param = new RegExp('^(?:' + param + ')$');
        }
        return param.test(value)
      }
    },

    range: {
      message: 'Field value is out of the defined range',
      validator: function (value, _, param) {
        return value >= param[0] && value <= param[1]
      }
    },

    min: {
      message: 'Field value is too small',
      validator: function (value, _, param) {
        return value >= param
      }
    },

    max: {
      message: 'Field value is too large',
      validator: function (value, _, param) {
        return value <= param
      }
    }
  };

  jsGrid.validators = validators;
}(jsGrid, jQuery));

/**
 * jsgrid virtual scroll module
 * @since : 2017-01-25
 * @author : kdydesign
 */

(function (jsGrid, $, undef) {
  var ID_SUFFIX = 0; // virtual scroll container id number
  var HORIZONTAL_SCROLL_TOP = 0;

  /**
   * virtual scroll 생성자
   * @param grid
   * @param config
   * @constructor
   */
  function VirtualScroll (grid, config) {
    this._grid = grid;

    $.extend(true, this, grid.virtualScrolling);
  }

  /**
   *
   * @type {{
   *  totalRows: number, itemHeight: number, screenItemsLen: number, cachedItemsLen: number, lastRepaintY: number,
   *  maxBuffer: number, lastScrolled: number, _initVirtualScroll: VirtualScroll._initVirtualScroll,
   *  _dummyRows: VirtualScroll._dummyRows, _createScrollSector: VirtualScroll._createScrollSector,
   *  _rmNodeInterval: VirtualScroll._rmNodeInterval, _onScroll: VirtualScroll._onScroll,
   *  _renderVirtualNode: VirtualScroll._renderVirtualNode, _reRowSelectionItem: VirtualScroll._reRowSelectionItem
   * }}
   */
  VirtualScroll.prototype = {
    totalRows: 0,              //총 데이터 개수
    itemHeight: 0,             //row의 높이
    screenItemsLen: 0,         //한 화면에 보여질 아이템 수
    cachedItemsLen: 0,         //캐쉬에 보관할 아이템 수
    lastRepaintY: 0,           //마지막 스크롤 위치
    maxBuffer: 0,              //아이템 보관 버퍼 사이즈
    lastScrolled: 0,           //마지막 스크롤 이벤트 종료시간

    /**
     * virtual scroll 초기화
     * @private
     */
    _initVirtualScroll: function (refreshType) {
      this.scrollSector = null;

      this._dummyRows(refreshType);
    },

    /**
     * virtual scroll dummy DOM 생성
     * itemHight 계산을 위해 1 row를 추가하여 hight 저장
     * @returns {VirtualScroll}
     * @private
     */
    _dummyRows: function (refreshType) {
      var grid = this._grid,
        content = grid._content,
        bodyTable = grid._bodyGrid,
        item = grid.data[0];
      var row;

      content.empty();

      if (!grid.data.length) {
        // content.append(grid._createNoDataRow())
        this._resetScrollSector();
        bodyTable.css('margin-top', 0);

        return this
      }

      if (grid.grouping) {
        if (item.is_group) {
          row = grid._createGroupRow(item);
        } else {
          row = grid._createRow(item, 0);
        }
      } else {
        row = grid._createRow(item, 0, 'virtualScrollDummy');
      }

      content.append(row);

      this._createScrollSector(refreshType);
    },

    /**
     * virtual scroll 영역 초기화
     * @private
     */
    _resetScrollSector: function _resetScrollSector () {
      var
        grid = this._grid,
        body = grid._body;

      body.find('[id*="jsgrid-vrscroll-container-"]').remove();
    },

    /**
     * scroller sector 생성
     * DOM 변경시 화면에 보여지는 tbody 영역을 유지
     * @private
     */
    _createScrollSector: function (refreshType) {
      var grid = this._grid,
        body = grid._body,
        data = grid.data;
      var itemHeight = this.itemHeight = grid._content.find('tr').height(),
        totalRows = this.totalRows = data.length,
        scrContainerHeight = itemHeight * totalRows;

      if (this._grid.pageVirtualScrolling) {
        if (totalRows > (this._grid.pageIndex) * this._grid.pageSize) {
          totalRows = this.totalRows = (this._grid.pageIndex) * this._grid.pageSize;
          scrContainerHeight = itemHeight * this._grid.pageSize;
        } else {
          var pageDataLen = (this._grid.pageIndex - 1) * this._grid.pageSize;

          if (totalRows - pageDataLen < this._grid.pageSize && totalRows < pageDataLen) {
            totalRows = this.totalRows = (this._grid.pageIndex) * this._grid.pageSize;
            scrContainerHeight = itemHeight * (totalRows - pageDataLen);
          } else {
            scrContainerHeight = itemHeight * (totalRows - pageDataLen);
          }
        }
      }

      this._resetScrollSector();

      // add scroller container
      var scrollSector = this.scrollSector = $('<div>').attr('id', 'jsgrid-vrscroll-container-' + ID_SUFFIX)
        .css('opacity', 0)
        .css('position', 'absolute')
        .css('top', '0px')
        .css('left', '0px')
        .css('width', '1px')
        .css('height', scrContainerHeight + 'px');

      var gridHeight = ((grid.windowSize ? grid.resizeHeight : grid.height) || '').toString();
      var screenItemLen = this.screenItemsLen = Math.ceil(gridHeight.replace('px', '') / itemHeight) + 1;

      // this.maxBuffer = screenItemLen * itemHeight
      // this.cachedItemsLen = screenItemLen
      // this.cachedItemsLen = screenItemLen * 3
      grid._loadStrategy.endPosition = totalRows >= screenItemLen ? screenItemLen : totalRows;

      body.prepend(scrollSector);
      body.off('scroll.virtualScroll').on('scroll.virtualScroll', $.proxy(this, '_onScroll'));

      this._applyVirtualScrollDOM();

      if (refreshType || this._grid.pageVirtualScrolling) {
        var scrollTop = body.scrollTop();

        // if (body.height() < this.scrollSector[0].scrollHeight) {
        //   let a = body.scrollTop() + (this.itemHeight * this.screenItemsLen)
        //
        //   if (a > this.scrollSector[0].scrollHeight) {
        //     scrollTop = body.scrollTop() + this.itemHeight
        //   }
        // }

        if (scrollTop > scrContainerHeight) {
          scrollTop = scrContainerHeight;
        }

        this._onScroll({
          target: {scrollTop: scrollTop},
          refresh: true
        });

        $(body).scrollTop(scrollTop);
      }

      ID_SUFFIX++;
    },

    destroy: function destroy () {
      this.scrollSector = null;
      this.container = void 0;
      this._grid._body.off('scroll.virtualScroll');
      HORIZONTAL_SCROLL_TOP = 0;
    },

    /**
     * Virtual Scroll refresh
     * @param vsContainerHeight
     */
    refreshVirtualScroll: function (vsContainerHeight) {
      if (this.scrollSector) {
        var grid = this._grid;
        var scrContainerHeight = this.itemHeight * (this.totalRows - vsContainerHeight);

        this.scrollSector.css('height', scrContainerHeight + 'px');
        this._onScroll({target: $(grid._body)[0], refresh: true});
      }
    },

    /**
     * virtual scroll row DOM 생성
     * @private
     */
    _applyVirtualScrollDOM: function () {
      var grid = this._grid;

      // remove dummy DOM
      grid._content.empty();
      grid._refreshRows();
      // this._rmNodeInterval()
    },

    /**
     * 300 ms 단위로 DOM 삭제
     * @private
     */
    // _rmNodeInterval: function () {
    //   var content = this._grid._content
    //
    //   // 기존 타이머에 의존하여 삭제되는 코드
    //   setInterval($.proxy(function () {
    //     if (Date.now() - this.lastScrolled > 100) {
    //       content.children('[data-rm="true"]').detach()
    //     }
    //   }, this), 300)
    // },

    /**
     * Scroll Event
     * @param e
     * @private
     */
    _onScroll: function (e) {
      var currentScrollTop = $(e.target).scrollTop();

      if (HORIZONTAL_SCROLL_TOP !== currentScrollTop || e.refresh) {
        var scrollTop = e.target.scrollTop;

        if (!this.lastRepaintY || Math.abs(scrollTop - this.lastRepaintY) || e.refresh) {
          var first = Math.floor(scrollTop / this.itemHeight);

          first = first < 0 ? 0 : first;

          if (this._grid.pageVirtualScrolling) {
            first = first < 0 ? 0 : first + (this._grid.pageIndex - 1) * this._grid.pageSize;
          }

          this._renderVirtualNode(this._grid._content, first);

          this.lastRepaintY = scrollTop;
          HORIZONTAL_SCROLL_TOP = currentScrollTop;
        }

        // if (!this.lastRepaintY || Math.abs(scrollTop - this.lastRepaintY) > this.maxBuffer || e.refresh) {
        //   var first = parseInt(scrollTop / itemHeight) - this.screenItemsLen
        //   first = first < 0 ? 0 : first
        //
        //   this._renderVirtualNode(grid._content, first)
        //
        //   this.lastRepaintY = scrollTop
        // }

        // this.lastScrolled = Date.now()

        e.preventDefault && e.preventDefault();
      }
    },

    /**
     * Column Resize 재설정
     * 재 생성된 row dom의 column resize를 위해 width style copy
     * @param bodyContent
     * @returns {Array}
     * @private
     */
    _copyRowWidthStyle: function (bodyContent) {
      var bodyTr = bodyContent.find('tr');
      var styleArr = [];
      var resizeTdIndex = 0;

      bodyTr.each(function (idx, value) {
        if (!$(value).attr('parent-group')) {
          resizeTdIndex = idx;
          return false
        }
      });

      var firstEl = bodyTr.eq(resizeTdIndex).find('td');

      firstEl.each(function (idx, value) {
        styleArr.push($(value).attr('style'));
      });

      return {
        bodyTr: bodyTr,
        styleWidth: styleArr
      }
    },

    /**
     * Scroll Event에 따른 Virtual Scroll DOM 렌더링
     * @param bodyContent
     * @param from
     * @private
     */
    _renderVirtualNode: function (bodyContent, from) {
      var this$1 = this;

      var fragment = $(document.createDocumentFragment());
      var grid = this._grid,
        bodyTable = grid._bodyGrid;
      var finalItem = from + this.screenItemsLen;
      var copyObject = this._copyRowWidthStyle(bodyContent);
      var bodyTr = copyObject.bodyTr,
        firstStyleArr = copyObject.styleWidth;
      // var cachedRow = []
      // var isOpenRow = true

      if (finalItem > this.totalRows) {
        finalItem = this.totalRows;
      }

      if (this._grid.pageVirtualScrolling) {
        bodyTable.css('margin-top', Math.abs((this._grid.pageIndex - 1) * this._grid.pageSize - from) * this.itemHeight);
      } else {
        bodyTable.css('margin-top', (from) * this.itemHeight);
      }

      // for (var j = 0, l = bodyContent.children().length; j < l; j++) {
      //   var firstEl = bodyTr.eq(0).find('td')
      //
      //   firstEl.each(function (idx, value) {
      //     firstStyleArr.push($(value).attr('style'))
      //   })
      //
      //   bodyTr.eq(j).css('display', 'none').attr('data-rm', true)
      // }

      for (var j = 0, l = bodyContent.children().length; j < l; j++) {
        // 기존 타이머에 의존하여 삭제되는 코드
        // bodyTr.eq(j).css("display", "none").attr("data-rm", true);

        // 변경 후 display를 숨기지 않고 바로 삭제 후 캐싱
        // cachedRow.push(bodyTr.eq(j).detach())

        // 그냥 삭제
        bodyTr.eq(j).remove();
      }

      for (var i = from; i < finalItem; i++) {
        var item = grid.data[i];
        var row = null;

        // 캐시에 담긴 row가 있을 경우 캐시 사용local
        /* if (cachedRow[i]) {
             var cachedRowIndex = cachedRow[i].attr("id").split('-')[2];

             if (cachedRowIndex == i) {
                 row = cachedRow[i];
             } else {
                 row = grid._createRow(item, i);
             }
         } else {
             row = grid._createRow(item, i);
         } */

        if (item != null) {
          if (grid.grouping) {
            // 기존 데이터에 "is_open" 속성 추가
            // if (!item.hasOwnProperty('is_open')) {
            //   $.extend(item, {
            //     is_open: true
            //   })
            // }
            //
            // if (item.is_group) {
            //   isOpenRow = item.is_open
            //   row = grid._createGroupRow(item, i)
            // } else {
            //   if (isOpenRow) {
            //     row = grid._createRow(item, i).attr('row-seq', item.seq).attr('row-local-seq', localSeq)
            //     localSeq++
            //   }
            // }
          } else {
            row = grid._createRow(item, i);
          }

          if (row) {
            if (!row.attr('parent-group')) {
              row.find('td').each(function (idx, value) {
                $(value).attr('style', firstStyleArr[idx]);
              });
            }

            this$1._reRowSelectionItem(row, i);

            fragment.append(row.attr('data-rowindex', i));
          }
        }
      }

      bodyContent.append(fragment);
    },

    /**
     * 선택된 row 재선택(rowSelection)
     * @param row
     * @param index
     * @private
     */
    _reRowSelectionItem: function (row, index) {
      var grid = this._grid,
        selectedRows = grid.getRowSelectionItem;

      $.each(selectedRows, function (idx, value) {
        var checkIndex = value.itemIndex;

        if (index === checkIndex) {
          row.addClass(grid.selectionRowClass);
        }
      });
    }
  };

  jsGrid.VirtualScroll = VirtualScroll;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var Field = jsGrid.Field;

  function TextField (config) {
    Field.call(this, config);
  }

  TextField.prototype = new Field({

    autosearch: true,
    readOnly: false,

    _createTextBox: function () {
      return $('<input>').attr('type', 'text')
        .prop('readonly', !!this.readOnly)
    }
  });

  jsGrid.fields.text = jsGrid.TextField = TextField;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var TextField = jsGrid.TextField;

  function NumberField (config) {
    TextField.call(this, config);
  }

  NumberField.prototype = new TextField({

    sorter: 'number',
    align: 'right',
    readOnly: false,

    filterValue: function () {
      return this.filterControl.val()
        ? parseInt(this.filterControl.val() || 0, 10)
        : undefined
    },

    insertValue: function () {
      return this.insertControl.val()
        ? parseInt(this.insertControl.val() || 0, 10)
        : undefined
    },

    editValue: function () {
      return this.editControl.val()
        ? parseInt(this.editControl.val() || 0, 10)
        : undefined
    },

    _createTextBox: function () {
      return $('<input>').attr('type', 'number')
        .prop('readonly', !!this.readOnly)
    }
  });

  jsGrid.fields.number = jsGrid.NumberField = NumberField;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var TextField = jsGrid.TextField;

  function IPField (config) {
    TextField.call(this, config);
  }

  IPField.prototype = new TextField({

    sorter: 'ip',
    align: 'left',
    readOnly: false,
    _createTextBox: function () {
      return $('<input>').attr('type', 'ip')
        .prop('readonly', !!this.readOnly)
    }
  });

  jsGrid.fields.ip = jsGrid.IPField = IPField;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var NumberField = jsGrid.NumberField;
  var numberValueType = 'number';
  var stringValueType = 'string';

  function SelectField (config) {
    this.items = [];
    this.selectedIndex = -1;
    this.valueField = '';
    this.textField = '';

    if (config.valueField && config.items.length) {
      var firstItemValue = config.items[0][config.valueField];
      this.valueType = (typeof firstItemValue) === 'string' ? numberValueType : stringValueType;
    }

    this.sorter = this.valueType;

    NumberField.call(this, config);
  }

  SelectField.prototype = new NumberField({

    align: 'center',
    valueType: numberValueType,

    itemTemplate: function (value) {
      var items = this.items,
        valueField = this.valueField,
        textField = this.textField,
        resultItem;

      if (valueField) {
        resultItem = $.grep(items, function (item, index) {
          return item[valueField] === value
        })[0] || {};
      } else {
        resultItem = items[value];
      }

      var result = (textField ? resultItem[textField] : resultItem);

      return (result === undefined || result === null) ? '' : result
    },

    _createSelect: function () {
      var $result = $('<select>'),
        valueField = this.valueField,
        textField = this.textField,
        selectedIndex = this.selectedIndex;

      $.each(this.items, function (index, item) {
        var value = valueField ? item[valueField] : index,
          text = textField ? item[textField] : item;

        var $option = $('<option>')
          .attr('value', value)
          .text(text)
          .appendTo($result);

        $option.prop('selected', (selectedIndex === index));
      });

      $result.prop('disabled', !!this.readOnly);

      return $result
    }
  });

  jsGrid.fields.select = jsGrid.SelectField = SelectField;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var Field = jsGrid.Field;

  function CheckboxField (config) {
    Field.call(this, config);
  }

  CheckboxField.prototype = new Field({
    sorter: 'number',
    align: 'center',
    autosearch: true,

    itemTemplate: function (value) {
      return this._createCheckbox().prop({
        checked: value,
        disabled: false
      })
    },

    _createCheckbox: function () {
      var self = this;
      var grid = self._grid;
      var el = $('<input>')
        .attr('type', 'checkbox')
        .attr('name', this.name)
        .off('click.checkfield')
        .on('click.checkfield', function (e) {
          var checkedChild = grid._content.find('input[type="checkbox"][name="' + this.name + '"]:not(:checked)');
          var headerCheckBox = grid._headerRow.find('input[type="checkbox"][name="' + this.name + '"]');

          if (checkedChild.length > 0 && self.headerType) {
            headerCheckBox.prop({
              checked: false
            });
          }

          if (checkedChild.length === 0 && self.headerType) {
            headerCheckBox.prop({
              checked: true
            });
          }

          e.stopPropagation();
        });

      return el
    }
  });

  jsGrid.fields.checkbox = jsGrid.CheckboxField = CheckboxField;
}(jsGrid, jQuery));

(function (jsGrid, $, undef) {
  var TextField = jsGrid.TextField;

  function TextAreaField (config) {
    TextField.call(this, config);
  }

  TextAreaField.prototype = new TextField({

    insertTemplate: function () {
      if (!this.inserting) {
        return ''
      }

      this.insertControl = this._createTextArea();

      return this.insertControl
    },

    editTemplate: function (value) {
      if (!this.editing) {
        return this.itemTemplate.apply(this, arguments)
      }

      var $result = this.editControl = this._createTextArea();
      $result.val(value);
      return $result
    },

    _createTextArea: function () {
      return $('<textarea>').prop('readonly', !!this.readOnly)
    }
  });

  jsGrid.fields.textarea = jsGrid.TextAreaField = TextAreaField;
}(jsGrid, jQuery));

/**
 * jsgrid virtual list module
 * @since : 2017-01-25
 */

/**
 * virtual scroll core module
 */
(function (jsGrid, $, undef) {
  var CONTAINER_CLASS = 'virtual-scroll-list-container';

  /**
   * virtual scroll list
   * @param grid
   * @param config
   * @constructor
   */
  function VirtualScrollList (grid, rowItem) {
    this._initVirtualScrollList(grid, rowItem);
    this._createVirtualList();
  }

  /**
   * @type {{
   *  rowHeight: number, width: string, viewCount: number, align: string, template: jQuery.noop,
   *  _createVirtualList: VirtualScrollList._createVirtualList, _onScroll: VirtualScrollList._onScroll,
   *  _createRow: VirtualScrollList._createRow, _renderChunk: VirtualScrollList._renderChunk,
   *  _createContainer: VirtualScrollList._createContainer, _createScroller: VirtualScrollList._createScroller
   * }}
   */
  VirtualScrollList.prototype = {
    dataKey: null,                      // 데이터 형태가 객체 일 경우 조회 할 key
    rowHeight: 20,                      // list item 높이
    viewCount: 5,                       // 한 페이지에 보여질 개수
    width: '100%',                      // virtual list container 너비
    align: 'center',                    // text 위치
    template: $.noop,                   // virtual list Template 지정
    listData: [],                       // virtual list data
    dbClick: $.noop,                    // virtual list double click
    height: 0,
    maxBuffer: 0,
    iconTemplate: $.noop,
    tooltip: $.noop,

    /**
     * destroy 함수
     * @private
     */
    destroy: function () {
      $(this.container).off('scroll.virtualList');
      clearInterval(this.removeInterval);
      this.scroller = void 0;
      this.container = void 0;
      this.rmNodeInterval = void 0;
    },
    /**
     * initialize virtual scroll
     * @param grid
     * @param rowItem
     * @private
     */
    _initVirtualScrollList: function (grid, rowItem) {
      this._grid = grid;
      this.listData = grid.data;
      this.rowItem = rowItem;
      this.firewall = grid._grid.firewall;
      this.nat = grid._grid.nat;
      this.virtualOption = grid.virtualOption;
    },

    /**
     * virtual scroll list 생성
     * @private
     */
    _createVirtualList: function () {
      var opts = this.virtualOption;

      if (opts) {
        this.rowHeight = opts.rowHeight || 20;
        this.width = opts.width || '100%';
        this.viewCount = opts.viewCount || 5;
        this.align = opts.align || 'center';
        this.template = opts.template || $.noop;
        this.iconTemplate = opts.iconTemplate || null;
        this.listData = opts.listData || this.listData;
        this.dbClick = opts.dbClick || $.noop;
        this.tooltip = opts.tooltip || $.noop;
        this.dataKey = opts.dataKey || null;
        this.height = opts.height || 0;
      }

      var height = this._computedContainHeight();
      var itemHeight = this.itemHeight = this.rowHeight;

      this.items = this.listData;
      this.totalRows = this.listData && this.listData.length;

      var scroller = this.scroller = this._createScroller(itemHeight * this.totalRows);
      this.container = this._createContainer(this.width, height);
      this.container.append(scroller);

      var margin = this.margin = $('<div>');
      this.container.append($(margin));

      var screenItemsLen = this.screenItemsLen = Math.ceil(this.rowHeight * this.viewCount / itemHeight);
      this.maxBuffer = screenItemsLen * itemHeight;
      this.cachedItemsLen = screenItemsLen * 3;
      this._renderChunk(this.container, 0);

      this.lastScrolled = 0;
      this.removeInterval = void 0;

      var self = this;
      this.rmNodeInterval = function () {
        self.removeInterval = setInterval($.proxy(function () {
          if (Date.now() - self.lastScrolled > 100) {
            $(self.container).children('[data-rm="1"]').remove();
          }
        }, this), 300);
      };

      $(this.container).off('scroll.virtualList').on('scroll.virtualList', $.proxy(this, '_onScroll'));
      this.rmNodeInterval();
    },

    /**
     * Contain Height
     * @returns {string}
     * @private
     */
    _computedContainHeight: function () {
      var height = this.rowHeight * this.viewCount + 'px';

      if (this.height !== 0) {
        height = this.height;
      }

      if (this.listData.length <= 5) {
        height = 'auto';
      }

      return height
    },

    /**
     * scroll event
     * @param e
     * @private
     */
    _onScroll: function (e) {
      e = e || window.event; // ie

      var self = this;
      var lastRepaintY;
      var target = e.target || e.srcElement; // ie
      var scrollTop = target.scrollTop;

      if (!lastRepaintY || Math.abs(scrollTop - lastRepaintY) > this.maxBuffer) {
        var first = parseInt(scrollTop / self.itemHeight) - self.screenItemsLen;

        self._renderChunk(self.container, first < 0 ? 0 : first);
        self.lastRepaintY = scrollTop;
      }

      self.lastScrolled = Date.now();

      e.preventDefault && e.preventDefault();
    },

    /**
     * object data to string data
     * @param value
     * @returns {*}
     * @private
     */
    _catchData: function (value) {
      var data = value;
      var dataKey = this.dataKey;

      if (dataKey.indexOf('.') > -1) {
        dataKey = dataKey.split('.');

        $.each(dataKey, function (idx, key) {
          data = data[key];
        });

        return data
      }

      return value[dataKey]
    },

    /**
     * row 생성
     * @param i
     * @returns {*}
     * @private
     */
    _createRow: function (i) {
      var el = null;
      var self = this;

      if (this.template !== $.noop) {
        var template = this.template;
        el = $(template.call(this, this.items[i]));
      } else {
        var value = this.items[i];
        var textBox = $('<span>').addClass('jsgrid-cell-textbox');
        el = $('<li>');

        if ($.isPlainObject(value)) {
          value = this._catchData(value);
        }

        if (this.iconTemplate) {
          var iconTemplate = this.iconTemplate(value, this.items[i]);
          var iconClassContainer = $('<div>').addClass(iconTemplate.icon);

          value = iconTemplate.text;

          if (iconTemplate.textDecoration) {
            textBox.css('text-decoration', 'line-through');
          }

          el.append(iconClassContainer);
        }

        textBox.data('jsgrid-cell-textbox', this.items[i]).text(value);

        if (this.firewall || this.nat) {
          if (this.rowItem.use === 0) {
            textBox.addClass('disabled');
          }
        }

        el.append(textBox)
          .addClass('jsgrid-extend-list')
          .hover(function () {
              // $(this).addClass('jsgrid-list-selecting')
              var item = self.items[i];

              if (self._grid.tooltip === void 0) {
                item = value;
              }

              self._grid._renderToolTip(self, item, el, self, 'list');
            },
            function () {
              // $(this).removeClass('jsgrid-list-selecting')
              self._grid._destroyToolTip();
            })
          .css('width', '100%')
          .off('click.listselect')
          .on('click.listselect', function (e) {
            // e.stopPropagation()
            //
            // $('.jsgrid-extend-list').removeClass('jsgrid-list-selection')
            // $(this).addClass('jsgrid-list-selection')
          });
      }

      if (this.dbClick) {
        el.on('dblclick', $.proxy(function (e) {
          // this.dbClick({
          //   item: this.items[i],
          //   itemIndex: i,
          //   event: e
          // })
        }, this));
      }

      // if (this.listData.length > 5) {
      //   el.css('position', 'absolute')
      // }
      //
      // el.css('top', (i * this.itemHeight) + 'px')

      el.data('jsgrid-extend-list', this.items[i]);

      return el
    },

    /**
     * virtual scroll list DOM 재 구성
     * @param node
     * @param from
     * @private
     */
    _renderChunk: function (node, from) {
      var this$1 = this;

      var fragment = $(document.createDocumentFragment());
      var finalItem = from + this.cachedItemsLen;

      if (finalItem > this.totalRows) {
        finalItem = this.totalRows;
      }

      $(this.margin).css('margin-top', ((from) * this.itemHeight));

      for (var i = from; i < finalItem; i++) {
        fragment.append(this$1._createRow(i));
      }

      for (var j = 2, l = $(node).children().length; j < l; j++) {
        $(node).children().eq(j).css('display', 'none');
        $(node).children().eq(j).attr('data-rm', '1');
      }

      $(node).append(fragment);

      // $(node).sortable({
      //   containment: null,
      //   connectWith: 'ul',
      //   opacity: 1,
      //   revert: 200,
      //   helper: function (e, ui) {
      //     return ui
      //   },
      //   start: function (e, ui) {
      //   },
      //   stop: function (e, ui) {
      //   }
      // }).disableSelection()
    },

    /**
     * list content container 생성
     * @param width
     * @param height
     * @returns {*|{src, dest}}
     * @private
     */
    _createContainer: function (width, height) {
      var container = $('<ul>')
        .addClass(CONTAINER_CLASS)
        .css('width', width)
        .css('height', height)
        .css('text-align', this.align);

      if (this.listData.length <= 5) {
        container.css('overflow', 'hidden');
      }

      return container
    },

    /**
     * scroll Container 생성
     * @param totalHeight
     * @returns {*|{src, dest}}
     * @private
     */
    _createScroller: function (totalHeight) {
      var scroller = $('<div>').addClass('jsgrid-vs-scroller')
        .css('opacity', 0)
        .css('top', '0px')
        .css('left', '0px')
        .css('width', '1px')
        .css('position', 'absolute')
        .css('height', totalHeight + 'px');

      return scroller
    }
  };

  jsGrid.VirtualScrollList = VirtualScrollList;
}(jsGrid, jQuery));

/**
 * virtual scroll list module
 */
(function (jsGrid, $, undef) {
  var Field = jsGrid.Field;

  /**
   * virtual list field
   * @param config
   * @constructor
   */
  function VirtualListField (config) {
    Field.call(this, config);
  }

  /**
   *
   * @type {*}
   */
  VirtualListField.prototype = new Field({
    itemTemplate: function (value, item) {
      return this._createVirtualListBox(value, item)
    },

    _createVirtualListBox: function (values, item) {
      this.data = values || [];

      return new jsGrid.VirtualScrollList(this, item).container
    }
  });

  jsGrid.fields.list = jsGrid.VirtualListField = VirtualListField;
}(jsGrid, jQuery));

/**
 * jsgrid virtual list module
 * @since : 2017-01-25
 */

/**
 * virtual scroll core module
 */
(function (jsGrid, $, undef) {
  var Field = jsGrid.Field;
  var CONTAINER_CLASS = 'fixed-list-container';

  function FixedListField (config) {
    Field.call(this, config);

    this.viewData = [];
    this.listData = [];
  }

  FixedListField.prototype = new Field({
    dataKey: null,                   // 데이터 형태가 객체 일 경우 조회 할 key
    viewCount: 5,                    // 한 페이지에 보여질 개수
    align: 'left',                   // text 위치
    template: $.noop,                // list Template 지정
    dbClick: $.noop,                 // list double click,
    listDbClick: $.noop,             // virtual list double click
    listTemplate: $.noop,            // virtual list template,
    iconTemplate: null,
    sortable: true,
    event: true,

    itemTemplate: function (value, rowItem) {
      this._setData(value, rowItem);

      return this._createView(rowItem)
    },

    _createView: function (rowItem) {
      var container = this._createContainer();

      return container.append(this._createRow(rowItem))
    },

    _setData: function (value, rowItem) {
      var rValue = [];

      if (_.has(this, 'parseData')) {
        var parseData = this.parseData(value, rowItem);

        if (_.isPlainObject(parseData)) {
          rValue.push(this.parseData(value, rowItem));
        } else {
          rValue = this.parseData(value, rowItem);
        }
      } else {
        rValue = value;
      }

      if (!Array.isArray(rValue)) {
        rValue = [];
      }

      this.data = rValue;
      this.viewData = this.data.slice(0, this.viewCount);
      // this.listData = this.data.slice(this.viewCount, this.data.length + 1)
      this.listData = this.data;
      this.scrollListInstance = void 0;
    },

    _catchData: function (value) {
      var data = value;
      var dataKey = this.dataKey;

      if (dataKey.indexOf('.') > -1) {
        dataKey = dataKey.split('.');

        $.each(dataKey, function (idx, key) {
          data = data[key];
        });

        return data
      }

      return value[dataKey]
    },

    _createContainer: function () {
      var container = $('<div>')
        .addClass(CONTAINER_CLASS)
        .css('overflow', 'hidden')
        .css('width', '100%')
        .css('text-align', this.align);

      return container
    },

    _createListContainer: function () {
      return $('<div>').addClass('jsgrid-fixed-list-container')
    },

    _createRow: function (rowItem) {
      var elements = $([]);
      var ul = $('<ul>');
      var more = $('<span>').addClass('jsgrid-list-more').addClass('jsgrid-list-more-open').data('listData', this.listData);
      var self = this;

      $.each(this.viewData, function (i, viewDataItem) {
        var el;

        if (self.template !== $.noop) {
          el = $(self.template.call(this, viewDataItem));
        } else {
          var value = viewDataItem;
          var textBox = $('<span>').addClass('jsgrid-cell-textbox');

          el = $('<li>');

          if ($.isPlainObject(value)) {
            value = self._catchData(value);
          }

          if (self.iconTemplate) {
            var iconTemplate = self.iconTemplate(self.data, viewDataItem);
            var iconClassContainer = $('<div>').addClass(iconTemplate.icon);

            value = iconTemplate.text;

            if (iconTemplate.textDecoration) {
              textBox.css('text-decoration', 'line-through');
            }

            // TAMS
            if (iconTemplate.color) {
              textBox.css('color', iconTemplate.color);
            }

            el.append(iconClassContainer);
          }

          textBox.data('jsgrid-cell-textbox', viewDataItem).text(value);

          if (self._grid.firewall || self._grid.nat) {
            if (rowItem.use === 0) {
              textBox.addClass('disabled');
            }
          }

          el.append(textBox)
            .addClass('jsgrid-view-list')
            .hover(function () {
              // $(this).addClass('jsgrid-list-selecting')
              var item = viewDataItem;

              if (self.tooltip === void 0) {
                item = value;
              }

              self._renderToolTip(self, item, el, self, 'fixed-list');
            }, function () {
              // $(this).removeClass('jsgrid-list-selecting')
              self._destroyToolTip();
            })
            .off('click.listselect')
            .on('click.listselect', function (e) {
              if (self.event) {
                // e.stopPropagation()

                // $('.jsgrid-view-list').removeClass('jsgrid-list-selection')
                // $(this).addClass('jsgrid-list-selection')
              }
            });
        }

        if (self.dbClick) {
          el.off('dblclick.dbrows').on('dblclick.dbrows', $.proxy(function (e) {
            if (this.event) {
              // e.stopPropagation()
              //
              // this.dbClick({
              //   item: v,
              //   itemIndex: i,
              //   event: e
              // })
            }
          }, self));
        }

        el.data('jsgrid-view-list', viewDataItem);
        elements = elements.add(el);
      });

      more.off('click.fixedmore').on('click.fixedmore', function (e) {
        e.stopPropagation();

        var listData = $(this).data('listData');
        // TAMS - 팝업 창 내 fixedList tooptip 겹침 해결
        self._createList(e, listData, rowItem, more);
        more.addClass('hidden');
      });

      ul.append(elements);

      if (this.data.length > this.viewCount) {
        ul.append($('<li>').addClass('jsgrid-view-list-more').append(more));
      }

      // if (this.sortable) {
      //   ul.sortable({
      //     containment: null,
      //     connectWith: 'ul',
      //     opacity: 1,
      //     revert: 200,
      //     items: '> li:not(:last)',
      //     helper: function (e, ui) {
      //       return ui
      //     },
      //     start: function (e, ui) {
      //     },
      //     stop: function (e, ui) {
      //     }
      //   }).disableSelection()
      // }

      return ul
    },

     // TAMS
    _createList: function (e, listData, rowItem, $more) {
      var listContainer = this._createListContainer();

      this.virtualOption = {
        width: '100%',
        align: 'left',
        viewCount: 5,
        rowHeight: 28, /* TAMS, list height 값 고정 (height: 28px) */
        height: 'calc(100% - 19px)',
        dbClick: this.listDbClick,
        tooltip: this.tooltip,
        listData: listData,
        template: this.listTemplate,
        iconTemplate: this.iconTemplate,
        dataKey: this.dataKey
      };

      var scrollListInstance = this.scrollListInstance = new jsGrid.VirtualScrollList(this, rowItem);

      listContainer.append(scrollListInstance.container).append(this._createClose(this, $more)); // TAMS

      $(e.currentTarget).parent().parent().before(listContainer);

      $(this._grid).off('jsgrid.core.destroy').on('jsgrid.core.destroy', function () {
        $(this._grid).off('jsgrid.core.destroy');
        scrollListInstance.destroy();
      });
    },

    // TAMS
    _createClose: function (self, $more) {
      var close = $('<span>').addClass('jsgrid-list-more').addClass('jsgrid-list-more-close').text(this._grid.i18n_all);

      close.off('click.fixedclose').on('click.fixedclose', function (e) {
        e.stopPropagation();

        if (self.scrollListInstance) {
          self.scrollListInstance.destroy();
          self.scrollListInstance = void 0;
        }
        $(e.currentTarget).parent().eq(0).remove();
        $more.removeClass('hidden'); // TAMS
      });

      return close
    }
  });

  jsGrid.fields.fixed = jsGrid.FixedListField = FixedListField;
}(jsGrid, jQuery));

// import { ENGINE_METHOD_STORE } from 'constants';

/**
 * jsgrid virtual list module
 * @since : 2017-01-25
 */

/**
 * virtual scroll core module
 */
(function (jsGrid, $, undef) {
  var Field = jsGrid.Field;
  var CONTAINER_CLASS = 'fixed-list-container';

  function LinkedTextField (config) {
    Field.call(this, config);

    this.viewData = '';
    // this.listData = []
  }

  LinkedTextField.prototype = new Field({
    align: 'left',                   // text 위치
    template: $.noop,                // list Template 지정
    // dbClick: $.noop,                 // list double click,
    readOnly: false,
    onClick: $.noop,

    itemTemplate: function (value, item) {
      this._setData(value);

      return this._createView()
    },

    _createView: function () {
      var container = this._createContainer();

      return container.append(this._createRow())
    },

    _setData: function (value) {
      this.data = value;
      this.viewData = this.data;
    },

    _createContainer: function () {
      var container = $('<div>')
        .addClass(CONTAINER_CLASS)
        .css('overflow', 'hidden')
        .css('width', '100%')
        .css('text-align', this.align);

      return container
    },

    _createRow: function () {
      var more = $('<span>').addClass('jsgrid-text-btn').text(("" + (this.viewData)));
      var self = this;

      more.off('click').on('click', function (e) {
        e.stopPropagation();

        self.onClick(e);
      });

      return more
    }
  });

  jsGrid.fields.linkedText = jsGrid.LinkedTextField = LinkedTextField;
}(jsGrid, jQuery));

/**
 * BlueMax store 공유 플러그인
 *
 * @since: 2018-11-09
 * @author: kdydesign
 */
var store = {
  __installed: false,
  install: function install (ref) {
    var $q = ref.$q;
    var Vue$$1 = ref.Vue;
    var storeSet = ref.storeSet;

    if (this.__installed) { return }
    this.__installed = true;

    this.set = function (store) {
      if ( store === void 0 ) store = void 0;

      $q['store'] = store;

      if ($q.store) {
        $q.store = store;
      } else {
        Vue$$1.util.defineReactive($q, 'store', store);
      }
    };

    this.set(storeSet);
  }
}

/**
 * utils
 *
 * @since 2018-04-10
 * @author kdydesign.kim
 */

// quasar component data changed
function dataChanged (vue, fieldName, value) {
  vue.$set(vue.field, fieldName, value);
  vue.value = value;

  return value
}

// check complexHader options
function complexHeaderCheck (complexHeader) {
  if ( complexHeader === void 0 ) complexHeader = [];

  return complexHeader.length > 0
}

// generator complex header(multi header)
function generatorComplexHeader (vue) {
  var rowClass = 'jsgrid-header-row',
    mergeHeaderClass = 'jsgrid-merge-header',
    cellClass = 'jsgrid-header-cell jsgrid-align-center jsgrid-text-overflow jsgrid-header-sortable';

  var cpxList = [];

  var result = $('<tr>').addClass(rowClass);
  var childResult = $('<tr>').addClass(rowClass);

  if (_.isArray(vue.complexHeader)) {
    cpxList = vue.complexHeader;
  }

  if (_.isPlainObject(vue.complexHeader)) {
    cpxList.push({
      start: vue.complexHeader.start,
      end: vue.complexHeader.end,
      title: vue.complexHeader.title
    });
  }

  vue.fields.forEach(function (field) {
    field.visible = _.has(field, 'visible') ? field.visible : true;
  });

  // merge header
  vue.fields.forEach(function (field, index) {
    var fieldTitle = field.title;
    var th = null;

    var mergeHeader = _getMergeHeader(cpxList, field, vue);
    var normalHeader = _getNormalHeader(cpxList, field, vue);

    // 병합 부모 헤더
    if (_.isPlainObject(mergeHeader)) {
      fieldTitle = mergeHeader.title;
      th = $('<th>')
        .addClass(cellClass)
        .attr('colspan', mergeHeader.colspan)
        .text(fieldTitle)
        .addClass(mergeHeaderClass)
        .css({'height': '26px'});
    }

    if (!_.some(normalHeader, {name: field.name})) {
      // 기본 헤더 (1행)
      if (field.visible) {
        th = $('<th>').addClass(cellClass).attr('rowspan', 2).css({'height': '52px'});

        if (!field.hasOwnProperty('header')) {
          th.text(fieldTitle);
        } else {
          if (field.header.type === 'toggle') {
            th.append($('<div>').attr('vue-quasar-template', ("headerToggle-" + (field.name))));
          }
        }
      }
    } else {
      // 병합된 자식 헤더 (2행)
      if (field.visible) {
        var childHeader = $('<th>').addClass(cellClass).css({'height': '26px'});

        if (field.hasOwnProperty('header')) {
          if (field.header.type === 'toggle') {
            childHeader.append($('<div>').attr('vue-quasar-template', ("headerToggle-" + (field.name))));
          }
        } else {
          childHeader.text(field.title);
        }

        childResult.append(childHeader);
      }
    }

    result.append(th);
  });

  return result.add(childResult)
}

// merge header
function _getMergeHeader (cpx, field, vue) {
  var result = false;

  cpx.forEach(function (h) {
    var startIdx = _.findIndex(vue.fields, {name: h.start});
    var lastIdx = _.findIndex(vue.fields, {name: h.end});

    if (field.name === h.start) {
      var colSpan = lastIdx - startIdx + 1;

      // visible check
      for (var i = startIdx; i <= lastIdx; i++) {
        if (!vue.fields[i].visible) {
          colSpan -= 1;
        }
      }

      if (colSpan === 0) {
        return false
      }

      result = {
        startIdx: startIdx,
        lastIdx: lastIdx,
        colspan: colSpan,
        title: h.title
      };
    }
  });

  return result
}

//normal header
function _getNormalHeader (cpx, field, vue) {
  var header = [];

  for (var i = 0; i < cpx.length; i++) {
    var startIdx = _.findIndex(vue.fields, {name: cpx[i].start});
    var lastIdx = _.findIndex(vue.fields, {name: cpx[i].end});

    for (var j = startIdx; j <= lastIdx; j++) {
      header.push({
        startIdx: startIdx,
        lastIdx: lastIdx,
        name: vue.fields[j].name
      });
    }
  }

  return header
}

/**
 * DataTable Quasar Component
 * q-select
 *
 * @since 2018-03-22
 * @author kdydesign.kim
 */

function qSelect (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      field: field,
      options: data.options || [],
      value: field[fieldName],
      class: data.class || 'bs bs-q-select',
      toolTip: data.toolTip || '',
      disabled: _.has(data, 'disabled') ? data.disabled : false,
      authForce: data.authForce === true ? data.authForce : false
    },
    methods: methods,
    computed: {
      isDisabled: function isDisabled () {
        if (this.authForce) {
          if (this.disabled) {
            return this.disabled
          }

          return !this.authForce
        }

        return this.disabled
      }
    },
    watch: {
      value: function value (v) {
        this.$set(this.field, fieldName, v);
      }
    },
    render: function render (h) {
      var this$1 = this;

      var childrenComponents = void 0;

      if (this.toolTip) {
        var msg = void 0;

        if (typeof this.toolTip === 'function') {
          msg = this.toolTip(field, field[fieldName]);
        } else {
          msg = this.toolTip;
        }

        childrenComponents = [
          h('q-tooltip', {
            'class': 'bs bs-q-tooltip bs-q-tooltip-default',
            props: {
              anchor: 'top middle',
              self: 'bottom middle',
              offset: [10, 10],
              delay: 500
            }
          }, [
            h('span', msg)
          ])
        ];
      }

      return h('q-select', {
        'class': this.class,
        props: {
          options: this.options,
          value: this.value,
          readonly: this.isDisabled,
          authForce: this.authForce,
          disable: this.isDisabled // TAMS
        },
        attrs: {
          disabled: this.isDisabled
        },
        nativeOn: {
          click: function (event) {
            // event.stopPropagation()
          },
          dblclick: function (event) {
            // event.stopPropagation()
          }
        },
        on: {
          change: function (value) {
            var data = dataChanged(this$1, fieldName, value);

            if (_.has(this$1, 'change')) {
              this$1.change(data, this$1.field);
            }
          },
          input: function (value) {
            var data = dataChanged(this$1, fieldName, value);

            if (_.has(this$1, 'input')) {
              this$1.input(data, this$1.field);
            }
          }
        }
      }, childrenComponents)
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-checkbox
 *
 * @since 2018-03-22
 * @author kdydesign.kim
 */

function qCheckbox (ref, ref$1) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;
  var opts = ref$1.opts;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      data: data,
      field: field,
      label: data.label,
      iconClass: data.iconClass,
      value: data.value === false ? data.value : data.value || field[fieldName],
      disabled: data.disabled === true ? data.disabled : false,
      class: data.class || 'bs bs-q-checkbox bs-q-checkbox-default',
      trueValue: data.trueValue,
      falseValue: data.falseValue,
      authForce: data.authForce === true ? data.authForce : false,
      haForce: data.haForce === true ? data.haForce : false
    },
    computed: {
      isDisabled: function isDisabled () {
        if (this.authForce || this.haForce) {
          if (this.disabled) {
            return this.disabled
          }

          if (this.authForce) {
            return !this.authForce
          }

          if (this.haForce) {
            return !this.haForce
          }
        }

        return this.disabled
      }
    },
    beforeDestroy: function beforeDestroy () {
      var this$1 = this;

      for (var i = 0, l = this.$el.childElementCount; i < l; i++) {
        var node = this$1.$el.children[i];

        for (var j = 0, k = node.childElementCount; j < k; j++) {
          if (node.children[0].childNodes.length > 0) {
            node.children[0].childNodes[0].remove();
          }

          node.children[0].remove();
        }
      }

      this.$el.remove();
    },
    methods: methods,
    watch: {
      value: function value (v) {
        this.$set(this.field, fieldName, v);
      }
    },
    render: function render (h) {
      var this$1 = this;

      var iconRender = [];

      // iconTemplate
      if (_.has(opts, 'iconTemplate')) {
        iconRender.push(
          h('q-icon', {
            class: opts.icon
          })
        );
      }

      return h('q-checkbox', {
          class: this.class,
          attrs: {
            disabled: this.isDisabled
          },
          props: {
            label: this.label,
            value: this.value,
            iconClass: this.iconClass,
            trueValue: this.trueValue,
            falseValue: this.falseValue,
            authForce: this.authForce,
            haForce: this.haForce,
            disable: this.isDisabled
          },
          nativeOn: {
            dblclick: function (evt) {
              evt.stopPropagation();
              evt.preventDefault();
            }
          },
          on: {
            change: function (value) {
              if (this$1.disable) { return }

              var data = dataChanged(this$1, fieldName, value);

              if (_.has(this$1, 'change')) {
                this$1.change(data, this$1.field);
              }
            },
            input: function (value) {
              if (this$1.disabled) { return }

              var data = dataChanged(this$1, fieldName, value);

              if (_.has(this$1, 'input')) {
                this$1.input(data, this$1.field);
              }
            }
          }
        },
        iconRender
      )
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-Btn
 *
 * @since 2018-03-22
 * @author kdydesign.kim
 */

function qBtn (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      authDisable: data.authDisable,
      authForce: data.authForce === true ? data.authForce : false,
      size: data.size || 'md',
      icon: data.icon,
      toolTip: data.toolTip,
      flat: data.flat,
      label: data.label,
      color: data.color || 'primary',
      round: data.round,
      dense: data.dense,
      outline: data.outline,
      align: data.align || 'right',
      disabled: data.disabled === true ? data.disabled : false,
      class: data.class || 'bs bs-q-btn-md',
      iconClass: data.iconClass
    },
    methods: methods,
    computed: {
      chgDis: function chgDis () {
        if (this.authForce === false && this.authDisable) {
          return true
        }

        if (this.disabled) {
          return true
        } else {
          return false
        }
      }
    },
    render: function render (h) {
      var this$1 = this;

      var slotRender = [];

      if (this.icon || this.iconClass) {
        slotRender.push(
          h('q-icon', {
            class: ['bs-q-btn-icon', this.iconClass]
          })
        );
      }

      if (this.toolTip) {
        var msg = void 0;

        if (typeof this.toolTip === 'function') {
          msg = this.toolTip(field, field[fieldName]);
        } else {
          msg = this.toolTip;
        }

        slotRender.push(
          h('q-tooltip', {
            'class': 'bs bs-q-tooltip bs-q-tooltip-default',
            props: {
              anchor: 'top middle',
              self: 'bottom middle',
              offset: [10, 10],
              delay: 500
            }
          }, [
            h('span', msg)
          ])
        );
      }

      return h('q-btn', {
          'class': this.class,
          style: {
            float: this.align + '!important'
          },
          attrs: {
            disabled: this.chgDis
          },
          props: {
            authForce: this.authForce,
            size: this.size,
            icon: this.icon,
            flat: this.flat,
            label: this.label,
            color: this.color,
            round: this.round,
            dense: this.dense,
            outline: this.outline
          },
          on: {
            click: function (event) {
              if (this$1.disabled) { return }

              var data = {
                item: field,
                event: event
              };

              this$1.click(data);

              event.stopPropagation();
            }
          }
        },
        slotRender
      )
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-input
 *
 * @since 2018-03-22
 * @author kdydesign.kim
 */

function qInput (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      type: data.type || 'text', // TAMS - dataTable 패스워드 타입 허용
      name: data.name || templateName,
      field: field,
      value: data.value || field[fieldName],
      class: data.class || 'bs bs-q-input',
      prefix: data.prefix,
      suffix: data.suffix,
      fieldType: data.type,
      validate: data.validate || null,
      clearable: data.clearable,
      maxlength: data.maxlength,
      tooltipMsg: data.tooltipMsg || '',
      disabled: _.has(data, 'disabled') ? data.disabled : false,
      authForce: data.authForce === true ? data.authForce : false
    },
    computed: {
      isDisabled: function isDisabled () {
        if (this.authForce) {
          if (this.disabled) {
            return this.disabled
          }

          return !this.authForce
        }

        return this.disabled
      },
      getFieldName: function getFieldName () {
        return ((this.name) + "_" + (this.field.itemIndex))
      },
      getErrorStyle: function getErrorStyle () {
        // 유효성 검사를 수행하지 않는다면
        if (!this.validate) {
          return false
        } else if (this.validate.scope) {
          // Scope가 있다면 스코프.FieldName으로 errors 객체 검색
          return this.errors.has(((this.validate.scope) + "." + (this.getFieldName)))
        }

        // Scope가 없으면 FieldName만으로 errors 객체 검색
        return this.errors.has(("" + (this.getFieldName)))
      }
    },
    created: function created () {
      // 유효성 검사 적용 - 유효성 검사 모듈인 Vee-validate 인스턴스 초기화
      if (this.validate) {
        this.$validator = this.validate.validator || this.$validator;
      }
    },
    mounted: function mounted () {
      // 참고 - Scope가 파라미터로 들어올경우 요소의 속성값으로 추가한다
      if (this.validate) {
        // Validate Scope 지정
        if (this.validate.scope) {
          this.$el.setAttribute('data-vv-scope', this.validate.scope);

          // 에러백 제거
          this.errors.remove(this.getFieldName, this.validate.scope);
        } else {
          // 에러백 제거
          this.errors.remove(this.getFieldName);
        }
      }
    },
    beforeDestroy: function beforeDestroy () {
      var this$1 = this;

      // 필드가 제거되기 전 Validator에서 확인
      var removeDupField = this.$validator.fields.find({name: this.getFieldName});

      // 필드 제거
      if (removeDupField) {
        removeDupField.destroy();
      }

      for (var i = 0, l = this.$el.childElementCount; i < l; i++) {
        var node = this$1.$el.children[i];

        for (var j = 0, k = node.childElementCount; j < k; j++) {
          node.children[0].remove();
        }
      }

      this.$el.remove();
    },
    methods: methods,
    render: function render (h) {
      var this$1 = this;

      var childrenComponents = void 0;

      if (this.tooltipMsg) {
        var child = [];

        if (typeof this.tooltipMsg === 'function') {
          child.push(h('span', this.tooltipMsg(field, field[fieldName])));
        } else if (_.isArray(this.tooltipMsg)) {
          this.tooltipMsg.forEach(function (msg) {
            child.push(h('span', msg));
          });
        } else {
          child.push(h('span', this.tooltipMsg));
        }

        childrenComponents = [
          h('q-tooltip', {
            'class': 'bs bs-q-tooltip bs-q-tooltip-default',
            props: {
              anchor: 'top middle',
              self: 'bottom middle',
              offset: [10, 10],
              delay: 500
            }
          }, child)
        ];
      }

      return h('q-input',
        {
          ref: this.getFieldName,
          class: [
            this.class,
            {'bs-table-input-clearable': this.clearable}
          ],
          props: {
            type: this.type,
            align: 'left',
            value: this.value,
            error: this.getErrorStyle,
            prefix: this.prefix,
            suffix: this.suffix,
            clearable: this.clearable,
            readonly: this.isDisabled,
            authForce: this.authForce,
            // TAMS
            noPassToggle: true
          },
          attrs: {
            name: this.getFieldName,
            disabled: this.isDisabled,
            maxlength: this.maxlength
          },
          nativeOn: {
            click: function (event) {
              event.stopPropagation();
            }
          },
          directives: [
            {
              name: 'validate',
              value: this.validate ? this.validate.rules : false
            }
          ],
          on: {
            blur: function (evt) {
              if (_.has(this$1, 'blur')) {
                this$1.blur(this$1.field);
              }
            },
            input: function (value) {
              // 데이터 타입에 따라 변환
              var data = '';
              if (this$1.fieldType === 'number') {
                // 정규식으로 숫자를 제외한 모든 문자열 빈문자열로 변환
                var convertValue = value.replace(/[^0-9]/gi, '');

                // 데이터 갱신
                data = dataChanged(this$1, fieldName, Number(convertValue));
              } else {
                data = dataChanged(this$1, fieldName, value);
              }

              // 퀘이사 컴포넌트 내부 모델에 입력
              this$1.$refs[this$1.getFieldName].$data.model = data;

              // Input 호출
              if (_.has(this$1, 'input')) {
                this$1.input(data, this$1.field);
              }
            },
            focus: function (evt) {
              if (_.has(this$1, 'focus')) {
                this$1.focus(this$1.field);
              }
            },
            change: function (value) {
              var data = dataChanged(this$1, fieldName, value);

              if (_.has(this$1, 'change')) {
                this$1.change(data, this$1.field);
              }
            },
            keyup: function (evt) {
              if (_.has(this$1, 'keyup')) {
                this$1.keyup(evt, this$1.field);
              }
            },
            keydown: function (evt) {
              if (_.has(this$1, 'keydown')) {
                this$1.keydown(evt, this$1.field);
              }
            }
          }
        },
        childrenComponents
      )
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-Fieldbtn
 *
 *  @since 2018-04-09
 *  @author dev013
 */

function qFieldbtn (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      field: field,
      type: data.type,
      value: field[fieldName] || '',
      desc: data.desc || [],
      align: data.align || 'right',
      style: data.style || 'bs bs-q-btn-md',
      iconStyle: data.iconStyle || 'icon',
      toolTip: data.toolTip, // TAMS
      class: data.iconClass || null,
      isSetValue: !!data.isSetValue,
      btnClass: data.btnClass || null,
      disabled: data.disabled === true ? data.disabled : false,
      btnProps: data.btnProps || {
        color: 'primary',
        outline: 'outline',
        authForce: this.authForce
      },
      collapsibleToggle: false,
      authForce: data.authForce === true ? data.authForce : false
    },
    computed: {
      toggleClass: function toggleClass () {
        var style = '';
        if (this.type === 'collapsible') {
          style = 'bs bs-q-btn-xs bs-q-btn-icon bs-q-btn-line';
        }

        if (this.type === 'fieldBtn') {
          style = (_.isNull(this.btnClass)) ? this.style : this.btnClass;
        }

        return style
      },
      limitClass: function limitClass () {
        return 'text-limit-line'
      }
    },
    methods: methods,
    watch: {
      value: function value (v) {
        this.$set(this.field, fieldName, v);
      }
    },
    render: function render (h) {
      var this$1 = this;

      var iconRender = [];

      if (this.toolTip) {
        iconRender.push(
          h('q-tooltip', {
            'class': 'bs bs-q-tooltip bs-q-tooltip-default',
            props: {
              anchor: 'top middle',
              self: 'bottom middle',
              offset: [10, 10],
              delay: 500
            }
          }, [
            h('span', this.toolTip)
          ])
        );
      }

      if (this.type === 'collapsible') {
        var toggleClass = this.collapsibleToggle ? 'bs-q-btn-icon-remove-xs' : 'bs-q-btn-icon-add-xs';

        iconRender.push(
          h('q-icon', {
            class: ['bs-q-btn-icon', toggleClass]
          })
        );
      } else if (!_.isNull(this.class)) {
        iconRender.push((this.iconStyle === 'icon') ? h('q-icon', { class: ['bs-q-btn-icon', this.class] }) : h('span', { class: this.class }));
      }
      return h('div',
        [
          h('q-btn', {
              'class': this.toggleClass,
              style: {
                float: this.align + '!important'
              },
              attrs: {
                disabled: this.disabled
              },
              props: this.btnProps,
              on: {
                click: function (event) {
                  this$1.collapsibleToggle = !this$1.collapsibleToggle;

                  var data = {
                    item: this$1.field,
                    target: fieldName,
                    event: event
                  };

                  if (_.has(this$1, 'click') && this$1.type === 'fieldBtn') {
                    var setValue = this$1.click(data);
                    if (this$1.isSetValue) {
                      dataChanged(this$1, fieldName, setValue);
                    }
                  }

                  event.stopPropagation();
                }
              }
            },
            iconRender
          ),
          h('div', this.value),
          this.desc.map(function (p) { return (this$1.collapsibleToggle) ? h(p.id || 'div', this$1.field[p.name]) : ''; })
        ])
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-header-toggle
 *
 * @since 2018-04-10
 * @author kdydesign.kim
 */

function qHeaderToggle (ref, ref$1, applyFunction) {
  var header = ref.header;
  var title = ref.title;
  var name = ref.name;
  var data = ref$1.data;
  var bodyComp = ref$1.bodyComp;

  var vueInstance = new Vue({
    el: ("[vue-quasar-template=\"headerToggle-" + name + "\"]"),
    data: {
      data: data,
      toggle: header.toggle === false ? header.toggle : true,
      toggleItem: header.item,
      button: header.button,
      authForce: header.authForce === true ? header.authForce : false,
      haForce: header.haForce === true ? header.haForce : false,
      disabled: header.disabled === true ? header.disabled : false,
      toggleDisabled: _.has(header, 'toggleDisabled') ? header.toggleDisabled() : false
    },
    methods: header.methods,
    computed: {
      isDisabled: function isDisabled () {
        // TAMS - 미사용
        // if (this.authForce || this.haForce) {
        //   if (this.disabled) {
        //     return this.disabled
        //   }
        //
        //   if (this.authForce) {
        //     return !this.authForce
        //   }
        //
        //   if (this.haForce) {
        //     return !this.haForce
        //   }
        // }

        return this.disabled
      }
    },
    render: function render (h) {
      var this$1 = this;

      var createBtnEl = void 0, createToggleEl = void 0;
      var isUseBtn = false;

      if (this.button) {
        isUseBtn = this.button.use;
      }

      if (isUseBtn) {
        this.$options.methods = _.assign(this.methods, header.button.methods);

        createBtnEl = h('q-btn', {
            class: this.button.class,
            props: {
              size: 'xs',
              align: 'center',
              color: 'dark',
              flat: 'flat',
              authForce: this.authForce,
              haForce: this.haForce,
              disable: this.isDisabled
            },
            on: {
              click: function (event) {
                var data = {
                  fieldName: name,
                  event: event
                };

                this$1.$options.methods.click(data);

                event.stopPropagation();
              }
            }
          },
          [
            h('q-icon', {
              class: ['bs-q-btn-icon', this.button.iconClass]
            })
          ]
        );
      }

      if (this.toggle) {
        createToggleEl = h('q-btn-dropdown', {
          ref: 'headerToggle',
          data: {
            toggleValue: null
          },
          props: {
            class: 'bs bs-q-btn-dropdown-md bs-q-btn-dropdown-flat-type',
            size: 'md',
            color: 'dark',
            flat: 'flat',
            label: title,
            authForce: this.authForce,
            haForce: this.haForce,
            disable: this.isDisabled || this.toggleDisabled
          },
          on: {
            click: function (event) {
              event.stopPropagation();
            }
          }
        }, [
          h('q-list', {
              props: {
                class: 'bs bs-q-list bs-q-list-btn-dropdown',
                link: true
              }
            },
            this.toggleItem.map(function (item) {
              return h('q-item', {
                  nativeOn: {
                    click: function (event) {
                      // TAMS
                      if (item.disabled) {
                        event.preventDefault();
                        return
                      }

                      this$1.$nextTick(function () {
                        if (this$1.change) {
                          this$1.change(item.value);
                        }

                        this$1.$refs.headerToggle.hide();
                      });
                    }
                  }
                },
                [
                  h('q-item-main', {
                    attrs: {
                      disabled: item.disabled // TAMS
                    },
                    props: {
                      label: item.label,
                      disable: item.disabled // TAMS
                    }
                  })
                ])
            }))
        ]);
      } else {
        createToggleEl = h('span', title);
      }

      return h('div', [
        // button
        createBtnEl,

        // dropdown
        createToggleEl
      ])
    }
  });

  return vueInstance
}

/**
 * DataTable Quasar Component
 * q-Group-Btn
 *
 * @since 2018-03-22
 * @author kdydesign.kim
 */

function qGroupBtn (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: "[vue-quasar-template=\"groupBtn\"]",
    data: {
      size: 'sm',
      round: true,
      class: 'bs bs-q-btn-sm bs-q-btn-round-icon',
      iconClass: 'bs-q-btn-round-icon bs-q-btn-round-icon-more-dot',
      authForce: data.authForce === true ? data.authForce : false
    },
    render: function render (h) {
      return h('q-btn', {
          'class': this.class,
          props: {
            size: this.size,
            round: this.round,
            authForce: this.authForce
          },
          on: {
            click: function (event) {
              event.stopPropagation();
            }
          }
        },
        [
          h('span', {
            class: this.iconClass
          })
        ]
      )
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-tree
 *
 * @since 2018-08-31
 * @author mk.ko
 */

function qTree (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      nodes: data.nodes,
      nodeKey: data.nodeKey,
      class: data.class || 'bs bs-q-tree'
    },
    methods: methods,
    render: function render (h) {
      return h('q-tree', {
        'class': this.class,
        props: {
          nodes: this.nodes,
          nodeKey: this.nodeKey
        }
      })
    }
  });

  return vm
}

/**
 * DataTable Quasar Component
 * q-progress
 *
 * @since 2018-08-31
 * @author mk.ko
 */

function qProgress (ref) {
  var data = ref.data;
  var methods = ref.methods;
  var fieldName = ref.fieldName;
  var field = ref.field;
  var templateName = ref.templateName;

  var vm = new Vue({
    el: ("[vue-quasar-template=\"" + templateName + "\"]"),
    data: {
      percentage: data.percentage,
      color: data.color,
      styleColor: data.styleColor,
      stripe: data.stripte,
      animate: data.animate,
      indeterminate: data.indeterminate,
      height: data.height,
      showPercentage: data.showPercentage,
      labelColor: data.labelColor,
      isSupported: _.has(data, 'isSupported') ? data.isSupported : true,
      unsupportedMessage: _.has(data, 'unsupportedMessage') ? data.unsupportedMessage : ''
    },
    methods: methods,
    render: function render (h) {
      if (this.isSupported) {
        return h('div', {
              class: 'jsgrid-cell-progress'
            },
            [
              h('q-progress', {
                props: {
                  percentage: this.percentage,
                  color: this.color,
                  styleColor: this.styleColor,
                  stripe: this.stripte,
                  animate: this.animate,
                  indeterminate: this.indeterminate,
                  height: this.height,
                  showPercentage: this.showPercentage,
                  labelColor: this.labelColor
                }
              }),
              h('q-tooltip', {
                'class': 'bs bs-q-tooltip bs-q-tooltip-default',
                props: {
                  anchor: 'top middle',
                  self: 'bottom middle',
                  offset: [10, 10],
                  delay: 500
                }
              }, [
                h('span', ((data.percentage) + "%"))
              ])
            ]
        )
      } else {
        return h('div', {
          class: 'jsgrid-cell-textbox'
        }, [
          h('span', this.unsupportedMessage),
          h('q-tooltip', {
            'class': 'bs bs-q-tooltip bs-q-tooltip-default',
            props: {
              anchor: 'top middle',
              self: 'bottom middle',
              offset: [10, 10],
              delay: 500
            }
          }, [
            h('span', this.unsupportedMessage)
          ])
        ])
      }
    }
  });

  return vm
}



var Comp = Object.freeze({
	qSelect: qSelect,
	qCheckbox: qCheckbox,
	qBtn: qBtn,
	qInput: qInput,
	qFieldbtn: qFieldbtn,
	qHeaderToggle: qHeaderToggle,
	qGroupBtn: qGroupBtn,
	qTree: qTree,
	qProgress: qProgress
});

var QComp = Comp;

var viewport = function () {
  var
    e = window,
    a = 'inner';

  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }

  return {
    width: e[a + 'Width'],
    height: e[a + 'Height']
  }
};

var idGenerator = function () {
  var timestamp = Date.now().toString();
  var randomInt = Math.floor(Math.random() * (200 - 0 + 1));
  var id = timestamp + randomInt.toString();
  return id
};

var DataTables = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.windowSize || _vm.resizeMode === 'overflow')?_c('q-window-resize-observable',{on:{"resize":_vm.onResize}}):_vm._e(),_vm._v(" "),_c('div',{ref:"dataTable"}),_vm._v(" "),_vm._t("context-menu"),_vm._v(" "),_c('div',{ref:"pager"})],2)},staticRenderFns: [],
  name: 'DataTable',
  props: {
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '100%'
    },
    minHeight: {
      type: [String, Number, Boolean],
      default: 0
    },
    sorting: {
      type: Boolean,
      default: true
    },
    paging: {
      type: Boolean,
      default: false
    },
    selecting: {
      type: Boolean,
      default: true
    },
    autoload: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 15
    },
    pageButtonCount: {
      type: Number,
      default: 5
    },
    pagerFormat: {
      type: String,
      default: 'current page: {pageIndex} &nbsp;&nbsp; {first} {prev} {pages} {next} {last} &nbsp;&nbsp; total pages: {pageCount}'
    },
    pagePrevText: {
      type: String,
      default: '<'
    },
    pageNextText: {
      type: String,
      default: '>'
    },
    pageFirstText: {
      type: String,
      default: '<<'
    },
    pageLastText: {
      type: String,
      default: '>>'
    },
    fields: {
      type: Array,
      default: function () { return []; }
    },
    headerRowRenderer: {
      type: Function,
      default: _.noop()
    },
    groupExpandCallBack: {
      type: Function,
      default: _.noop()
    },
    virtualScrolling: {
      type: Boolean,
      default: false
    },
    pageVirtualScrolling: {
      type: Boolean,
      default: false
    },
    fieldSortable: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, Array, Function],
      default: function () { return []; }
    },
    resizableFields: {
      type: Object,
      default: function default$1 () {
        return {
          use: true,
          liveDrag: true
        }
      }
    },
    rowSortable: {
      type: Boolean,
      default: false
    },
    rowDoubleClick: {
      type: Function,
      default: _.noop()
    },
    rowClick: {
      type: Function,
      default: _.noop()
    },
    cellClick: {
      type: Function,
      default: _.noop()
    },
    rowClicked: {
      type: Function,
      default: _.noop()
    },
    // TAMS 필요 기능
    rowClass: {
      type: Function,
      default: _.noop()
    },
    treeView: {
      type: Object,
      default: function default$2 () {
        return {
          use: false
        }
      }
    },
    grouping: {
      type: Boolean,
      default: false
    },
    autoRender: {
      type: Boolean,
      default: true
    },
    complexHeader: {
      type: [Array, Object],
      default: function () {}
    },
    visibleHeader: {
      type: Boolean,
      default: false
    },
    multiSelection: {
      type: Boolean,
      default: true
    },
    firewall: {
      type: Boolean,
      default: false
    },
    nat: {
      type: Boolean,
      default: false
    },
    firewallGroupEvent: {
      type: Function,
      default: _.noop()
    },
    firewallGroupButton: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dropable: {
      type: Boolean,
      default: false
    },
    rowSortableHandler: {
      type: String,
      default: void 0
    },
    disable: {
      type: Boolean,
      default: false
    },
    objectView: {
      type: Boolean,
      default: false
    },
    rowSortableStop: {
      type: Function,
      default: _.noop()
    },
    storageKey: {
      type: String,
      default: void 0
    },
    cellIconBtn: {
      type: Object,
      default: void 0
    },
    pageMargin: {
      type: Number,
      default: 0
    },
    windowSize: {
      type: Boolean,
      default: false
    },
    loadingPopUp: {
      type: Object
    },
    haForce: {
      type: Boolean,
      default: false
    },
    resizeMode: {
      type: String,
      default: 'minFix' // minFix, overflow
    },
    virtualScrollRefresh: {
      type: Boolean,
      default: false
    },
    // TAMS
    headerSortClick: {
      type: Function,
      default: _.noop()
    },
    onDataLoading: {
      type: Function,
      default: _.noop()
    },
    onDataLoaded: {
      type: Function,
      default: _.noop()
    },
    onRefreshed: {
      type: Function,
      default: _.noop()
    }
  },
  data: function data () {
    return {
      tableId: '',
      bodyComp: [],
      headerComp: [],
      locale: 'ko',
      authDisable: false  // true: 활성화, false: 비활성화
    }
  },
  created: function created () {
    this.tableId = idGenerator();

    if (this.$q.store) {
      // const blueMaxUiData = this.$q.store.state.common.common.uiData
      var blueMaxLocale = this.$q.store.state.common.locale.locale; // TAMS 필요

      // if (blueMaxUiData) {
      //   const
      //     authLevel = blueMaxUiData.user.level,
      //     haMode = blueMaxUiData.ha.mode.toLowerCase()
      //
      //   if (authLevel >= 2) {
      //     this.authDisable = false
      //   } else {
      //     this.authDisable = true
      //   }
      //
      //   // HA 권한 제어(임시)
      //   if (haMode !== 'stand-alone') {
      //     const
      //       haMember = blueMaxUiData.ha.mmbr,
      //       uuid = blueMaxUiData.system.host_uuid,
      //       haState = haMember.find(mmbr => mmbr.mmbr_uuid === uuid).state
      //
      //     if (haState.toLowerCase() === 'backup' && !this.haForce) {
      //       this.authDisable = true
      //     }
      //   } else {
      //     // Stand-ALone
      //     if (authLevel >= 2) {
      //       this.authDisable = false
      //     } else {
      //       this.authDisable = true
      //     }
      //   }
      // }

      this.setLocale(blueMaxLocale);
    } else {
      this.setLocale('ko');
    }

    if (this.autoRender) {
      //multi header
      if (complexHeaderCheck(this.complexHeader)) {
        this.setComplexHeader();
      }
    }
  },
  mounted: function mounted () {
    if (this.autoRender) {
      this.render();
    }
  },
  beforeDestroy: function beforeDestroy () {
    this.initDataTable();
    this.destroy();
  },
  methods: {
    setLocale: function setLocale (locale) {
      this.locale = locale;

      jsGrid.locale(locale);
    },
    onResize: function onResize (size) {
      if (this.target) {
        if (this.resizeMode === 'overflow') {
          this.target.jsGrid('option', 'resizeOverflow', '');
        }
        if (this.windowSize) {
          var windowSize = size.height - this.pageMargin;

          if (size.height <= 600 && this.minHeight !== false) {
            var minSize = this.target.jsGrid('option', 'height');

            if (this.virtualScrollRefresh) {
              this.target.jsGrid('option', 'vsRefreshHeight', {minSize: minSize, refreshType: true});
            } else {
              this.target.jsGrid('option', 'height', minSize);
            }
          } else {
            if (this.virtualScrollRefresh) {
              this.target.jsGrid('option', 'vsRefreshHeight', {minSize: (windowSize + "px"), refreshType: true});
            } else {
              this.target.jsGrid('option', 'height', (windowSize + "px"));
            }
          }
        }
      }
    },
    setComplexHeader: function setComplexHeader () {
      var this$1 = this;

      var complexRender = function () { return generatorComplexHeader(this$1); };

      _.assign(this.$props, {
        complexRowRenderer: complexRender
      });

      complexRender = void 0;
    },
    // Create quasar component fields
    createQuasarCompFields: function createQuasarCompFields (fields) {
      var this$1 = this;

      _.map(fields || this.fields, function (o) {
        if (o.type === 'quasar' || o.type === 'quasarHeader') {
          if (_.has(o, 'itemTemplate') && o.type === 'quasar') {
            // quasar - itemTemplate
            o.quasarItemTemplate = function (item, field, fieldName, qResource) {
              _.forEach(this$1.bodyComp, function (comp) {
                var key = _.keys(comp.component)[0];

                if (comp.component[key]) {
                  comp.component[key].$destroy();
                  comp.component[key] = void 0;
                }
              });

              this$1.bodyComp = [];

              if (qResource) {
                var renderOpts = qResource;
                var renderOptsParseArray = [];

                if (_.isArray(renderOpts)) {
                  renderOptsParseArray = renderOpts;
                } else {
                  renderOptsParseArray.push(renderOpts);
                }

                renderOptsParseArray.forEach(function (opt, i) {
                  var template = opt.template;
                  var renderParam = {
                    item: item,
                    field: field,
                    fieldName: fieldName,
                    templateName: ((this$1.tableId) + "_" + fieldName + "_" + i + "_" + (field._itemKey)),
                    authDisable: this$1.authDisable
                  };

                  this$1.$nextTick(function () {
                    if ($('div[vue-quasar-template="' + "" + (renderParam.templateName) + '"]').length > 0) {
                      var applyFunction = _.camelCase(template);
                      var obj = {};

                      obj[applyFunction] = QComp[applyFunction](_.assign(opt, renderParam), {opts: o});

                      this$1.bodyComp.push({
                        fieldName: (fieldName + "_" + i),
                        itemIndex: field.itemIndex,
                        component: obj
                      });
                    }
                  });
                });
              }

              o.quasarItemTemplate = void 0;
            };
          }

          if (_.has(o, 'header')) {
            // quasar - headerTemplate
            if (o.header.type === 'toggle') {
              this$1.$nextTick(function () {
                if ($('div[vue-quasar-template="' + "headerToggle-" + (o.name) + '"]').length > 0) {
                  var applyFunction = _.camelCase(o.header.template);

                  this$1.headerComp.push(QComp.qHeaderToggle(o, this$1, applyFunction));
                }
              });
            }
          }
        }
      });
    },
    createQuasarGroupSetBtn: function createQuasarGroupSetBtn () {
      this.$nextTick(function () {
        QComp.qGroupBtn();
      });
    },
    openPage: function openPage (pageIndex) {
      if (this.target) {
        this.target.jsGrid('openPage', pageIndex);
      }
    },
    render: function render () {
      var this$1 = this;

      this.createQuasarCompFields();

      if (!this.autoRender) {
        //multi header
        if (complexHeaderCheck(this.complexHeader)) {
          this.setComplexHeader();
        }
      }

      if (this.windowSize) {
        _.assign(this.$props, {
          resizeHeight: ((viewport().height - this.pageMargin) + "px")
        });
      }

      _.assign(this.$props, {
        pagerContainer: this.$refs.pager,
        authDisable: this.authDisable
      });

      if (!_.isArray(this.data)) {
        _.assign(this.$props, {
          controller: this.data
        });
      } else {
        _.assign(this.$props, {
          data: this.data
        });
      }

      this.destroy();
      this.$props.tableId = this.tableId;

      this.target = $(this.$refs.dataTable).jsGrid(this.$props);

      if (!this.autoRender) {
        setTimeout(function () {
          // 팝업에서 사용할 경우 팝업 trasition으로 인해 0.2초 딜레이
          if (this$1.target) {
            this$1.target.jsGrid('_createRenderResizableFields');
          }
        }, 200);
      }
    },
    destroy: function destroy () {
      if (this.target) {
        this.target.jsGrid('destroy');
        delete this.target;

        this.target = void 0;
      }
    },
    jsGridExec: function jsGridExec (p1, p2, p3, p4) {
      if (this.target) {
        if (p4 !== undefined && p4 !== null) {
          return this.target.jsGrid(p1, p2, p3, p4)
        }
        if (p3 !== undefined && p3 !== null) {
          return this.target.jsGrid(p1, p2, p3)
        }
        if (p2 !== undefined && p3 !== null) {
          return this.target.jsGrid(p1, p2)
        }
        if (p1) {
          return this.target.jsGrid(p1)
        }
        return 'parameter error'
      }
    },
    initDataTable: function initDataTable () {
      _.forEach(this.bodyComp, function (comp) {
        var key = _.keys(comp.component)[0];

        if (comp.component[key]) {
          comp.component[key].$destroy();
          comp.component[key] = void 0;
        }
      });

      _.forEach(this.headerComp, function (comp) {
        if (comp) {
          comp.$destroy();
        }
      });

      this.bodyComp = [];
      this.headerComp = [];
    },
    changeFieldsAttr: function changeFieldsAttr (fieldName, fieldValue) {
      if (this.target) {
        this.target.jsGrid('option', 'changeFieldValue', {
          fieldName: fieldName,
          fieldValue: fieldValue
        });
      }
    },
    changeFields: function changeFields (fields) {
      this.initDataTable();
      this.createQuasarCompFields(fields);

      if (this.target) {
        this.target.jsGrid('option', 'fields', fields);
      }
    }
  },
  watch: {
    disable: function disable (isDisable) {
      this.target.data('JSGrid').disable = isDisable;
    },
    data: function data (v) {
      // 데이터 갱신 전 메모리 정리
      _.forEach(this.bodyComp, function (comp) {
        var key = _.keys(comp.component)[0];

        if (comp.component[key]) {
          comp.component[key].$destroy();
          comp.component[key] = void 0;
        }
      });

      // 데이터 갱신
      if (this.target) {
        this.target.jsGrid('option', 'data', v);
      }
    },
    // TODO: TAMS 임시 해제 (disabled 방안 필요)
    fields: {
      handler: function handler (after, before) {
        if (after !== before) {
          // 데이터 갱신 전 메모리 정리
          this.initDataTable();
          this.createQuasarCompFields();

          if (this.target) {
            this.target.jsGrid('option', 'fields', after);
            this.target.jsGrid('refresh');
          }
        }
      },
      deep: true
    },
    height: function height (value) {
      if (this.target) {
        this.target.jsGrid('option', 'height', value);
      }
    },
    pageSize: function pageSize (value) {
      if (this.target) {
        this.target.jsGrid('refreshPageSize', value);
      }
    }
  }
}

/**
 * DataTable plugin install module
 *
 * @since: 2018-11-20
 * @author: kdydesign
 */

function install (_Vue, opts) {
  if ( opts === void 0 ) opts = {};

  if (this.__installed) {
    return
  }
  this.__installed = true;

  var $q = {};

  /**
   * BlueMAx Store 공유 모듈
   * @since: 2018-11-20
   * @author: kdydesign
   */
  store.install({$q: $q, Vue: _Vue, storeSet: opts.store});

  _Vue.component(DataTables.name, DataTables);

  _Vue.prototype.$q = $q;
}

// css
// jsgrid module
// fields
// vue plugin module
var index = {
  install: install,
  store: store
}

export default index;
